// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/roboto.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/anton.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/bahnschrift.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/brunoace.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/metamorphous.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/overpass.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "Anton";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "Bahnschrift";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "BrunoAce";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "Metamorphous";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "Overpass";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@keyframes slideshow {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-874px);
  }
}
@keyframes openingWindow {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes closingWindow {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes topBarMoving {
  0% {
    top: 100%;
    transform: scaleY(1);
    opacity: 0;
  }
  13% {
    transform: scaleY(50);
  }
  25% {
    top: 0%;
    transform: scaleY(1);
  }
  38% {
    transform: scaleY(50);
  }
  50% {
    top: 100%;
    transform: scaleY(1);
  }
  60% {
    transform: scaleY(50);
  }
  70% {
    top: 0%;
    transform: scaleY(1);
  }
  80% {
    transform: scaleY(50);
  }
  90% {
    top: 100%;
    transform: scaleY(1);
  }
  95% {
    transform: scaleY(50);
    opacity: 0.5;
  }
  99% {
    top: 0%;
    transform: scaleY(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes bottomBarMoving {
  0% {
    bottom: 100%;
    transform: scaleY(1);
    opacity: 0;
  }
  13% {
    transform: scaleY(50);
  }
  25% {
    bottom: 0%;
    transform: scaleY(1);
  }
  38% {
    transform: scaleY(50);
  }
  50% {
    bottom: 100%;
    transform: scaleY(1);
  }
  60% {
    transform: scaleY(50);
  }
  70% {
    bottom: 0%;
    transform: scaleY(1);
  }
  80% {
    transform: scaleY(50);
  }
  90% {
    bottom: 100%;
    transform: scaleY(1);
  }
  95% {
    transform: scaleY(50);
    opacity: 0.5;
  }
  99% {
    bottom: 0%;
    transform: scaleY(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes menuButtonTop {
  0% {
    transform-origin: right center;
    transform: rotate(0deg);
  }
  100% {
    transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg);
  }
}
@keyframes menuCloseButtonTop {
  0% {
    transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg);
  }
  100% {
    transform-origin: right center;
    transform: rotate(0deg);
  }
}
@keyframes menuButtonBottom {
  0% {
    transform-origin: left center;
    transform: rotate(0deg);
  }
  100% {
    transform: translate(-5px, -3px) rotate(-50deg);
  }
}
@keyframes menuCloseButtonBottom {
  0% {
    transform: translate(-5px, -3px) rotate(-50deg);
  }
  100% {
    transform-origin: left center;
    transform: rotate(0deg);
  }
}
@keyframes introductionArrow {
  0% {
    transform: translateY(50px);
  }
  50% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(50px);
  }
}
@keyframes introductionArrow2 {
  0% {
    transform: translateY(52px);
  }
  50% {
    transform: translateY(32px);
  }
  100% {
    transform: translateY(52px);
  }
}
*, ::before, ::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

#root {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  align-items: center;
  white-space: pre-line;
}
#root .app-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  position: relative;
  background: #191825;
  font-family: "Bahnschrift";
}
#root .app-body main {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 90%;
  margin-bottom: 50px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
@media screen and (min-width: 768px) {
  #root .app-body main {
    width: 100%;
  }
}
@media screen and (min-width: 1280px) {
  #root .app-body main {
    width: 90%;
  }
}
#root .app-body main .portfolio {
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: baseline;
}
@media screen and (min-width: 768px) {
  #root .app-body main .portfolio {
    width: 100%;
  }
}
@media screen and (min-width: 1280px) {
  #root .app-body main .portfolio {
    width: 95%;
  }
}

body {
  position: relative;
}

header {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 3;
}
header::after {
  content: "";
  width: 97%;
  height: 2px;
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: #9471fd;
  z-index: -1;
}

footer {
  display: flex;
  align-items: center;
  background: #191825;
  padding-top: 25px;
  flex-direction: column;
  color: #9471fd;
  font-weight: bold;
  border-radius: 20px 20px 0 0;
  position: relative;
}
footer img {
  width: 50px;
}
footer .copyright {
  padding: 15px 0 15px 0;
}
footer::before {
  content: "";
  width: 97%;
  height: 2px;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: #9471fd;
}

.secret-link {
  color: #F0CAA3;
  margin-left: 5px;
  cursor: default;
}

header {
  font-family: "Bahnschrift";
}
header .logo {
  color: #9471fd;
  font-size: 25px;
  margin-top: 15px;
  height: 160px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 1280px) {
  header .logo {
    font-size: 37px;
  }
}
header .logo .image {
  width: 70px;
  height: 70px;
  position: relative;
  left: 40%;
  margin-bottom: 5px;
}
header .logo .image::before {
  content: "";
  position: absolute;
  top: 62px;
  left: -52px;
  width: 55px;
  height: 3px;
  background: #9471fd;
}
header .logo .image::after {
  content: "";
  position: absolute;
  top: 62px;
  left: 60px;
  width: 55px;
  height: 3px;
  background: #9471fd;
}
header .logo .text {
  position: relative;
}
header .logo .text .name {
  font-family: "BrunoAce";
  flex-basis: 100%;
}
header .logo .text .name::before {
  content: "";
  width: 250px;
  height: 3px;
  background: #9471fd;
  position: absolute;
  top: 0px;
  left: -12px;
}
@media screen and (min-width: 1280px) {
  header .logo .text .name::before {
    width: 350px;
  }
}
header .logo .text .function {
  font-stretch: condensed;
  font-weight: 100;
  position: absolute;
  top: 27px;
  min-width: 233px;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 1280px) {
  header .logo .text .function {
    width: 325px;
    top: 37px;
  }
}

nav {
  position: absolute;
  display: block;
  font-size: 25px;
  font-weight: lighter;
  color: #F0CAA3;
  right: 5%;
  top: 35px;
  font-family: "Bahnschrift";
}
@media screen and (min-width: 1280px) {
  nav {
    right: 2%;
    top: 15px;
  }
}
nav .openButton {
  position: relative;
  cursor: pointer;
  width: 40px;
  height: 18px;
  z-index: 21;
}
nav .openButton.opened::before {
  animation: menuButtonTop 700ms ease-out normal both;
}
nav .openButton.opened::after {
  animation: menuButtonBottom 700ms ease-out normal both;
}
nav .openButton.closed::before {
  animation: menuCloseButtonTop 700ms ease-out normal both;
}
nav .openButton.closed::after {
  animation: menuCloseButtonBottom 700ms ease-out normal both;
}
nav .openButton::before {
  content: "";
  width: 40px;
  height: 3px;
  background: #FFA3FD;
  position: absolute;
  top: 0;
  left: 0;
}
nav .openButton::after {
  content: "";
  width: 30px;
  height: 3px;
  background: #FFA3FD;
  position: absolute;
  top: 15px;
  left: 10px;
}
nav .menu {
  position: absolute;
  top: -10px;
  right: 0px;
}
nav .menu__ref {
  padding: 25px;
  position: relative;
  width: 300px;
  height: 550px;
  border: 2px solid #9471fd;
  background: #191825;
  z-index: 20;
}
nav .menu__ref span {
  display: block;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
}
nav .menu ul {
  list-style: none;
  margin-left: 15px;
}
nav .menu ul li {
  margin-bottom: 20px;
}
nav .menu ul li a {
  position: relative;
  color: #F0CAA3;
  font-size: 18px;
}
nav .menu ul li a::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -10px;
  left: 0;
  background-color: #F0CAA3;
  transform-origin: top right;
  transition: transform 0.6s ease-out;
}
nav .menu ul li a:hover::after {
  transform: scaleX(1);
}
nav .menu ul li a::before {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  top: -11px;
  left: 0;
  background-color: #F0CAA3;
  transform-origin: bottom left;
  transition: transform 0.6s ease-out;
}
nav .menu ul li a:hover::before {
  transform: scaleX(1);
}
nav .menu ul .reversed a::after {
  transform-origin: bottom left;
}
nav .menu ul .reversed a::before {
  transform-origin: top right;
}
nav .menu ul.lang {
  display: flex;
  font-weight: bold;
  justify-content: space-between;
}
nav .menu ul.lang li {
  cursor: pointer;
  font-size: 15px;
  color: #F0CAA3;
}
nav .menu ul.lang li.activated {
  color: #FFA3FD;
  text-decoration: overline;
}
nav .sousMenu {
  margin-left: 25px;
  position: relative;
}
nav .sousMenu::before {
  content: "";
  width: 10px;
  height: 10px;
  border-left: 2px solid #F0CAA3;
  border-bottom: 2px solid #F0CAA3;
  position: absolute;
  left: -15px;
  top: 10px;
}

.prePortfolioNav .openButton::before {
  background: #9471fd;
}
.prePortfolioNav .openButton::after {
  background: #9471fd;
}

.contactform .openButton::before {
  background: #F0CAA3;
}
.contactform .openButton::after {
  background: #F0CAA3;
}

.jrpg .openButton::before {
  background: #F0CAA3;
}
.jrpg .openButton::after {
  background: #F0CAA3;
}

.scroller {
  overflow-y: scroll;
  scroll-snap-type: x mandatory;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
@media screen and (min-width: 1280px) {
  .scroller {
    scroll-snap-type: y mandatory;
    flex-wrap: wrap;
  }
}
.scroller section {
  min-height: 100vh;
  min-width: 100%;
  height: 100%;
  width: 100%;
  overflow: auto;
  scroll-snap-align: start;
}
.scroller .one {
  background: #191825;
  position: relative;
  max-height: 100vh;
}
.scroller .two {
  background: none;
}
.scroller .three {
  background: #F0CAA3;
}
.scroller .four {
  background: #9471fd;
}
.scroller .five {
  background: #191825;
}

.introduction {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-basis: 100%;
  height: auto;
  font-family: "Bahnschrift";
  position: relative;
}
@media screen and (min-width: 1280px) {
  .introduction::before {
    content: "";
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    right: 0;
    left: 0;
    bottom: -2vw;
    z-index: 0;
    width: 0;
    height: 0;
    border-left: 70px solid transparent;
    border-right: 70px solid transparent;
    border-top: 70px solid #9471fd;
    animation: introductionArrow2 2.5s ease-in-out infinite normal;
  }
}
@media screen and (min-width: 1280px) {
  .introduction::after {
    content: "";
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    right: 0;
    left: 0;
    bottom: -2vw;
    z-index: 0;
    width: 0;
    height: 0;
    border-left: 66px solid transparent;
    border-right: 66px solid transparent;
    border-top: 66px solid #191825;
    animation: introductionArrow 2.5s ease-in-out infinite normal;
  }
}
.introductionText {
  position: relative;
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 100px;
}
@media screen and (min-width: 768px) {
  .introductionText {
    flex-basis: 90%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .introductionText {
    flex-basis: 50%;
  }
}
@media screen and (min-width: 1280px) {
  .introductionText {
    flex-basis: 50%;
  }
}
.introductionText h1 {
  position: relative;
  z-index: 1;
  flex-basis: 100%;
  font-size: 6vw;
  color: #FFA3FD;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 768px) {
  .introductionText h1 {
    font-size: 4.5vw;
    margin-left: 20px;
    justify-content: start;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .introductionText h1 {
    font-size: 2.7vw;
    margin-left: 0px;
  }
}
@media screen and (min-width: 1280px) {
  .introductionText h1 {
    margin-left: 0;
    font-size: 3vw;
  }
}
.introductionText h2 {
  font-size: 4.8vw;
  color: #F0CAA3;
  margin: 0 0 15px 0;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 768px) {
  .introductionText h2 {
    font-size: 3vw;
    justify-content: start;
    margin: 50px 0 20px 20px;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .introductionText h2 {
    font-size: 1.9vw;
    margin: 50px 0 20px 0;
  }
}
@media screen and (min-width: 1280px) {
  .introductionText h2 {
    font-size: 1.8vw;
    margin: 50px 0 20px 0;
  }
}
.introductionText p {
  font-size: 4vw;
  color: #9471fd;
  padding: 20px;
}
@media screen and (min-width: 768px) {
  .introductionText p {
    font-size: 2.8vw;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .introductionText p {
    padding: 10px;
    font-size: 1.5vw;
  }
}
@media screen and (min-width: 1280px) {
  .introductionText p {
    padding: 10px;
    font-size: 1.5vw;
  }
}
.introductionText .secondText, .introductionText .thirdText {
  flex-basis: 100%;
}
@media screen and (min-width: 768px) {
  .introductionText .secondText, .introductionText .thirdText {
    flex-basis: 50%;
  }
}
@media screen and (min-width: 1280px) {
  .introductionText::before {
    content: "";
    position: absolute;
    top: -55px;
    right: 0;
    z-index: 0;
    width: 0;
    height: 0;
    border-left: 60px solid transparent;
    border-right: 60px solid transparent;
    border-top: 130px solid #9471fd;
    transform: rotate(50deg);
  }
}
@media screen and (min-width: 1280px) {
  .introductionText::after {
    content: "";
    position: absolute;
    top: -52px;
    right: 3px;
    z-index: 0;
    width: 0;
    height: 0;
    border-left: 56px solid transparent;
    border-right: 56px solid transparent;
    border-top: 122px solid #191825;
    transform: rotate(50deg);
  }
}
.introduction .presentationText {
  margin-top: 25px;
  width: 500px;
  background: #9471fd;
  border-radius: 25px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
.introduction .presentationText .thirdText h2 {
  display: flex;
  flex-direction: column;
}
.introduction .presentationText .thirdText h2 span {
  flex-basis: 50%;
}
.introduction .presentationText p {
  position: relative;
  flex-basis: 80%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.introduction .presentationText::before {
  content: "";
  position: absolute;
  height: 3px;
  width: 100%;
  background: #191825;
  top: 98%;
  z-index: 4;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  animation: topBarMoving 1s ease 2 normal both;
}
.introduction .presentationText::after {
  content: "";
  position: absolute;
  height: 3px;
  width: 100%;
  background: #191825;
  bottom: 98%;
  z-index: 4;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  animation: bottomBarMoving 1s ease 2 normal both;
}

.two {
  cursor: default;
  color: #fff;
  font-family: "metamorphous";
  position: relative;
  max-height: 100vh;
  min-width: 100vw;
}
.two h2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.two h2 img {
  height: 90px;
  margin-right: 15px;
}
.two h3 {
  padding-left: 3%;
  margin-bottom: 15px;
  position: relative;
  font-size: 15px;
}
@media screen and (min-width: 1280px) {
  .two h3 {
    font-size: 1.17em;
    padding-left: 5%;
  }
}
.two h3::after {
  content: "";
  display: inline-block;
  height: 1px;
  width: 35%;
  background: #fff;
  position: absolute;
  bottom: -10px;
  left: 2%;
}
@media screen and (min-width: 1280px) {
  .two h3::after {
    left: 4%;
  }
}
.two #backgroundVideo {
  position: fixed;
  right: 0;
  top: 0;
  z-index: -2;
  min-width: 100vw;
  min-height: 100vh;
  max-height: 100vh;
}
@media screen and (min-width: 1280px) {
  .two #backgroundVideo {
    min-width: 100%;
    min-height: 100%;
    max-height: none;
  }
}
.two::before {
  content: "";
  position: fixed;
  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 15%, rgb(124, 124, 124) 40%, rgb(124, 124, 124) 60%, rgb(0, 0, 0) 85%, rgb(0, 0, 0) 100%);
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0.7;
  width: 100%;
  height: 100%;
}
.two .jrpgstat {
  display: flex;
  flex-wrap: wrap;
}
.two .jrpgstat .header {
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 20vh;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header {
    height: 20vh;
  }
}
.two .jrpgstat .header .title h2 {
  position: relative;
}
.two .jrpgstat .body {
  flex-basis: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body {
    height: 60vh;
  }
}
.two .jrpgstat .body .stats {
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats {
    flex-basis: 40%;
  }
}
.two .jrpgstat .body .stats .skills {
  flex-basis: 100%;
  height: 100%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .skills {
    height: 60%;
  }
}
.two .jrpgstat .footer {
  flex-basis: 100%;
  min-height: 20vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer {
    height: 20vh;
  }
}

.prePortfolio {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  position: relative;
  flex-wrap: wrap;
}
.prePortfolio .projectCard {
  position: relative;
  z-index: 2;
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;
  order: 1;
  margin-top: 0;
  margin-top: -250px;
}
@media screen and (min-width: 768px) {
  .prePortfolio .projectCard {
    flex-basis: 48%;
    margin-top: -450px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .projectCard {
    margin-top: 0;
    flex-basis: 30%;
    margin-top: 30px;
    order: none;
  }
}
.prePortfolio .textBlock {
  background: #191825;
}
.prePortfolio .preProtfolioText {
  flex-basis: 100%;
  height: 100%;
  font-family: "Bahnschrift";
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 0;
  margin-bottom: 10%;
  order: 0;
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText {
    margin-top: 0;
    margin-bottom: 0;
    flex-basis: 40%;
    order: 1;
  }
}
.prePortfolio .preProtfolioText h2 {
  color: #9471fd;
  font-size: 40px;
  position: relative;
  z-index: 0;
  margin-top: -60px;
  margin-bottom: -250px;
}
@media screen and (min-width: 768px) {
  .prePortfolio .preProtfolioText h2 {
    font-size: 70px;
    margin-top: -250px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText h2 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 70px;
  }
  .prePortfolio .preProtfolioText h2::before {
    content: "";
    width: 400px;
    height: 400px;
    border-radius: 200px;
    border: 4px solid #9471fd;
    position: absolute;
    left: -45%;
    top: 0px;
    z-index: -1;
  }
  .prePortfolio .preProtfolioText h2::after {
    content: "";
    width: 400px;
    height: 400px;
    border-radius: 200px;
    border: 4px solid #9471fd;
    position: absolute;
    left: 100%;
    top: 500%;
    z-index: -1;
  }
}
.prePortfolio .preProtfolioText p {
  color: #191825;
  position: relative;
  z-index: 1;
  width: 100%;
  font-size: 20px;
  padding: 3%;
}
@media screen and (min-width: 768px) {
  .prePortfolio .preProtfolioText p {
    font-size: 30px;
    margin-top: -250px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText p {
    font-size: 40px;
    margin-top: 0;
  }
  .prePortfolio .preProtfolioText p::before {
    content: "";
    width: 200px;
    height: 200px;
    border-radius: 100px;
    border: 4px solid #9471fd;
    position: absolute;
    left: -10%;
    top: 125%;
    z-index: -1;
  }
  .prePortfolio .preProtfolioText p::after {
    content: "";
    width: 300px;
    height: 300px;
    border-radius: 150px;
    border: 4px solid #9471fd;
    position: absolute;
    right: -30%;
    top: -150%;
    z-index: -1;
  }
}
.prePortfolio .preProtfolioText .links {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: -100px;
}
@media screen and (min-width: 768px) {
  .prePortfolio .preProtfolioText .links {
    margin-top: -300px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText .links {
    margin-top: 0;
  }
}
.prePortfolio .preProtfolioText .links a {
  flex-basis: 45%;
  margin-top: -150px;
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText .links a {
    margin-top: 0px;
    margin-bottom: 60px;
  }
}
.prePortfolio .preProtfolioText .links a .button {
  height: 50px;
  border-radius: 45px;
  color: #FFA3FD;
  background: #191825;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  box-shadow: 5px 5px 10px #191825;
}
@media screen and (min-width: 768px) {
  .prePortfolio .preProtfolioText .links a .button {
    height: 70px;
    font-size: 30px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .preProtfolioText .links a .button {
    height: 90px;
    border-radius: 45px;
    font-size: 35px;
  }
}
.prePortfolio .preProtfolioText .links a .button:hover {
  background: black;
  box-shadow: 5px 5px 10px black;
  color: rgb(100%, 79.9215686275%, 99.5635123615%);
}
.prePortfolio .projectCard.second {
  margin-top: 0px;
}
@media screen and (min-width: 768px) {
  .prePortfolio .projectCard.second {
    margin-top: -450px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .projectCard.second {
    margin-top: 30px;
  }
}

main.notFound {
  color: #9471fd;
}
main.notFound h1 {
  margin-top: 25px;
  position: relative;
  flex-basis: 100%;
  font-size: 150px;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 768px) {
  main.notFound h1 {
    font-size: 300px;
    margin-top: 50px;
  }
}
@media screen and (min-width: 1280px) {
  main.notFound h1 {
    margin-top: 50px;
    font-size: 300px;
  }
}
main.notFound p {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  font-size: 12px;
  font-weight: bold;
}
@media screen and (min-width: 768px) {
  main.notFound p {
    font-size: 25px;
  }
}
@media screen and (min-width: 1280px) {
  main.notFound p {
    font-size: 25px;
  }
}
main.notFound a {
  color: #F0CAA3;
  font-size: 20px;
}

.legal-mentions {
  margin-top: 100px;
  color: #F0CAA3;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  color: #FFA3FD;
  font-size: 1.2rem;
  margin-top: 50px;
}
.login-form.change {
  margin-top: 0;
}
.login-form input {
  width: 300px !important;
  height: 40px !important;
  margin: 10px !important;
  padding: 0 10px !important;
  border: none !important;
  border-radius: 5px !important;
  font-size: 1rem !important;
  outline: none !important;
  background-color: white !important;
  color: black !important;
}
.login-form input:focus {
  border: 2px solid #FFA3FD !important;
}
.login-form button {
  width: 150px;
  height: 40px;
  margin: 10px;
  border: 2px solid #F0CAA3;
  border-radius: 5px;
  background-color: transparent;
  color: #F0CAA3;
  font-size: 1rem;
}
.login-form button:hover {
  background-color: #F0CAA3;
  color: #000;
  cursor: pointer;
}

.presentation-text input, .presentation-text textarea {
  width: 100% !important;
  border: none !important;
  background-color: transparent !important;
  color: #F0CAA3 !important;
  font-size: 1rem !important;
  margin-bottom: 10px !important;
}
.presentation-text .presentation-title {
  font-size: 1.2rem !important;
  font-weight: bold !important;
  height: 30px !important;
}
.presentation-text .presentation-title:focus {
  outline: 2px solid #FFA3FD !important;
  border-radius: 0 !important;
}
.presentation-text .presentation-textarea {
  height: 150px !important;
  resize: none;
  font-family: "Bahnschrift";
}
.presentation-text .presentation-textarea:focus {
  outline: 2px solid #FFA3FD !important;
}

.login-sub-panel {
  display: flex;
  flex-direction: column;
  margin: 20px;
  padding: 20px 30px 20px 30px;
  border-radius: 15px;
  border: 2px solid #F0CAA3;
}

.sub-form {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.admin-generator {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.freeSpace {
  flex: 1 1;
  position: relative;
  bottom: 5px;
}
.freeSpace .slidingText {
  position: absolute;
  bottom: 0;
}

.buttonContainer {
  display: flex;
  flex-basis: 100%;
  padding-top: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.buttonContainer .singleButton {
  flex-basis: 95%;
  padding-bottom: 20px;
}
@media screen and (min-width: 1280px) {
  .buttonContainer .singleButton {
    flex-basis: 48%;
  }
}
.buttonContainer .button {
  flex-basis: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5em 0 0.5em 0;
  border-radius: 8px;
  background: #9471fd;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: bold;
  color: #000;
  box-shadow: 1px 1px 5px #9471fd;
  margin: 0 15px 0 15px;
  position: relative;
}
.buttonContainer .button:hover {
  box-shadow: 1px 1px 5px rgb(35.7475490196%, 14.7303921569%, 98.7990196078%);
}
@media screen and (min-width: 1280px) {
  .buttonContainer .button {
    font-size: 13px;
    padding-left: 10px;
  }
}
.buttonContainer .button img {
  position: absolute;
  left: 4%;
  width: 20px;
  top: 11px;
}
.buttonContainer .button.github {
  background: #F0CAA3;
  font-size: 12px;
}
.buttonContainer .button.github:hover {
  background: rgb(92.7157778999%, 74.2624152465%, 55.3234377863%);
}
.buttonContainer .button.live {
  color: #191825;
  background: #FFA3FD;
}
.buttonContainer .button.live:hover {
  background: rgb(100%, 53.9215686275%, 98.9982949702%);
}
.buttonContainer .button.unavailable {
  background: #191825;
  color: #9471fd;
  cursor: not-allowed;
}

.slidingText {
  overflow: hidden;
  position: relative;
  width: 97%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.slidingText .slidingBox {
  animation: slideshow 120s infinite linear;
}
.slidingText .slidingBox span {
  font-size: 15px;
  opacity: 0.7;
  color: #9471fd;
  font-family: "Anton";
}
.slidingText .slidingBox :nth-child(2n+1) {
  font-size: 16px;
  position: relative;
  top: 1px;
}
.slidingText .slidingBox :nth-child(2n+0) {
  color: transparent;
  -webkit-text-stroke: 1px #9471fd;
}
.slidingText.reversed .slidingBox {
  animation: slideshow 120s infinite linear reverse;
}
.slidingText.reversed .slidingBox span {
  color: #F0CAA3;
}
.slidingText.reversed .slidingBox :nth-child(2n+0) {
  color: transparent;
  -webkit-text-stroke: 1px #F0CAA3;
}

.textBlock {
  position: relative;
  font-family: "Roboto";
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0 20px 0;
  padding-bottom: 10px;
  justify-content: center;
  animation: openingWindow 700ms ease-out normal both;
  flex-basis: 95%;
  border: 2px solid #9471fd;
}
@media screen and (min-width: 768px) {
  .textBlock {
    flex-basis: 90%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .textBlock {
    flex-basis: 85%;
  }
}
@media screen and (min-width: 1280px) {
  .textBlock {
    flex-basis: 95%;
  }
}
.textBlock .codeTitle {
  height: 50px;
  background: #9471fd;
  color: #191825;
  padding: 10px 10px 10px 0;
  text-align: center;
  flex-basis: 100%;
  margin-bottom: 20px;
  font-size: 14px;
}
@media screen and (min-width: 1280px) {
  .textBlock .codeTitle {
    font-size: 17px;
    padding: 10px 30px 10px 10px;
    height: 50px;
  }
}
.textBlock .textCode {
  padding: 30px 30px 0 30px;
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
}
.textBlock .textCode h3 {
  text-decoration: underline;
  flex-basis: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.textBlock::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  background: #191825;
  border: 2px solid #F0CAA3;
  position: absolute;
  right: 4px;
  top: 5px;
}
.textBlock .closeButton {
  cursor: pointer;
  font-size: 23px;
  font-weight: bold;
  color: #F0CAA3;
  position: absolute;
  top: -1px;
  right: 10px;
}
.textBlock.fade {
  animation: closingWindow 700ms ease-out both;
}

.portfolio .textBlock {
  flex-basis: 100%;
  border: 2px solid #9471fd;
}
@media screen and (min-width: 768px) {
  .portfolio .textBlock {
    flex-basis: 48%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .portfolio .textBlock {
    flex-basis: 45%;
  }
}
@media screen and (min-width: 1280px) {
  .portfolio .textBlock {
    flex-basis: 30%;
  }
}
.portfolio .textCode {
  color: #9471fd;
  font-size: 4vw;
}
@media screen and (min-width: 768px) {
  .portfolio .textCode {
    font-size: 2.3vw;
  }
}
@media screen and (min-width: 1280px) {
  .portfolio .textCode {
    font-size: 1.26vw;
  }
}
.portfolio .textCode h3 {
  color: #FFA3FD;
}
.portfolio .textCode p {
  margin-left: 7px;
}
@media screen and (min-width: 1280px) {
  .portfolio .textCode p {
    margin-left: 10px;
  }
}

.prePortfolio .textCode {
  color: #9471fd;
  font-size: 4.6vw;
}
@media screen and (min-width: 768px) {
  .prePortfolio .textCode {
    font-size: 2vw;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .textCode {
    font-size: 1.2vw;
  }
}
.prePortfolio .textCode h3 {
  color: #FFA3FD;
}
.prePortfolio .textCode p {
  margin-left: 7px;
}
@media screen and (min-width: 768px) {
  .prePortfolio .textCode p {
    margin-left: 20px;
  }
}
@media screen and (min-width: 1280px) {
  .prePortfolio .textCode p {
    margin-left: 50px;
  }
}

.imageSample {
  height: 200px;
  width: 80%;
  object-fit: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  background: #191825;
  border: 3px solid #F0CAA3;
  box-shadow: 1px 1px 5px #000;
}
@media screen and (min-width: 1280px) {
  .imageSample {
    height: 250px;
    width: 80%;
  }
}
.imageSample .imgContainer {
  flex-basis: 100%;
  margin: 51px 5px 5px 5px;
  height: 100%;
  overflow: hidden;
}
.imageSample .imgContainer img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.imageSample .imageText {
  position: absolute;
  top: 0;
  padding-top: 8px;
  padding-bottom: 17px;
  width: 100%;
  color: #191825;
  font-weight: bold;
  text-align: center;
  background: #F0CAA3;
}
.imageSample.first {
  z-index: 3;
  animation: openingWindow 700ms ease-out 2100ms normal both;
}
.imageSample.first.fade {
  animation: closingWindow 700ms ease-out both;
}
.imageSample.second {
  z-index: 2;
  animation: openingWindow 700ms ease-out 1400ms normal both;
}
.imageSample.second.fade {
  animation: closingWindow 700ms ease-out both;
}
.imageSample.third {
  z-index: 1;
  animation: openingWindow 700ms ease-out 700ms normal both;
}
.imageSample.third.fade {
  animation: closingWindow 700ms ease-out both;
}
.imageSample.left {
  position: absolute;
  left: -3%;
  top: 10%;
}
.imageSample.center {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.imageSample.right {
  position: absolute;
  right: -3%;
  top: 20%;
}
.imageSample::before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  background: #191825;
  border: 2px solid #FFA3FD;
  position: absolute;
  z-index: 2;
  right: 4px;
  top: 5px;
}
.imageSample .closeButton {
  cursor: pointer;
  font-size: 23px;
  font-weight: bold;
  color: #FFA3FD;
  position: absolute;
  z-index: 3;
  top: -1px;
  right: 10px;
}

.imageHolder {
  position: relative;
  max-height: 400px;
  transition: max-height 700ms ease-out;
  width: 100%;
}
.imageHolder .holder {
  height: 200px;
}
@media screen and (min-width: 1280px) {
  .imageHolder .holder {
    height: 270px;
  }
}
.imageHolder.fade {
  max-height: 0px;
}

.presentationText .imageSample {
  height: 200px;
  width: 90%;
}
@media screen and (min-width: 1280px) {
  .presentationText .imageSample {
    height: 600px;
    width: 90%;
  }
}
.presentationText .imageSample .closeButton {
  top: 3px;
  right: 11px;
}
.presentationText .imageHolder {
  position: relative;
  max-height: 650px;
  transition: max-height 700ms ease-out;
  width: 100%;
}
.presentationText .imageHolder .holder {
  height: 700px;
}
@media screen and (min-width: 1280px) {
  .presentationText .imageHolder .holder {
    height: 700px;
  }
}
.presentationText .imageHolder.fade {
  max-height: 0px;
}

@media screen and (min-width: 1280px) {
  .prePortfolio .imageSample {
    height: 200px;
    width: 60%;
  }
}
.prePortfolio .imageHolder {
  position: relative;
  max-height: 400px;
  transition: max-height 700ms ease-out;
  width: 100%;
}
@media screen and (min-width: 1280px) {
  .prePortfolio .imageHolder .holder {
    height: 200px;
  }
}

.tripleContainer {
  display: flex;
  align-items: center;
}
.tripleContainer .triplePhoto {
  max-height: 430px;
  max-width: 610px;
  position: relative;
  margin-right: 50vw;
  margin-bottom: 22vw;
  margin-top: 10vw;
  scale: 1;
}
@media screen and (min-width: 768px) {
  .tripleContainer .triplePhoto {
    margin-top: 10vw;
    margin-right: 43vw;
    margin-bottom: 30vw;
    scale: 0.8;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .tripleContainer .triplePhoto {
    scale: 0.5;
    margin-right: 15vw;
    margin-top: 3vw;
    margin-bottom: 12vw;
  }
}
@media screen and (min-width: 1280px) {
  .tripleContainer .triplePhoto {
    margin-top: 0;
    margin-right: 15vw;
    margin-bottom: 17vw;
    margin-left: 0;
    scale: 0.5;
  }
}
.tripleContainer .triplePhoto::before {
  content: "";
  width: 40vw;
  height: 40vw;
  border-radius: 2vw;
  border: 2px solid #9471fd;
  position: absolute;
  left: -5vw;
  top: -5vw;
  z-index: 0;
  overflow: auto;
}
.tripleContainer .triplePhoto::after {
  content: "";
  width: 10vw;
  height: 10vw;
  border-radius: 2vw;
  border: 2px solid #9471fd;
  position: absolute;
  left: 36vw;
  top: 36vw;
  z-index: 0;
}
.tripleContainer .triplePhoto .squareOne {
  width: 40vw;
  height: 40vw;
  border-radius: 2vw;
  position: absolute;
  overflow: hidden;
  z-index: 1;
}
.tripleContainer .triplePhoto .squareOne img {
  position: absolute;
  top: -1vw;
  left: 0;
  min-width: 61vw;
  height: 50vw;
}
.tripleContainer .triplePhoto .squareTwo {
  width: 20vw;
  height: 20vw;
  border-radius: 2vw;
  position: absolute;
  left: 41vw;
  top: 6vw;
  overflow: hidden;
  z-index: 1;
}
.tripleContainer .triplePhoto .squareTwo img {
  position: absolute;
  left: -41vw;
  top: -7vw;
  min-width: 61vw;
  height: 50vw;
}
.tripleContainer .triplePhoto .squareThree {
  width: 15vw;
  height: 15vw;
  border-radius: 2vw;
  position: absolute;
  left: 41vw;
  top: 27vw;
  overflow: hidden;
  z-index: 1;
}
.tripleContainer .triplePhoto .squareThree img {
  position: absolute;
  left: -41vw;
  top: -28vw;
  min-width: 61vw;
  height: 50vw;
}

.two .jrpgstat .header .title {
  flex-basis: 100%;
  display: flex;
  margin-left: 2%;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .header .title {
    flex-basis: 30%;
  }
}
.two .jrpgstat .header .title h2 {
  font-size: 15px;
  text-shadow: 3px 3px 2px #191825;
  left: 7%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .title h2 {
    font-size: 1.5em;
  }
}
.two .jrpgstat .header .title h2 .text {
  position: relative;
  z-index: 1;
  width: 130px;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .title h2 .text {
    width: 220px;
  }
}
.two .jrpgstat .header .title h2::before {
  content: "";
  width: 130px;
  height: 50px;
  position: absolute;
  background: #191825;
  border-radius: 25px;
  opacity: 0.5;
  z-index: 0;
  left: 105px;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .title h2::before {
    width: 220px;
  }
}
.two .jrpgstat .header .faces {
  flex-basis: 100%;
  display: flex;
  justify-content: space-between;
  margin-right: 5%;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .header .faces {
    flex-basis: 40%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .header .faces {
    margin-top: 20px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .faces {
    margin-top: 0;
    flex-basis: 30%;
    margin-right: 0;
    justify-content: space-around;
  }
}
.two .jrpgstat .header .faces h3 {
  font-size: 15px;
  display: flex;
  justify-content: center;
}
.two .jrpgstat .header .faces h3::after {
  width: 100%;
  left: 15%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .faces h3 {
    font-size: 1.17em;
  }
}
.two .jrpgstat .header .faces h3::before {
  content: "";
  width: 100px;
  height: 30px;
  position: absolute;
  background: #191825;
  border-radius: 25px;
  opacity: 0.5;
  z-index: -1;
  left: 2%;
  top: -6px;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .faces h3::before {
    width: 120px;
    top: -4px;
    left: 17%;
  }
}
.two .jrpgstat .header .faces img {
  height: 25px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .header .faces img {
    height: 40px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .header .faces img {
    height: 50px;
  }
}

.two .jrpgstat .body .stats .head {
  padding-left: 5%;
  padding-right: 1%;
  flex-basis: 100%;
  height: 120px;
  object-fit: cover;
  overflow: hidden;
  position: relative;
  display: flex;
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head {
    height: 170px;
    margin-bottom: 20px;
    margin-top: -60px;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .head {
    margin-bottom: -20px;
    margin-top: -30px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head {
    height: 170px;
    margin-bottom: 0;
    margin-top: 0;
  }
}
.two .jrpgstat .body .stats .head::before {
  content: "";
  width: 75%;
  height: 100%;
  background: #000;
  opacity: 0.5;
  position: absolute;
  border-radius: 0 0 25px 0;
  z-index: -1;
  top: 0;
  right: 5%;
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .head::before {
    width: 80%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head::before {
    width: 80%;
  }
}
.two .jrpgstat .body .stats .head img {
  height: 100%;
}
.two .jrpgstat .body .stats .head .nameHPandMana {
  flex-basis: 70%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  position: relative;
  padding-left: 0;
  padding-top: 15px;
  padding-right: 5%;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana {
    padding-right: 0;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .head .nameHPandMana {
    padding-left: 30px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head .nameHPandMana {
    padding-left: 15px;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .namePC {
  flex-basis: 100%;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  padding-right: 5%;
  padding-left: 5%;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .namePC {
    font-size: 22px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .namePC {
    font-size: 22px;
    padding-left: 0;
    padding-right: 0;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .HP {
  flex-basis: 40%;
  display: flex;
  flex-wrap: wrap;
  margin-right: 0;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .HP {
    font-size: 22px;
    margin-right: 10px;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .HP .points {
  flex-basis: 100%;
  font-size: 10px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .HP .points {
    font-size: 20px;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .HP .bar {
  flex-basis: 100%;
  height: 15px;
  border-radius: 15px;
  background: linear-gradient(90deg, rgb(246, 115, 0) 0%, rgb(255, 198, 155) 100%);
  border: 2px solid black;
  position: relative;
}
.two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {
  content: "";
  width: 109%;
  height: 17px;
  border-radius: 15px;
  border: 4px solid white;
  position: absolute;
  left: -4px;
  top: -3px;
  z-index: -1;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {
    width: 104%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {
    width: 103%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {
    width: 104%;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .mana {
  flex-basis: 40%;
  display: flex;
  flex-wrap: wrap;
}
.two .jrpgstat .body .stats .head .nameHPandMana .mana .points {
  flex-basis: 100%;
  font-size: 10px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .mana .points {
    font-size: 20px;
  }
}
.two .jrpgstat .body .stats .head .nameHPandMana .mana .bar {
  flex-basis: 100%;
  height: 15px;
  border-radius: 15px;
  background: linear-gradient(90deg, rgb(9, 9, 121) 0%, rgb(0, 212, 255) 100%);
  border: 2px solid black;
  position: relative;
}
.two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {
  content: "";
  width: 109%;
  height: 17px;
  border-radius: 15px;
  border: 4px solid white;
  position: absolute;
  left: -4px;
  top: -3px;
  z-index: -1;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {
    width: 104%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {
    width: 103%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {
    width: 104%;
  }
}

.two .jrpgstat .body .stats .skills h3 {
  width: 210px;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .skills h3 {
    width: 230px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .skills h3 {
    width: 285px;
  }
}
.two .jrpgstat .body .stats .skills h3::before {
  content: "";
  width: 210px;
  height: 30px;
  position: absolute;
  background: #191825;
  border-radius: 25px;
  opacity: 0.7;
  z-index: -1;
  left: 3%;
  top: -6px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills h3::before {
    left: 6%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .skills h3::before {
    left: 12%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .skills h3::before {
    width: 285px;
    top: -4px;
    left: 7%;
  }
}
.two .jrpgstat .body .stats .skills .capacities {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities {
    height: 90%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .skills .capacities {
    height: 90%;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity {
  position: relative;
  flex-basis: 45%;
  border-radius: 5px;
  padding: 2px 0px 2px 15px;
  display: flex;
  color: #FFF;
  font-weight: bold;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity {
    margin-bottom: 9px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity {
    margin-bottom: 0;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity.active {
  color: #000;
}
.two .jrpgstat .body .stats .skills .capacities .capacity::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(94, 94, 94) 100%);
  border: 1px solid black;
  border-radius: 5px;
  padding: 2px 0px 2px 15px;
}
.two .jrpgstat .body .stats .skills .capacities .capacity.active::before {
  border: 2px solid #fff;
  background: linear-gradient(0deg, rgb(74, 74, 74) 0%, rgb(185, 185, 185) 100%);
}
.two .jrpgstat .body .stats .skills .capacities .capacity img {
  height: 20px;
  margin-left: -7%;
  position: relative;
  z-index: 1;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity img {
    height: 30px;
    margin-left: -3%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity img {
    margin-left: -1%;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity .valueName {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  bottom: 0;
  margin-left: 2px;
  font-size: 11px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity .valueName {
    font-size: 15px;
    margin-left: 15px;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  top: 0;
  bottom: 0;
  right: 19%;
  z-index: 2;
  flex-basis: 30%;
  height: 12px;
  border-radius: 15px;
  background: rgb(74, 74, 74);
  border: 2px solid #fff;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity .bar {
    right: 22%;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #000;
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background: linear-gradient(90deg, rgb(9, 9, 121) 0%, rgb(0, 212, 255) 100%);
  transform-origin: left center;
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.zero::after {
  transform: scaleX(0);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.five::after {
  transform: scaleX(0.2);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.ten::after {
  transform: scaleX(0.4);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.fiveteen::after {
  transform: scaleX(0.6);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.twenty::after {
  transform: scaleX(0.8);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .bar.twentyfive::after {
  transform: scaleX(1);
}
.two .jrpgstat .body .stats .skills .capacities .capacity .value {
  position: absolute;
  margin-right: 2%;
  top: 25%;
  right: 0;
  font-size: 8px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .stats .skills .capacities .capacity .value {
    font-size: 15px;
  }
}
.two .jrpgstat .body .stats .skills .capacities .capacity.empty::before {
  background: none;
  border: none;
}

.two .jrpgstat .body .equipment {
  flex-basis: 100%;
  font-size: 10px;
  margin-top: 10%;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .equipment {
    margin-top: 5%;
    font-size: 14px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment {
    flex-basis: 40%;
    margin-top: 0;
    font-size: 13px;
  }
}
.two .jrpgstat .body .equipment h3 {
  width: 330px;
  display: flex;
  justify-content: center;
  flex-basis: 100%;
  margin: 0 0 15px 0;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment h3 {
    margin: 20px 0 20px 7%;
  }
}
.two .jrpgstat .body .equipment h3::before {
  content: "";
  width: 293px;
  height: 30px;
  position: absolute;
  background: #191825;
  border-radius: 25px;
  opacity: 0.7;
  z-index: -1;
  left: 8%;
  top: -6px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .equipment h3::before {
    left: 9%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .equipment h3::before {
    left: 11%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment h3::before {
    left: 8%;
    width: 320px;
    top: -4px;
  }
}
.two .jrpgstat .body .equipment h3.smallBack {
  width: 92px;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment h3.smallBack {
    width: 102px;
  }
}
.two .jrpgstat .body .equipment h3.smallBack::before {
  width: 90px;
  left: 8%;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .equipment h3.smallBack::before {
    left: 14%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .body .equipment h3.smallBack::before {
    left: 20%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment h3.smallBack::before {
    width: 92px;
    left: 22%;
  }
}
.two .jrpgstat .body .equipment .weapons {
  width: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  font-family: "Overpass";
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .equipment .weapons {
    width: 90%;
  }
}
.two .jrpgstat .body .equipment .weapons .weapon {
  margin: 10px 0 10px 0;
  flex-basis: 90%;
  height: 50px;
  border-radius: 5px;
  padding: 2px 0px 2px 2px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.two .jrpgstat .body .equipment .weapons .weapon::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(94, 94, 94) 100%);
  border: 1px solid black;
  border-radius: 5px;
  padding: 2px 0px 2px 15px;
}
.two .jrpgstat .body .equipment .weapons .weapon.active::before {
  border: 2px solid #fff;
  background: linear-gradient(0deg, rgb(74, 74, 74) 0%, rgb(185, 185, 185) 100%);
}
.two .jrpgstat .body .equipment .weapons .weapon .value {
  position: relative;
  z-index: 2;
  font-weight: bold;
  color: #fff;
  padding-left: 7px;
  display: inline-block;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .body .equipment .weapons .weapon .value {
    padding-left: 15px;
  }
}
.two .jrpgstat .body .equipment .weapons .weapon.active .value {
  color: #000;
}
.two .jrpgstat .body .equipment .weapons .weapon img {
  height: 40px;
  position: relative;
  z-index: 1;
}

.two .jrpgstat .body .stats .skills {
  flex-basis: 100%;
  height: 60%;
}
.two .jrpgstat .body .caracter {
  display: none;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .body .caracter {
    display: block;
    flex-basis: 20%;
    object-fit: cover;
    height: 100%;
  }
}
.two .jrpgstat .body .caracter img {
  width: 100%;
}

.two .jrpgstat .footer .others {
  flex-basis: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 5%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer .others {
    flex-basis: 35%;
    justify-content: space-around;
    margin-right: 0;
  }
}
.two .jrpgstat .footer .others h3 {
  position: relative;
  width: 200px;
  display: flex;
  justify-content: center;
}
.two .jrpgstat .footer .others h3::after {
  width: 100%;
  left: 5%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer .others h3 {
    width: 230px;
    left: 10%;
  }
}
.two .jrpgstat .footer .others h3::before {
  content: "";
  width: 180px;
  height: 30px;
  position: absolute;
  background: #191825;
  border-radius: 25px;
  opacity: 0.7;
  z-index: -1;
  left: 7%;
  top: -6px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .footer .others h3::before {
    left: 11%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .two .jrpgstat .footer .others h3::before {
    left: 14%;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer .others h3::before {
    width: 220px;
    top: -4px;
    left: 10%;
  }
}
.two .jrpgstat .footer .others .other {
  flex-basis: 33%;
  display: flex;
  justify-content: space-between;
  margin-left: 0%;
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer .others .other {
    margin-left: 10%;
    flex-basis: 27%;
  }
}
.two .jrpgstat .footer .others .other img {
  margin-left: 10px;
  height: 25px;
}
@media screen and (min-width: 768px) {
  .two .jrpgstat .footer .others .other img {
    margin-left: 25px;
    height: 50px;
  }
}
@media screen and (min-width: 1280px) {
  .two .jrpgstat .footer .others .other img {
    height: 50px;
  }
}

.four .form {
  display: flex;
  width: 100%;
  min-height: 100vh;
  font-family: "Roboto";
  color: #F0CAA3;
  font-weight: bolder;
  position: relative;
}
.four .form label {
  font-size: 15px;
}
@media screen and (min-width: 768px) {
  .four .form label {
    font-size: 20px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form label {
    font-size: 20px;
  }
}
.four .form .name, .four .form .email, .four .form .request {
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 1280px) {
  .four .form .name, .four .form .email, .four .form .request {
    display: block;
    flex-wrap: nowrap;
  }
}
.four .form input {
  background: none;
  border: none;
  border-bottom: 4px solid #F0CAA3;
  font-size: 15px;
}
@media screen and (min-width: 768px) {
  .four .form input {
    font-size: 25px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form input {
    font-size: 25px;
  }
}
.four .form input:focus {
  outline: none;
  border-bottom: 4px solid #FFA3FD;
  background-color: rgba(255, 255, 255, 0.2);
}
.four .form {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.four .form h2 {
  height: 20%;
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  margin-top: 45px;
}
@media screen and (min-width: 768px) {
  .four .form h2 {
    font-size: 70px;
    margin-top: -30px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form h2 {
    margin-top: 0;
    font-size: 70px;
  }
}
.four .form p {
  flex-basis: 80%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  margin-bottom: 40px;
}
@media screen and (min-width: 768px) {
  .four .form p {
    font-size: 22px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form p {
    font-size: 33px;
    margin-bottom: 0;
  }
}
.four .form .formInputs {
  flex-basis: 90%;
  height: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.four .form .formInputs .error {
  font-size: 13px;
  position: absolute;
  bottom: -20px;
  left: 0;
}
@media screen and (min-width: 768px) {
  .four .form .formInputs .error {
    font-size: 17px;
    bottom: -4%;
  }
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .four .form .formInputs .error {
    bottom: -22%;
  }
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .error {
    bottom: 10%;
    left: 50%;
    font-size: 18px;
  }
}
.four .form .formInputs .error.requestArea {
  bottom: -6%;
  left: 0;
}
@media screen and (min-width: 768px) {
  .four .form .formInputs .error.requestArea {
    bottom: -7%;
  }
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .error.requestArea {
    bottom: -15%;
  }
}
.four .form .formInputs .name, .four .form .formInputs .email {
  position: relative;
  height: 20%;
  display: flex;
  flex-basis: 100%;
  margin-bottom: 35px;
}
@media screen and (min-width: 1024px) and (min-height: 600px) {
  .four .form .formInputs .name, .four .form .formInputs .email {
    flex-basis: 48%;
  }
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .name, .four .form .formInputs .email {
    margin-bottom: 0;
    flex-basis: 45%;
  }
}
.four .form .formInputs .name input, .four .form .formInputs .email input {
  height: 50px;
  flex-basis: 100%;
  cursor: pointer;
  padding-left: 15px;
}
.four .form .formInputs .name inputfocus, .four .form .formInputs .email inputfocus {
  cursor: pointer;
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .name input, .four .form .formInputs .email input {
    flex-basis: 80%;
  }
}
.four .form .formInputs .request {
  position: relative;
  flex-basis: 100%;
  display: flex;
}
.four .form .formInputs .request label {
  flex-basis: 100%;
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .request label {
    flex-basis: 10%;
  }
}
.four .form .formInputs .request textarea {
  font-size: 15px;
  background: none;
  height: 300px;
  flex-basis: 100%;
  border: 4px solid #F0CAA3;
  vertical-align: sub;
  padding: 15px;
  resize: none;
  cursor: pointer;
  margin-top: 5px;
}
@media screen and (min-width: 768px) {
  .four .form .formInputs .request textarea {
    font-size: 25px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .request textarea {
    flex-basis: 90%;
    margin-top: 0;
    font-size: 25px;
  }
}
.four .form .formInputs .request textarea:focus {
  outline: none;
  border: 4px solid #FFA3FD;
  background-color: rgba(255, 255, 255, 0.2);
}
.four .form .formInputs .button-form {
  flex-basis: 100%;
  display: flex;
  justify-content: flex-end;
}
.four .form .formInputs .button-form button {
  flex-basis: 40%;
  background: none;
  border: 4px solid #F0CAA3;
  font-family: "Roboto";
  font-weight: bolder;
  font-size: 15px;
  height: 50px;
  color: #F0CAA3;
  margin-top: 25px;
  margin-bottom: 40px;
  padding: 10px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  z-index: 1;
}
@media screen and (min-width: 1280px) {
  .four .form .formInputs .button-form button {
    flex-basis: 20%;
    font-size: 20px;
    margin-bottom: 0;
  }
}
.four .form .formInputs .button-form button:hover {
  color: #191825;
}
.four .form .formInputs .button-form button:hover::after {
  opacity: 1;
  transform: scale(2, 6);
}
.four .form .formInputs .button-form button::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to right, rgb(91.3139087411%, 69.3091442184%, 46.7253069452%), rgb(100%, 43.9215686275%, 98.7809036658%));
  opacity: 0;
  z-index: -1;
  transform: scale(0, 0) rotate(90deg);
  transition: all 1000ms;
}
.four .form .response {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.four .form .response::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  opacity: 0.5;
  background: #000;
  width: 100%;
  height: 100%;
}
.four .form .response .window {
  position: fixed;
  width: 350px;
  height: 180px;
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 51;
  background: #9471fd;
  border: 4px solid #F0CAA3;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 768px) {
  .four .form .response .window {
    height: 200px;
    width: 400px;
  }
}
@media screen and (min-width: 1280px) {
  .four .form .response .window {
    height: 200px;
    width: 400px;
  }
}
.four .form .response .window .text {
  color: #F0CAA3;
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  padding-top: 70px;
}
.four .form .response .window button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 100px;
  height: 40px;
  border: none;
  border: 2px solid #F0CAA3;
  color: #F0CAA3;
  background: #9471fd;
  font-weight: bolder;
  cursor: pointer;
}

.five {
  font-size: 35px;
  font-weight: lighter;
  color: #F0CAA3;
  font-family: "Bahnschrift";
}
@media screen and (min-width: 1280px) {
  .five {
    right: 2%;
    top: 15px;
  }
}
.five .menu {
  padding-top: 5%;
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  background: #191825;
  z-index: 20;
}
.five .menu .menuSection {
  flex-basis: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 2%;
}
@media screen and (min-width: 1280px) {
  .five .menu .menuSection {
    flex-basis: 50%;
  }
}
.five .menu span {
  display: block;
  margin-bottom: 20px;
  font-size: 20px;
  padding-left: 20px;
  font-weight: bold;
  flex-basis: 100%;
}
@media screen and (min-width: 1280px) {
  .five .menu span {
    font-size: 35px;
    flex-basis: 50%;
    padding-left: 0;
  }
}
.five .menu .copyright {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4%;
}
.five .menu .copyright span {
  display: flex;
  justify-content: center;
  font-size: 15px;
}
@media screen and (min-width: 1280px) {
  .five .menu .copyright span {
    font-size: 25px;
  }
}
.five .menu ul {
  list-style: none;
  margin-left: 15px;
}
.five .menu ul li {
  margin-bottom: 20px;
}
.five .menu ul li a {
  position: relative;
  color: #F0CAA3;
  font-size: 20px;
}
@media screen and (min-width: 1280px) {
  .five .menu ul li a {
    font-size: 25px;
  }
}
.five .menu ul li a::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -10px;
  left: 0;
  background-color: #F0CAA3;
  transform-origin: top right;
  transition: transform 0.6s ease-out;
}
.five .menu ul li a:hover::after {
  transform: scaleX(1);
}
.five .menu ul li a::before {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  top: -11px;
  left: 0;
  background-color: #F0CAA3;
  transform-origin: bottom left;
  transition: transform 0.6s ease-out;
}
.five .menu ul li a:hover::before {
  transform: scaleX(1);
}
.five .menu ul .reversed a::after {
  transform-origin: bottom left;
}
.five .menu ul .reversed a::before {
  transform-origin: top right;
}
.five .menu ul.lang {
  display: flex;
  font-weight: bold;
  justify-content: space-around;
  flex-basis: 100%;
}
.five .menu ul.lang li {
  cursor: pointer;
  font-size: 15px;
  color: #F0CAA3;
}
@media screen and (min-width: 1280px) {
  .five .menu ul.lang li {
    font-size: 20px;
  }
}
.five .menu ul.lang li.activated {
  color: #FFA3FD;
  text-decoration: overline;
}
.five .sousMenu {
  margin-left: 25px;
  position: relative;
}
.five .sousMenu::before {
  content: "";
  width: 10px;
  height: 10px;
  border-left: 2px solid #F0CAA3;
  border-bottom: 2px solid #F0CAA3;
  position: absolute;
  left: -15px;
  top: 10px;
}
.five .logo {
  color: #9471fd;
  font-size: 25px;
  margin-top: 15px;
  height: 160px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 228px;
}
@media screen and (min-width: 1280px) {
  .five .logo {
    width: 325px;
    font-size: 37px;
  }
}
.five .logo .image {
  width: 70px;
  height: 70px;
  position: relative;
  left: 40%;
  margin-bottom: 5px;
}
.five .logo .image::before {
  content: "";
  position: absolute;
  top: 62px;
  left: -52px;
  width: 55px;
  height: 3px;
  background: #9471fd;
}
.five .logo .image::after {
  content: "";
  position: absolute;
  top: 62px;
  left: 60px;
  width: 55px;
  height: 3px;
  background: #9471fd;
}
.five .logo .text {
  position: relative;
}
.five .logo .text .name {
  font-family: "BrunoAce";
  flex-basis: 100%;
}
.five .logo .text .name::before {
  content: "";
  width: 250px;
  height: 3px;
  background: #9471fd;
  position: absolute;
  top: 0px;
  left: -12px;
}
@media screen and (min-width: 1280px) {
  .five .logo .text .name::before {
    width: 350px;
  }
}
.five .logo .text .function {
  font-stretch: condensed;
  font-weight: 100;
  position: absolute;
  top: 27px;
  width: 228px;
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 1280px) {
  .five .logo .text .function {
    width: 325px;
    top: 37px;
  }
}

.lapantherePresentation {
  color: #9471fd;
  display: flex;
  flex-wrap: wrap;
}
.lapantherePresentation h1 {
  color: #FFA3FD;
  font-size: 40px;
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
@media screen and (min-width: 768px) {
  .lapantherePresentation h1 {
    font-size: 50px;
  }
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation h1 {
    font-size: 70px;
    margin-top: 0;
  }
}
.lapantherePresentation h2 {
  margin-bottom: 15px;
}
.lapantherePresentation .back {
  position: relative;
  flex-basis: 80%;
  margin-top: 20px;
}
.lapantherePresentation .back a {
  color: #F0CAA3;
  font-size: 15px;
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation .back a {
    font-size: 20px;
  }
}
.lapantherePresentation .back a .arrow {
  width: 15px;
  height: 15px;
  border-top: 3px solid #F0CAA3;
  border-left: 3px solid #F0CAA3;
  transform: rotate(-45deg);
  position: absolute;
  top: 1px;
  left: -15px;
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation .back a .arrow {
    top: 3px;
  }
}
.lapantherePresentation p {
  margin: 25px;
  font-size: 18px;
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation p {
    margin: 70px;
    font-size: 25px;
  }
}
.lapantherePresentation .avant, .lapantherePresentation .apres {
  flex-basis: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation .avant, .lapantherePresentation .apres {
    flex-basis: 30%;
    margin-bottom: 0;
  }
}
.lapantherePresentation .avant img, .lapantherePresentation .apres img {
  max-width: 500px;
  width: 100%;
}
@media screen and (min-width: 1280px) {
  .lapantherePresentation .avant img, .lapantherePresentation .apres img {
    width: 100%;
  }
}
.lapantherePresentation .rapport {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 40px;
}
.lapantherePresentation .rapport h2 {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
}
.lapantherePresentation .rapport a {
  color: #F0CAA3;
  font-size: 20px;
}

.administration {
  margin-top: 50px;
  padding: 15px 0 50px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #F0CAA3;
  border: 2px solid #F0CAA3;
  border-radius: 15px;
  position: relative;
}
.administration input[type=text] {
  height: 35px;
  background-color: transparent;
  border: 2px solid #F0CAA3;
  border-radius: 10px;
  color: #F0CAA3;
  font-size: 1rem;
  padding-left: 5px;
}
.administration input[type=text]:focus {
  outline: none;
}
.administration .textarea {
  resize: none;
  font-family: "Bahnschrift";
  background-color: transparent;
  border: 2px solid #F0CAA3;
  border-radius: 10px;
  color: #F0CAA3;
  padding-left: 5px;
  padding-top: 5px;
  font-size: 1.2rem;
  font-weight: 100;
}
.administration .textarea:focus {
  outline: none;
}
.administration .text-description {
  height: 250px;
}
.administration .text-technologies {
  height: 150px;
}
.administration .admin-categories {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  width: 100%;
}
.administration .admin-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
  background-color: #191825;
  min-height: 50px;
  border-radius: 15px;
  margin: 10px 0;
  border: 2px solid #F0CAA3;
  padding-top: 10px;
  position: relative;
}
.administration .admin-panel h2 {
  margin-bottom: 10px;
}
.administration .admin-panel .presentation {
  display: flex;
  flex-direction: row;
  margin: 20px;
}
.administration .admin-panel .presentation .presentation-text {
  background-color: transparent;
  border-radius: 15px;
  padding: 15px;
  margin: 10px;
  width: 33%;
  border: 2px solid #F0CAA3;
}
.administration .admin-panel .presentation .presentation-text h4 {
  margin-bottom: 10px;
}
.administration .contact-message {
  min-width: 670px;
  height: 450px;
  border-radius: 15px;
  padding: 15px;
  border: 2px solid #F0CAA3;
  font-size: 1.2rem;
  margin-left: 15px;
  margin-bottom: 10px;
}
.administration .contact-message .message-field {
  height: 230px;
  overflow-y: scroll;
}
.administration .no-new-message {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 150px;
  font-size: 2rem;
}
.administration .contact-sub-panel {
  display: flex;
  flex-direction: row;
  width: 90%;
  border: 2px solid #F0CAA3;
  border-radius: 15px;
  padding: 10px 0 10px 0;
  margin: 10px;
  overflow-x: scroll;
}
.administration .devStat-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.administration .devStat {
  width: 20%;
  background-color: transparent;
  border-radius: 10px;
  min-width: 300px;
  margin: 10px;
  padding-left: 10px;
  padding-right: 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #F0CAA3;
  border: 2px solid #F0CAA3;
  cursor: pointer;
}
.administration .devStat .index-image {
  display: flex;
  align-items: center;
}
.administration .devStat.selected {
  background-color: #F0CAA3;
  color: #191825;
}
.administration .devStat.newSelected {
  background-color: greenyellow;
  color: #191825;
}
.administration .weapon-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.administration .weapon {
  width: 90%;
  background-color: transparent;
  border-radius: 10px;
  min-width: 300px;
  margin: 10px 0 10px 0;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #F0CAA3;
  border: 2px solid #F0CAA3;
  padding: 10px;
  cursor: pointer;
}
.administration .weapon .index-image {
  display: flex;
  align-items: center;
}
.administration .weapon.selected {
  background-color: #F0CAA3;
  color: #191825;
}
.administration .weapon.newSelected {
  background-color: greenyellow;
  color: #191825;
}
.administration .weapon-box {
  display: flex;
  flex-direction: row;
}
.administration .weapon-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  border: 2px solid #F0CAA3;
  border-radius: 10px;
  overflow-y: scroll;
  height: 525px;
}
.administration .weapon-options {
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 30%;
  align-items: center;
  justify-content: flex-start;
  height: 300px;
}
.administration .weapon-options div {
  width: 90%;
  display: flex;
  justify-content: space-between;
}
.administration .weapon-options div label {
  padding-top: 10px;
}
.administration .weapon-options input[type=text] {
  width: 270px;
}
.administration .admin-sub-panel {
  display: flex;
  flex-direction: column;
  width: 90%;
  border: 2px solid #F0CAA3;
  border-radius: 15px;
  padding: 10px;
  margin: 10px;
}
.administration .project-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: scroll;
}
.administration .project-list .project {
  background-color: transparent;
  border-radius: 10px;
  min-width: 400px;
  margin: 15px;
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #F0CAA3;
  border: 2px solid #F0CAA3;
  cursor: pointer;
}
.administration .project-list .project .project-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 15px;
}
.administration .project-list .project .project-description {
  font-size: 1.1rem;
  margin-bottom: 15px;
}
.administration .project-list .project.selected {
  background-color: #F0CAA3;
  color: #191825;
}
.administration .project-list .project.newSelected {
  background-color: greenyellow;
  color: #191825;
}
.administration .project-option {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.administration .project-sub-option {
  width: 48%;
  margin-left: 1%;
  display: flex;
  flex-direction: column;
}
.administration .photo-field {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.administration .photo-option-presentation {
  display: flex;
  flex-direction: column;
}
.administration .photo-option-presentation label {
  margin-top: 5px;
  margin-bottom: 5px;
}
.administration .photo-option-presentation img {
  width: 200px;
  margin-bottom: 5px;
}
.administration .photo-option .button-field {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 0;
}
.administration .photo-option .button-field button {
  margin-left: 0;
  margin-right: 5px;
  width: 110px;
}
.administration .openClose, .administration .openCloseClose {
  font-size: 2rem;
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 5px;
}
.administration .openClose {
  rotate: -90deg;
}
.administration .openCloseClose {
  rotate: 90deg;
}
.administration .button-field {
  width: 100%;
  margin: 20px;
}
.administration .button-field button {
  margin-left: 15px;
}
.administration .option-field {
  margin: 20px;
  position: relative;
}
.administration .option-field img {
  position: absolute;
  top: 2px;
  left: -20px;
}
.administration .option-field .textfield {
  margin-left: 15px;
  border: 2px solid #F0CAA3;
  background-color: transparent;
  height: 35px;
  width: 250px;
  border-radius: 10px;
  color: #F0CAA3;
  font-size: 1.2rem;
  font-weight: bold;
  padding-left: 10px;
}
.administration .option-field .textfield:focus {
  outline: none;
}
.administration .option-field .numberfield {
  margin-left: 15px;
  height: 35px;
  padding-left: 10px;
  padding-right: 5px;
  background-color: transparent;
  border: 2px solid #F0CAA3;
  color: #F0CAA3;
  font-size: 1.2rem;
  border-radius: 10px;
}
.administration .option-field .numberfield:focus {
  outline: none;
}
.administration .option-field .filefield {
  margin-left: 15px;
  height: 35px;
  padding-left: 10px;
  padding-right: 5px;
  background-color: transparent;
  color: #F0CAA3;
  font-size: 1.2rem;
  border-radius: 10px;
}
.administration input::file-selector-button {
  height: 35px;
  background-color: transparent;
  border: 2px solid #F0CAA3;
  color: #F0CAA3;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
}
.administration input::file-selector-button:hover {
  background-color: #F0CAA3;
  color: #191825;
}
.administration .language-selector {
  display: flex;
  flex-direction: row;
}
.administration .language-selector .language {
  cursor: pointer;
}

.button-alert {
  cursor: pointer;
  width: 150px;
  height: 50px;
  border: 2px solid #F0CAA3;
  border-radius: 10px;
  background-color: transparent;
  color: #F0CAA3;
  font-family: "Bahnschrift";
  font-size: 1.2rem;
}
.button-alert:hover {
  background-color: #F0CAA3;
  color: #191825;
}
.button-alert.delete {
  background-color: rgb(185, 49, 49);
  color: #191825;
}
.button-alert.delete:hover {
  background-color: rgb(255, 104, 104);
  color: #000;
}

.admin-navigation {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 15px;
  left: 15px;
}
.admin-navigation-button {
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
  color: #F0CAA3;
}
.admin-navigation-button:hover {
  text-decoration: underline;
}

select {
  cursor: pointer;
}

option {
  background-color: #191825;
}

.top {
  rotate: 90deg;
}

.bottom {
  rotate: -90deg;
}

.devstat-selector {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
}
.devstat-selector .devstat-input {
  width: 30% !important;
}

.empty-alert-box {
  display: none;
}

.alert-box {
  position: absolute;
  display: inline-block;
  top: 0;
  left: 0;
  opacity: 1;
  width: 100%;
  height: 100%;
  font-family: "Bahnschrift";
}
.alert-box::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  font-size: 1.2rem;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: black;
  opacity: 0.8;
}
.alert-box .alert-box-title {
  padding-left: 15px;
  padding-top: 15px;
  font-size: 1.5rem;
  font-weight: bold;
}
.alert-box .alert-box-message {
  display: flex;
  justify-content: center;
  margin: 20px;
  font-size: 1.2rem;
}
.alert-box .alert-box-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.alert-box-success {
  padding: 15px;
  border-radius: 10px;
  margin: 20px 0;
  background-color: #191825;
  color: #F0CAA3;
  border: 2px solid #F0CAA3;
  position: sticky;
  top: 40%;
  left: 50%;
  translate: -50%;
  z-index: 11;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 600px;
}
.alert-box-error {
  padding: 15px;
  border-radius: 10px;
  background-color: #f8d7da;
  color: #721c24;
  border: 2px solid #f5c6cb;
}

.cookies {
  font-family: "Bahnschrift";
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.cookies__panel {
  width: 700px;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  border: 2px solid #F0CAA3;
  border-radius: 15px;
  background-color: #191825;
  color: #F0CAA3;
}
.cookies__panel .lang-choice {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.cookies__panel .lang-choice .lang {
  margin-left: 5px;
  cursor: pointer;
}
.cookies button {
  margin-left: 15px;
  margin-top: 15px;
}
.cookies::before {
  content: "";
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 50%;
  z-index: 10;
}

.cookie-button-open {
  position: absolute;
  font-family: "Bahnschrift";
  bottom: -2px;
  left: 10px;
  width: 160px;
  height: 50px;
  color: #FFA3FD;
  background-color: #191825;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px 15px 0 0;
  margin-left: 20px;
  font-weight: bold;
  border: 2px solid #F0CAA3;
  z-index: 10;
}
.cookie-button-open:hover {
  cursor: pointer;
  color: #191825;
  background-color: #F0CAA3;
  border: 2px solid #FFA3FD;
}`, "",{"version":3,"sources":["webpack://./src/styles/utils/_typographies.scss","webpack://./src/styles/style.scss","webpack://./src/styles/utils/_keyframes.scss","webpack://./src/styles/bases/_body.scss","webpack://./src/styles/utils/_variables.scss","webpack://./src/styles/utils/_mixins.scss","webpack://./src/styles/layouts/_header.scss","webpack://./src/styles/layouts/_footer.scss","webpack://./src/styles/layouts/_logo.scss","webpack://./src/styles/layouts/_menu.scss","webpack://./src/styles/layouts/_scroller.scss","webpack://./src/styles/layouts/_introduction.scss","webpack://./src/styles/layouts/_jrpg.scss","webpack://./src/styles/layouts/_prePortfolio.scss","webpack://./src/styles/layouts/_notFound.scss","webpack://./src/styles/layouts/_forms.scss","webpack://./src/styles/components/_freeSpace.scss","webpack://./src/styles/components/_button.scss","webpack://./src/styles/components/_slidinText.scss","webpack://./src/styles/components/_textCode.scss","webpack://./src/styles/components/_imageSample.scss","webpack://./src/styles/components/_triplePhoto.scss","webpack://./src/styles/components/jrpg/_jrpgHeader.scss","webpack://./src/styles/components/jrpg/_jrpgPlayerHead.scss","webpack://./src/styles/components/jrpg/_jrpgCapacities.scss","webpack://./src/styles/components/jrpg/_jrpgWeapons.scss","webpack://./src/styles/components/jrpg/_jrpgFullBody.scss","webpack://./src/styles/components/jrpg/_jrpgLangages.scss","webpack://./src/styles/components/_contactForm.scss","webpack://./src/styles/components/_presentationFooter.scss","webpack://./src/styles/components/_lapanthere.scss","webpack://./src/styles/components/_administration.scss","webpack://./src/styles/components/_alertBox.scss","webpack://./src/styles/components/_cookies.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,4CAAA;ACCJ;ADEA;EACI,oBAAA;EACA,4CAAA;ACAJ;ADGA;EACI,0BAAA;EACA,4CAAA;ACDJ;ADIA;EACI,uBAAA;EACA,4CAAA;ACFJ;ADKA;EACI,2BAAA;EACA,4CAAA;ACHJ;ADMA;EACI,uBAAA;EACA,4CAAA;ACJJ;ACvBA;EACI;IACI,wBAAA;EDyBN;ECtBE;IACI,6BAAA;EDwBN;AACF;ACrBA;EACI;IACI,UAAA;IACA,mBAAA;EDuBN;ECpBE;IACI,UAAA;IACA,mBAAA;EDsBN;AACF;ACnBA;EACI;IACI,UAAA;IACA,mBAAA;EDqBN;EClBE;IACI,UAAA;IACA,mBAAA;EDoBN;AACF;ACjBA;EACI;IACI,SAAA;IACA,oBAAA;IACA,UAAA;EDmBN;EChBE;IACI,qBAAA;EDkBN;ECfE;IACI,OAAA;IACA,oBAAA;EDiBN;ECdE;IACI,qBAAA;EDgBN;ECbE;IACI,SAAA;IACA,oBAAA;EDeN;ECZE;IACI,qBAAA;EDcN;ECXE;IACI,OAAA;IACA,oBAAA;EDaN;ECVE;IACI,qBAAA;EDYN;ECTE;IACI,SAAA;IACA,oBAAA;EDWN;ECRE;IACI,qBAAA;IACA,YAAA;EDUN;ECPE;IACI,OAAA;IACA,oBAAA;IACA,UAAA;EDSN;ECNE;IACI,UAAA;EDQN;AACF;ACLA;EACI;IACI,YAAA;IACA,oBAAA;IACA,UAAA;EDON;ECJE;IACI,qBAAA;EDMN;ECHE;IACI,UAAA;IACA,oBAAA;EDKN;ECFE;IACI,qBAAA;EDIN;ECDE;IACI,YAAA;IACA,oBAAA;EDGN;ECAE;IACI,qBAAA;EDEN;ECCE;IACI,UAAA;IACA,oBAAA;EDCN;ECEE;IACI,qBAAA;EDAN;ECGE;IACI,YAAA;IACA,oBAAA;EDDN;ECIE;IACI,qBAAA;IACA,YAAA;EDFN;ECKE;IACI,UAAA;IACA,oBAAA;IACA,UAAA;EDHN;ECME;IACI,UAAA;EDJN;AACF;ACOA;EAEI;IACI,8BAAA;IACA,uBAAA;EDNN;ECSE;IACI,iEAAA;EDPN;AACF;ACWA;EAEI;IACI,iEAAA;EDVN;ECaE;IACI,8BAAA;IACA,uBAAA;EDXN;AACF;ACeA;EAEI;IACI,6BAAA;IACA,uBAAA;EDdN;ECgBE;IACI,+CAAA;EDdN;AACF;ACkBA;EAEI;IACI,+CAAA;EDjBN;ECoBE;IACI,6BAAA;IACA,uBAAA;EDlBN;AACF;ACuBA;EACI;IACI,2BAAA;EDrBN;ECwBE;IACI,2BAAA;EDtBN;ECwBE;IACI,2BAAA;EDtBN;AACF;ACyBA;EACI;IACI,2BAAA;EDvBN;EC0BE;IACI,2BAAA;EDxBN;EC0BE;IACI,2BAAA;EDxBN;AACF;AE3MA;EAEI,UAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;AF4MJ;;AEzMA;EAEI,qBAAA;AF2MJ;;AExMA;EAEI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AF0MJ;AExMI;EAEI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBC7BS;ED8BT,0BAAA;AFyMR;AEvMQ;EAEI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AFwMZ;AI9OI;EF2BI;IAeQ,WAAA;EFwMd;AACF;AIzPI;EFiCI;IAoBQ,UAAA;EFwMd;AACF;AEtMY;EAEI,gBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,qBAAA;AFuMhB;AI/PI;EFkDQ;IAUQ,WAAA;EFuMlB;AACF;AI1QI;EFwDQ;IAeQ,UAAA;EFuMlB;AACF;;AEjMA;EACI,kBAAA;AFoMJ;;AKpRA;EAEI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,UAAA;ALsRJ;AKpRI;EAEI,WAAA;EACA,UF6CW;EE5CX,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBFfQ;EEgBR,WAAA;ALqRR;;AMzSA;EAEI,aAAA;EACA,mBAAA;EACA,mBHFa;EGGb,iBAAA;EACA,sBAAA;EACA,cHHY;EGIZ,iBAAA;EACA,4BAAA;EACA,kBAAA;AN2SJ;AMzSI;EAEI,WAAA;AN0SR;AMvSI;EAEI,sBAAA;ANwSR;AMrSI;EAEI,WAAA;EACA,UH+BW;EG9BX,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBH7BQ;AHmUhB;;AMlSA;EACI,cHhCa;EGiCb,gBAAA;EACA,eAAA;ANqSJ;;AO7UA;EAEI,0BAAA;AP+UJ;AO7UI;EAEI,cJFQ;EIGR,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AP8UR;AIzVI;EGGA;IAaQ,eAAA;EP6UV;AACF;AO3UQ;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AP4UZ;AO1UY;EAEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBJhCA;AH2WhB;AOxUY;EAEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,mBJ3CA;AHoXhB;AOrUQ;EAEI,kBAAA;APsUZ;AOpUY;EAEI,uBAAA;EACA,gBAAA;APqUhB;AOnUgB;EAEI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBJ7DJ;EI8DI,kBAAA;EACA,QAAA;EACA,WAAA;APoUpB;AIvYI;EG2DY;IAYQ,YAAA;EPoUtB;AACF;AOhUY;EAEI,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;APiUhB;AIrZI;EG4EQ;IAYQ,YAAA;IACA,SAAA;EPiUlB;AACF;;AQ5ZA;EAEI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;AR8ZJ;AItaI;EIDJ;IAaQ,SAAA;IACA,SAAA;ER8ZN;AACF;AQ5ZI;EAEI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AR6ZR;AQzZY;EAGY,mDAAA;AR0ZxB;AQvZY;EAGY,sDAAA;ARwZxB;AQlZY;EAGI,wDAAA;ARmZhB;AQhZY;EAGI,2DAAA;ARiZhB;AQ7YQ;EAEI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBLvDM;EKwDN,kBAAA;EACA,MAAA;EACA,OAAA;AR8YZ;AQ3YQ;EAEI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBLlEM;EKmEN,kBAAA;EACA,SAAA;EACA,UAAA;AR4YZ;AQxYI;EAEI,kBAAA;EACA,UAAA;EACA,UAAA;ARyYR;AQvYQ;EAEI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBLzFK;EK0FL,WAAA;ARwYZ;AQtYY;EAEI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ARuYhB;AQjYQ;EAEI,gBAAA;EACA,iBAAA;ARkYZ;AQhYY;EAEI,mBAAA;ARiYhB;AQ/XgB;EAEI,kBAAA;EACA,cL/GH;EKgHG,eAAA;ARgYpB;AQ9XoB;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,yBL3HP;EK4HO,2BAAA;EACA,mCAAA;AR+XxB;AQ5XoB;EAEI,oBAAA;AR6XxB;AQ1XoB;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;EACA,yBL9IP;EK+IO,6BAAA;EACA,mCAAA;AR2XxB;AQxXoB;EAEI,oBAAA;ARyXxB;AQjXoB;EAEI,6BAAA;ARkXxB;AQ/WoB;EAEI,2BAAA;ARgXxB;AQ1WQ;EAEI,aAAA;EACA,iBAAA;EACA,8BAAA;AR2WZ;AQxWY;EAEI,eAAA;EACA,eAAA;EACA,cLrLC;AH8hBjB;AQtWY;EAEI,cL3LE;EK4LF,yBAAA;ARuWhB;AQlWI;EAEI,iBAAA;EACA,kBAAA;ARmWR;AQjWQ;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ARkWZ;;AQxVQ;EAEI,mBL5NI;AHsjBhB;AQtVQ;EAEI,mBLlOI;AHyjBhB;;AQ7UQ;EAEI,mBL5OK;AH2jBjB;AQ3UQ;EAEI,mBLlPK;AH8jBjB;;AQlUQ;EAEI,mBL9PK;AHkkBjB;AQhUQ;EAEI,mBLpQK;AHqkBjB;;AS3kBA;EAEI,kBAAA;EAEA,6BAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AT6kBJ;AIplBI;EKDJ;IAiBQ,6BAAA;IACA,eAAA;ETykBN;AACF;ASvkBI;EAEI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;ATwkBR;AS5jBI;EAEI,mBNxCS;EMyCT,kBAAA;EACA,iBAAA;AT6jBR;AS1jBI;EAEI,gBAAA;AT2jBR;ASxjBI;EAEA,mBNhDa;AHymBjB;AStjBI;EAEA,mBNvDY;AH8mBhB;ASpjBI;EAEI,mBN9DS;AHmnBjB;;AUrnBA;EAEI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;AVunBJ;AI9nBI;EMSA;IAIQ,WAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,OAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,mCAAA;IACA,oCAAA;IACA,8BAAA;IAEQ,8DAAA;EVqnBlB;AACF;AIjpBI;EMgCA;IAIQ,WAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,OAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,mCAAA;IACA,oCAAA;IACA,8BAAA;IAEQ,6DAAA;EVinBlB;AACF;AU7mBI;EAEI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AV8mBR;AIrqBI;EMiDA;IAUQ,eAAA;EV8mBV;AACF;AIpqBI;EM2CA;IAeQ,eAAA;EV8mBV;AACF;AIrrBI;EMuDA;IAoBQ,eAAA;EV8mBV;AACF;AU5mBQ;EAEI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,cPhFM;EOiFN,gBAAA;EACA,aAAA;EACA,uBAAA;AV6mBZ;AI9rBI;EMwEI;IAaQ,gBAAA;IACA,iBAAA;IACA,sBAAA;EV6mBd;AACF;AI/rBI;EMkEI;IAoBQ,gBAAA;IACA,gBAAA;EV6mBd;AACF;AIjtBI;EM8EI;IA0BQ,cAAA;IACA,cAAA;EV6mBd;AACF;AU1mBQ;EAEI,gBAAA;EACA,cP3GK;EO4GL,kBAAA;EACA,aAAA;EACA,uBAAA;AV2mBZ;AIxtBI;EMuGI;IAUQ,cAAA;IACA,sBAAA;IACA,wBAAA;EV2mBd;AACF;AIztBI;EMiGI;IAiBQ,gBAAA;IACA,qBAAA;EV2mBd;AACF;AI3uBI;EM6GI;IAuBQ,gBAAA;IACA,qBAAA;EV2mBd;AACF;AUxmBQ;EAEI,cAAA;EACA,cPzII;EO0IJ,aAAA;AVymBZ;AIhvBI;EMmII;IAQQ,gBAAA;EVymBd;AACF;AI/uBI;EM6HI;IAaQ,aAAA;IACA,gBAAA;EVymBd;AACF;AIjwBI;EMyII;IAmBQ,aAAA;IACA,gBAAA;EVymBd;AACF;AUtmBQ;EAEI,gBAAA;AVumBZ;AIpwBI;EM2JI;IAKQ,eAAA;EVwmBd;AACF;AI/wBI;EM0KI;IAIQ,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,mCAAA;IACA,oCAAA;IACA,+BAAA;IACA,wBAAA;EVqmBd;AACF;AI9xBI;EM4LI;IAIQ,WAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,mCAAA;IACA,oCAAA;IACA,+BAAA;IACA,wBAAA;EVkmBd;AACF;AU9lBI;EAEI,gBAAA;EACA,YAAA;EACA,mBPhNQ;EOiNR,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AV+lBR;AU3lBY;EAEI,aAAA;EACA,sBAAA;AV4lBhB;AU1lBgB;EAEI,eAAA;AV2lBpB;AUtlBQ;EAEI,kBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AVulBZ;AUplBQ;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBPtPK;EOuPL,QAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EAEA,6CAAA;AVqlBZ;AUllBQ;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBPvQK;EOwQL,WAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EAEQ,gDAAA;AVmlBpB;;AWp2BA;EAEI,eAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AXs2BJ;AWp2BI;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;AXq2BR;AWn2BQ;EAEI,YAAA;EACA,kBAAA;AXo2BZ;AWh2BI;EAEI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AXi2BR;AI33BI;EOqBA;IASQ,iBAAA;IACA,gBAAA;EXi2BV;AACF;AW/1BQ;EAEI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;AXg2BZ;AI34BI;EOkCI;IAYQ,QAAA;EXi2Bd;AACF;AW71BI;EAEI,eAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AX81BR;AIz5BI;EOmDA;IAYQ,eAAA;IACA,gBAAA;IACA,gBAAA;EX81BV;AACF;AW31BI;EAEI,WAAA;EACA,eAAA;EACA,yJAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AX41BR;AWz1BI;EAEI,aAAA;EACA,eAAA;AX01BR;AWx1BQ;EAEI,gBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AXy1BZ;AIt7BI;EOuFI;IAUQ,YAAA;EXy1Bd;AACF;AWr1BgB;EAEI,kBAAA;AXs1BpB;AWj1BQ;EAEI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AXk1BZ;AIr8BI;EO6GI;IAUQ,YAAA;EXk1Bd;AACF;AWh1BY;EAEI,gBAAA;EACA,aAAA;EACA,eAAA;AXi1BhB;AI/8BI;EO0HQ;IAQQ,eAAA;EXi1BlB;AACF;AW/0BgB;EAEI,gBAAA;EACA,YAAA;AXg1BpB;AIx9BI;EOqIY;IAOQ,WAAA;EXg1BtB;AACF;AW30BQ;EAEI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AX40BZ;AIp+BI;EOkJI;IAUQ,YAAA;EX40Bd;AACF;;AY1+BA;EAEI,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AZ4+BJ;AY1+BI;EAEI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;AZ2+BR;AIv/BI;EQEA;IAcQ,eAAA;IACA,kBAAA;EZ2+BV;AACF;AIngCI;EQQA;IAmBQ,aAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EZ4+BV;AACF;AYz+BI;EAEI,mBTnCS;AH6gCjB;AYv+BI;EAEI,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;AZw+BR;AI1hCI;EQuCA;IAeQ,aAAA;IACA,gBAAA;IACA,eAAA;IACA,QAAA;EZw+BV;AACF;AYt+BQ;EAEI,cT3DI;ES4DJ,eAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;AZu+BZ;AIpiCI;EQsDI;IAWQ,eAAA;IACA,kBAAA;EZu+Bd;AACF;AIhjCI;EQ4DI;IAiBQ,aAAA;IACA,gBAAA;IACA,eAAA;EZu+Bd;EYr+Bc;IAEI,WAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;EZs+BlB;EYn+Bc;IAEI,WAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;EZo+BlB;AACF;AYh+BQ;EAEI,cT9GK;ES+GL,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AZi+BZ;AI/kCI;EQuGI;IAWQ,eAAA;IACA,kBAAA;EZi+Bd;AACF;AI3lCI;EQ6GI;IAiBQ,eAAA;IACA,aAAA;EZi+Bd;EY/9Bc;IAEI,WAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;EZg+BlB;EY79Bc;IAEI,WAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;EZ89BlB;AACF;AY19BQ;EAEI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AZ29BZ;AIznCI;EQuJI;IAWQ,kBAAA;EZ29Bd;AACF;AIpoCI;EQ6JI;IAgBQ,aAAA;EZ29Bd;AACF;AYz9BY;EAEI,eAAA;EACA,kBAAA;AZ09BhB;AI7oCI;EQgLQ;IAOQ,eAAA;IACA,mBAAA;EZ09BlB;AACF;AYx9BgB;EAEI,YAAA;EACA,mBAAA;EACA,cT3LF;ES4LE,mBT/LH;ESgMG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AZy9BpB;AIxpCI;EQqLY;IAcQ,YAAA;IACA,eAAA;EZy9BtB;AACF;AIpqCI;EQ2LY;IAoBQ,YAAA;IACA,mBAAA;IACA,eAAA;EZy9BtB;AACF;AYv9BoB;EAEI,iBAAA;EACA,8BAAA;EACA,gDAAA;AZw9BxB;AYj9BI;EAEI,eAAA;AZk9BR;AI7qCI;EQyNA;IAMQ,kBAAA;EZk9BV;AACF;AIxrCI;EQ+NA;IAWQ,gBAAA;EZk9BV;AACF;;Aa7rCI;EAEI,cVCQ;AH8rChB;Aa7rCQ;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;Ab+rCZ;AInsCI;ESFI;IASQ,gBAAA;IACA,gBAAA;EbgsCd;AACF;AI/sCI;ESII;IAcQ,gBAAA;IACA,gBAAA;EbisCd;AACF;Aa9rCQ;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AbgsCZ;AIvtCI;ESiBI;IAUQ,eAAA;EbgsCd;AACF;AIluCI;ESuBI;IAeQ,eAAA;EbgsCd;AACF;Aa7rCQ;EACI,cVtCK;EUuCL,eAAA;Ab+rCZ;;Aa1rCA;EACI,iBAAA;EACA,cV9Ca;AH2uCjB;;AcjvCA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,cXDc;EWEd,iBAAA;EACA,gBAAA;AdmvCJ;AcjvCI;EACI,aAAA;AdmvCR;AchvCI;EACI,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,uBAAA;AdkvCR;AchvCQ;EACI,oCAAA;AdkvCZ;Ac9uCI;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,cXhCS;EWiCT,eAAA;AdgvCR;Ac9uCQ;EACI,yBXpCK;EWqCL,WXxCQ;EWyCR,eAAA;AdgvCZ;;AczuCI;EACI,sBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;Ad4uCR;AczuCI;EACI,4BAAA;EACA,4BAAA;EACA,uBAAA;Ad2uCR;AczuCQ;EACI,qCAAA;EACA,2BAAA;Ad2uCZ;AcvuCI;EACI,wBAAA;EACA,YAAA;EACA,0BAAA;AdyuCR;AcvuCQ;EACI,qCAAA;AdyuCZ;;AcpuCA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AduuCJ;;AcpuCA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AduuCJ;;AcpuCA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AduuCJ;;Ae50CA;EAEI,SAAA;EACA,kBAAA;EACA,WAAA;Af80CJ;Ae50CI;EAEI,kBAAA;EACA,SAAA;Af60CR;;AgBt1CA;EAEI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;AhBw1CJ;AgBt1CI;EAEI,eAAA;EACA,oBAAA;AhBu1CR;AIj2CI;EYOA;IAWQ,eAAA;EhBm1CV;AACF;AgBh1CI;EAEI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBb5BQ;Ea6BR,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,WbjCY;EakCZ,+BAAA;EACA,qBAAA;EACA,kBAAA;AhBi1CR;AgB/0CQ;EAEI,2EAAA;AhBg1CZ;AI13CI;EYsBA;IA6BQ,eAAA;IACA,kBAAA;EhB20CV;AACF;AgBz0CQ;EAEI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;AhB00CZ;AgBv0CQ;EAEI,mBb5DK;Ea6DL,eAAA;AhBw0CZ;AgBt0CY;EACI,+DAAA;AhBw0ChB;AgBp0CQ;EAEI,cb1EK;Ea2EL,mBbxEM;AH64ClB;AgBn0CY;EACI,qDAAA;AhBq0ChB;AgBj0CQ;EAEI,mBbpFK;EaqFL,cbnFI;EaoFJ,mBAAA;AhBk0CZ;;AiB15CA;EAGI,gBAAA;EACA,kBAAA;EACA,UdmDe;EclDf,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AjB25CJ;AiBz5CI;EAIY,yCAAA;AjBy5ChB;AiBv5CQ;EAEI,eAAA;EACA,YAAA;EACA,cdjBI;EckBJ,oBAAA;AjBw5CZ;AiBp5CQ;EAEI,eAAA;EACA,kBAAA;EACA,QAAA;AjBq5CZ;AiBl5CQ;EAEI,kBAAA;EACA,gCAAA;AjBm5CZ;AiB14CQ;EAEI,iDAAA;AjB24CZ;AiBz4CY;EACI,cd5CC;AHu7CjB;AiBx4CY;EAEI,kBAAA;EACA,gCAAA;AjBy4ChB;;AkBj8CA;EAEI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,uBAAA;EAEQ,mDAAA;EACR,eAAA;EACA,yBAAA;AlBm8CJ;AIx8CI;EcPJ;IAgBQ,eAAA;ElBm8CN;AACF;AIv8CI;EcbJ;IAoBQ,eAAA;ElBo8CN;AACF;AIx9CI;EcDJ;IAyBQ,eAAA;ElBo8CN;AACF;AkBl8CI;EAEI,YAAA;EACA,mBf3BQ;Ee4BR,cf9BS;Ee+BT,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AlBm8CR;AIv+CI;Ec2BA;IAYQ,eAAA;IACA,4BAAA;IACA,YAAA;ElBo8CV;AACF;AkBj8CI;EAEI,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AlBk8CR;AkBh8CQ;EAEI,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AlBi8CZ;AkB77CI;EAEI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBfnES;EeoET,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AlB87CR;AkB37CK;EAEG,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cf3ES;Ee4ET,kBAAA;EACA,SAAA;EACA,WAAA;AlB47CR;AkBz7CI;EAGY,4CAAA;AlB07ChB;;AkBp7CI;EAEI,gBAAA;EACA,yBAAA;AlBs7CR;AIlhDI;EcyFA;IAOQ,eAAA;ElBs7CV;AACF;AIjhDI;EcmFA;IAWQ,eAAA;ElBu7CV;AACF;AIliDI;Ec+FA;IAgBQ,eAAA;ElBu7CV;AACF;AkBp7CI;EAEI,cflHQ;EemHR,cAAA;AlBq7CR;AIriDI;Ec6GA;IAMQ,gBAAA;ElBs7CV;AACF;AIhjDI;EcmHA;IAWQ,iBAAA;ElBs7CV;AACF;AkBn7CQ;EAEI,cfhIM;AHojDlB;AkBj7CQ;EAEI,gBAAA;AlBk7CZ;AI3jDI;EcuII;IAMQ,iBAAA;ElBk7Cd;AACF;;AkB36CI;EAEI,cfpJQ;EeqJR,gBAAA;AlB66CR;AI/jDI;Ec+IA;IAMQ,cAAA;ElB86CV;AACF;AI1kDI;EcqJA;IAWQ,gBAAA;ElB86CV;AACF;AkB56CQ;EAEI,cfjKM;AH8kDlB;AkB16CQ;EAEI,gBAAA;AlB26CZ;AI/kDI;EckKI;IAKQ,iBAAA;ElB46Cd;AACF;AI1lDI;EcwKI;IAUQ,iBAAA;ElB46Cd;AACF;;AmBhmDA;EAEI,aAAA;EACA,UAAA;EAEG,iBAAA;EACH,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBhBTa;EgBUb,yBAAA;EACA,4BAAA;AnBkmDJ;AI9mDI;EeDJ;IAqBQ,aAAA;IACA,UAAA;EnB8lDN;AACF;AmB5lDI;EAEI,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;AnB6lDR;AmB3lDQ;EAGI,iBAAA;EACA,WAAA;EACA,YAAA;AnB4lDZ;AmBxlDI;EAEI,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,chB9CS;EgB+CT,iBAAA;EACA,kBAAA;EACA,mBhB7CS;AHsoDjB;AmBvlDI;EAEI,UAAA;EAEQ,0DAAA;AnBwlDhB;AmBtlDQ;EAGY,4CAAA;AnBulDpB;AmBnlDI;EAEI,UAAA;EAEQ,0DAAA;AnBolDhB;AmBllDQ;EAGY,4CAAA;AnBmlDpB;AmB/kDI;EAEI,UAAA;EAEQ,yDAAA;AnBglDhB;AmB9kDQ;EAGY,4CAAA;AnB+kDpB;AmB3kDI;EAEI,kBAAA;EACA,SAAA;EACA,QAAA;AnB4kDR;AmBzkDI;EAEI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AnB0kDR;AmBtkDI;EAEI,kBAAA;EACA,UAAA;EACA,QAAA;AnBukDR;AmBpkDI;EAEI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBhBzHS;EgB0HT,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AnBqkDR;AmBlkDI;EAEI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,chBnIU;EgBoIV,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AnBmkDR;;AmB/jDA;EAEI,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,WAAA;AnBikDJ;AmB/jDI;EAEI,aAAA;AnBgkDR;AIxtDI;EesJA;IAMQ,aAAA;EnBgkDV;AACF;AmB7jDI;EAEI,eAAA;AnB8jDR;;AmBxjDI;EAEI,aAAA;EACA,UAAA;AnB0jDR;AIruDI;EewKA;IAWQ,aAAA;IACA,UAAA;EnBsjDV;AACF;AmBpjDQ;EAEI,QAAA;EACA,WAAA;AnBqjDZ;AmBjjDI;EAEI,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,WAAA;AnBkjDR;AmBhjDQ;EAEI,aAAA;AnBijDZ;AIxvDI;EeqMI;IAMQ,aAAA;EnBijDd;AACF;AmB9iDQ;EAEI,eAAA;AnB+iDZ;;AIhwDI;EewNA;IAIQ,aAAA;IACA,UAAA;EnByiDV;AACF;AmBtiDI;EAEI,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,WAAA;AnBuiDR;AI7wDI;EewOI;IAIQ,aAAA;EnBqiDd;AACF;;AoBnxDA;EAEI,aAAA;EACA,mBAAA;ApBqxDJ;AoBnxDI;EAEI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;ApBoxDR;AI1xDI;EgBFA;IAYQ,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,UAAA;EpBoxDV;AACF;AI5xDI;EgBRA;IAmBQ,UAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EpBqxDV;AACF;AIhzDI;EgBIA;IA0BQ,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,UAAA;EpBsxDV;AACF;AoBpxDQ;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;ApBqxDZ;AoBlxDQ;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ApBmxDZ;AoBhxDQ;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;ApBixDZ;AoB/wDY;EAEI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,YAAA;ApBgxDhB;AoB5wDQ;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;ApB6wDZ;AoB3wDY;EAEI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;ApB4wDhB;AoBxwDQ;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;ApBywDZ;AoBvwDY;EAEI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;ApBwwDhB;;AqB53DY;EAEI,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;ArB83DhB;AIl4DI;EiBDQ;IAQQ,eAAA;ErB+3DlB;AACF;AqB73DgB;EAEI,eAAA;EACA,gCAAA;EACA,QAAA;ArB83DpB;AIl5DI;EiBgBY;IAQQ,gBAAA;ErB83DtB;AACF;AqB53DoB;EAEI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;ArB63DxB;AI95DI;EiB2BgB;IAUQ,YAAA;ErB63D1B;AACF;AqB13DoB;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBlB9CP;EkB+CO,mBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;ArB23DxB;AI96DI;EiByCgB;IAcQ,YAAA;ErB23D1B;AACF;AqBt3DY;EAEI,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;ArBu3DhB;AIp7DI;EiBuDQ;IAUQ,eAAA;ErBu3DlB;AACF;AIn7DI;EiBiDQ;IAeQ,gBAAA;ErBu3DlB;AACF;AIp8DI;EiB6DQ;IAqBQ,aAAA;IACA,eAAA;IACA,eAAA;IACA,6BAAA;ErBs3DlB;AACF;AqBp3DgB;EAEI,eAAA;EACA,aAAA;EACA,uBAAA;ArBq3DpB;AqBn3DoB;EAEI,WAAA;EACA,SAAA;ArBo3DxB;AIr9DI;EiBwFY;IAcQ,iBAAA;ErBm3DtB;AACF;AqBj3DoB;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBlB9GP;EkB+GO,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;ArBk3DxB;AIt+DI;EiByGgB;IAeQ,YAAA;IACA,SAAA;IACA,SAAA;ErBk3D1B;AACF;AqB92DgB;EAEI,YAAA;ArB+2DpB;AI1+DI;EiByHY;IAKQ,YAAA;ErBg3DtB;AACF;AIr/DI;EiB+HY;IAUQ,YAAA;ErBg3DtB;AACF;;AsBn/DgB;EAEI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAEG,iBAAA;EACH,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AtBq/DpB;AIjgEI;EkBCY;IAeQ,aAAA;IACA,mBAAA;IACA,iBAAA;EtBq/DtB;AACF;AIlgEI;EkBLY;IAsBQ,oBAAA;IACA,iBAAA;EtBq/DtB;AACF;AIphEI;EkBOY;IA4BQ,aAAA;IACA,gBAAA;IACA,aAAA;EtBq/DtB;AACF;AsBn/DoB;EAEI,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;AtBo/DxB;AI3hEI;EkB4BgB;IAeQ,UAAA;EtBo/D1B;AACF;AI5iEI;EkBwCgB;IAoBQ,UAAA;EtBo/D1B;AACF;AsBj/DoB;EAEI,YAAA;AtBk/DxB;AsB/+DoB;EAEI,eAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AtBg/DxB;AIxjEI;EkB+DgB;IAaQ,gBAAA;EtBg/D1B;AACF;AIvjEI;EkByDgB;IAkBQ,kBAAA;EtBg/D1B;AACF;AIxkEI;EkBqEgB;IAuBQ,kBAAA;EtBg/D1B;AACF;AsB9+DwB;EAEI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AtB++D5B;AI/kEI;EkByFoB;IAWQ,eAAA;EtB++D9B;AACF;AI1lEI;EkB+FoB;IAgBQ,eAAA;IACA,eAAA;IACA,gBAAA;EtB++D9B;AACF;AsB3+DwB;EAEI,eAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AtB4+D5B;AIvmEI;EkBsHoB;IASQ,eAAA;IACA,kBAAA;EtB4+D9B;AACF;AsB1+D4B;EAEI,gBAAA;EACA,eAAA;AtB2+DhC;AI3mEI;EkB6HwB;IAMQ,eAAA;EtB4+DlC;AACF;AsBz+D4B;EAEI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,uBAAA;EACA,kBAAA;AtB0+DhC;AsBx+DgC;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AtBy+DpC;AInoEI;EkBgJ4B;IAaQ,WAAA;EtB0+DtC;AACF;AIloEI;EkB0I4B;IAkBQ,WAAA;EtB0+DtC;AACF;AInpEI;EkBsJ4B;IAuBQ,WAAA;EtB0+DtC;AACF;AsBr+DwB;EAEI,eAAA;EACA,aAAA;EACA,eAAA;AtBs+D5B;AsBp+D4B;EAEI,gBAAA;EACA,eAAA;AtBq+DhC;AI3pEI;EkBmLwB;IAOQ,eAAA;EtBq+DlC;AACF;AsBl+D4B;EAEI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,4EAAA;EACA,uBAAA;EACA,kBAAA;AtBm+DhC;AsBj+DgC;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AtBk+DpC;AInrEI;EkBuM4B;IAcQ,WAAA;EtBk+DtC;AACF;AIlrEI;EkBiM4B;IAmBQ,WAAA;EtBk+DtC;AACF;AInsEI;EkB6M4B;IAwBQ,WAAA;EtBk+DtC;AACF;;AuB/rEoB;EAEI,YAAA;EACA,aAAA;EACA,uBAAA;AvBisExB;AIlsEI;EmBHgB;IAQQ,YAAA;EvBisE1B;AACF;AIntEI;EmBSgB;IAaQ,YAAA;EvBisE1B;AACF;AuB/rEwB;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBpB9BX;EoB+BW,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AvBgsE5B;AI9tEI;EmBmBoB;IAeQ,QAAA;EvBgsE9B;AACF;AI7tEI;EmBaoB;IAoBQ,SAAA;EvBgsE9B;AACF;AI9uEI;EmByBoB;IAyBQ,YAAA;IACA,SAAA;IACA,QAAA;EvBgsE9B;AACF;AuB5rEoB;EAEI,YAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AvB6rExB;AItvEI;EmBmDgB;IAUQ,WAAA;EvB6rE1B;AACF;AIjwEI;EmByDgB;IAgBQ,WAAA;EvB4rE1B;AACF;AuB1rEwB;EAEI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AvB2rE5B;AIzwEI;EmBsEoB;IAYQ,kBAAA;EvB2rE9B;AACF;AIpxEI;EmB4EoB;IAiBQ,gBAAA;EvB2rE9B;AACF;AuBzrE4B;EAEI,WAAA;AvB0rEhC;AuBvrE4B;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AvBwrEhC;AuBrrE4B;EAEI,sBAAA;EACA,8EAAA;AvBsrEhC;AuBnrE4B;EAEI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AvBorEhC;AI5yEI;EmBmHwB;IASQ,YAAA;IACA,gBAAA;EvBorElC;AACF;AI5yEI;EmB6GwB;IAeQ,gBAAA;EvBorElC;AACF;AuBjrE4B;EAEI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AvBkrEhC;AIh0EI;EmBsIwB;IAYQ,eAAA;IACA,iBAAA;EvBkrElC;AACF;AuB9qE4B;EAEI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AvB+qEhC;AIr1EI;EmBwJwB;IAiBQ,UAAA;EvBgrElC;AACF;AuB9qEgC;EAEI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AvB+qEpC;AuB5qEgC;EAEI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4EAAA;EACA,6BAAA;AvB6qEpC;AuBxqEoC;EACA,oBAAA;AvB0qEpC;AuBpqEoC;EACA,sBAAA;AvBsqEpC;AuBhqEoC;EACA,sBAAA;AvBkqEpC;AuB5pEoC;EACA,sBAAA;AvB8pEpC;AuBxpEoC;EACA,sBAAA;AvB0pEpC;AuBppEoC;EACA,oBAAA;AvBspEpC;AuBhpE4B;EAEI,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,QAAA;EACA,cAAA;AvBipEhC;AI14EI;EmBmPwB;IAUQ,eAAA;EvBipElC;AACF;AuB9oE4B;EAEI,gBAAA;EACA,YAAA;AvB+oEhC;;AwBp5EY;EAEI,gBAAA;EACA,eAAA;EACA,eAAA;AxBs5EhB;AIz5EI;EoBDQ;IAQQ,cAAA;IACA,eAAA;ExBs5ElB;AACF;AIr6EI;EoBKQ;IAcQ,eAAA;IACA,aAAA;IACA,eAAA;ExBs5ElB;AACF;AwBn5EgB;EAEI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AxBo5EpB;AIn7EI;EoByBY;IAUQ,sBAAA;ExBo5EtB;AACF;AwBl5EoB;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBrB3CP;EqB4CO,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AxBm5ExB;AI97EI;EoBgCgB;IAeQ,QAAA;ExBm5E1B;AACF;AI77EI;EoB0BgB;IAoBQ,SAAA;ExBm5E1B;AACF;AI98EI;EoBsCgB;IAyBQ,QAAA;IACA,YAAA;IACA,SAAA;ExBm5E1B;AACF;AwBh5EoB;EAEI,WAAA;AxBi5ExB;AIx9EI;EoBqEgB;IAMQ,YAAA;ExBi5E1B;AACF;AwB/4EwB;EAEI,WAAA;EACA,QAAA;AxBg5E5B;AI39EI;EoBwEoB;IAOQ,SAAA;ExBg5E9B;AACF;AI19EI;EoBkEoB;IAYQ,SAAA;ExBg5E9B;AACF;AI3+EI;EoB8EoB;IAiBQ,WAAA;IACA,SAAA;ExBg5E9B;AACF;AwB34EgB;EAEI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;AxB44EpB;AI7/EI;EoBsGY;IAeQ,UAAA;ExB44EtB;AACF;AwB14EoB;EAEI,qBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AxB24ExB;AwBz4EwB;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AxB04E5B;AwBv4EwB;EAEI,sBAAA;EACA,8EAAA;AxBw4E5B;AwBr4EwB;EAEI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AxBs4E5B;AI/hFI;EoBkJoB;IAWQ,kBAAA;ExBs4E9B;AACF;AwBn4EwB;EAEI,WAAA;AxBo4E5B;AwBj4EwB;EAEI,YAAA;EACA,kBAAA;EACA,UAAA;AxBk4E5B;;AyB3iFgB;EAEI,gBAAA;EACA,WAAA;AzB6iFpB;AyBziFY;EAEI,aAAA;AzB0iFhB;AI1jFI;EqBcQ;IAMQ,cAAA;IACA,eAAA;IAEG,iBAAA;IACA,YAAA;EzB0iFrB;AACF;AyBxiFgB;EAEI,WAAA;AzByiFpB;;A0BjkFY;EAEI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;A1BmkFhB;AI9kFI;EsBKQ;IAUQ,eAAA;IACA,6BAAA;IACA,eAAA;E1BmkFlB;AACF;A0BjkFgB;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;A1BmkFpB;A0BjkFoB;EAEI,WAAA;EACA,QAAA;A1BkkFxB;AI/lFI;EsBoBY;IAcQ,YAAA;IACA,SAAA;E1BikFtB;AACF;A0B/jFoB;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBvB3CP;EuB4CO,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EAEA,SAAA;A1B+jFxB;AI3mFI;EsBgCgB;IAgBQ,SAAA;E1B+jF1B;AACF;AI1mFI;EsB0BgB;IAqBQ,SAAA;E1B+jF1B;AACF;AI3nFI;EsBsCgB;IA0BQ,YAAA;IACA,SAAA;IACA,SAAA;E1B+jF1B;AACF;A0B3jFgB;EAEI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;A1B4jFpB;AIxoFI;EsBuEY;IASQ,gBAAA;IACA,eAAA;E1B4jFtB;AACF;A0B1jFoB;EAEI,iBAAA;EACA,YAAA;A1B2jFxB;AI5oFI;EsB8EgB;IAOQ,iBAAA;IACA,YAAA;E1B2jF1B;AACF;AIxpFI;EsBoFgB;IAaQ,YAAA;E1B2jF1B;AACF;;A2B5pFI;EAEI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,cxBFS;EwBGT,mBAAA;EACA,kBAAA;A3B8pFR;A2B5pFQ;EAEI,eAAA;A3B6pFZ;AIpqFI;EuBKI;IAMQ,eAAA;E3B6pFd;AACF;AI/qFI;EuBWI;IAWQ,eAAA;E3B6pFd;AACF;A2B1pFQ;EAEI,aAAA;EACA,eAAA;A3B2pFZ;AIxrFI;EuB0BI;IAOQ,cAAA;IACA,iBAAA;E3B2pFd;AACF;A2BxpFQ;EAEI,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;A3BypFZ;AI9rFI;EuBgCI;IASQ,eAAA;E3BypFd;AACF;AIzsFI;EuBsCI;IAcQ,eAAA;E3BypFd;AACF;A2BvpFY;EAEI,aAAA;EACA,gCAAA;EACA,0CAAA;A3BwpFhB;A2BltFI;EA8DI,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;A3BupFR;A2BrpFQ;EAEI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;A3BspFZ;AI9tFI;EuBgEI;IAYQ,eAAA;IACA,iBAAA;E3BspFd;AACF;AI1uFI;EuBsEI;IAiBQ,aAAA;IACA,eAAA;E3BupFd;AACF;A2BppFQ;EAEI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;A3BqpFZ;AIjvFI;EuBsFI;IAUQ,eAAA;E3BqpFd;AACF;AI5vFI;EuB4FI;IAeQ,eAAA;IACA,gBAAA;E3BqpFd;AACF;A2BlpFQ;EAEI,eAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;A3BmpFZ;A2BjpFY;EAEI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;A3BkpFhB;AI1wFI;EuBmHQ;IASQ,eAAA;IACA,WAAA;E3BkpFlB;AACF;AI1wFI;EuB6GQ;IAeQ,YAAA;E3BkpFlB;AACF;AI3xFI;EuByHQ;IAoBQ,WAAA;IACA,SAAA;IACA,eAAA;E3BkpFlB;AACF;A2BhpFgB;EACI,WAAA;EACA,OAAA;A3BkpFpB;AIhyFI;EuB4IY;IAOQ,WAAA;E3BipFtB;AACF;AI3yFI;EuBkJY;IAYQ,YAAA;E3BipFtB;AACF;A2B7oFY;EAEI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;A3B8oFhB;AI3yFI;EuBuJQ;IAUQ,eAAA;E3B8oFlB;AACF;AI5zFI;EuBmKQ;IAgBQ,gBAAA;IACA,eAAA;E3B6oFlB;AACF;A2B3oFgB;EAEI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3B4oFpB;A2B1oFoB;EAEI,eAAA;A3B2oFxB;AI30FI;EuBuLY;IAcQ,eAAA;E3B0oFtB;AACF;A2BtoFY;EAEI,kBAAA;EACA,gBAAA;EACA,aAAA;A3BuoFhB;A2BroFgB;EAEI,gBAAA;A3BsoFpB;AIx1FI;EuBgNY;IAMQ,eAAA;E3BsoFtB;AACF;A2BnoFgB;EAEI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A3BooFpB;AIn2FI;EuBoNY;IAeQ,eAAA;E3BooFtB;AACF;AI92FI;EuB0NY;IAoBQ,eAAA;IACA,aAAA;IACA,eAAA;E3BooFtB;AACF;A2BloFoB;EAEI,aAAA;EACA,yBAAA;EACA,0CAAA;A3BmoFxB;A2B7nFY;EAEI,gBAAA;EACA,aAAA;EACA,yBAAA;A3B8nFhB;A2B5nFgB;EAEI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,cxBvQH;EwBwQG,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;A3B6nFpB;AIh5FI;EuBmQY;IAoBQ,eAAA;IACA,eAAA;IACA,gBAAA;E3B6nFtB;AACF;A2B3nFoB;EAEI,cxB7RP;AHy5FjB;A2B3nFwB;EACI,UAAA;EACA,sBAAA;A3B6nF5B;A2BznFoB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,qIAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,sBAAA;A3B2nFxB;A2BrnFQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A3BunFZ;A2BrnFY;EAEI,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;A3BsnFhB;A2BlnFY;EAEI,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,mBxBtVA;EwBuVA,yBAAA;EACA,aAAA;EACA,eAAA;A3BmnFhB;AIz8FI;EuBqUQ;IAqBQ,aAAA;IACA,YAAA;E3BmnFlB;AACF;AIr9FI;EuB2UQ;IA2BQ,aAAA;IACA,YAAA;E3BmnFlB;AACF;A2BhnFgB;EAEI,cxBxWH;EwByWG,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;A3BinFpB;A2B9mFgB;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,cxBxXH;EwByXG,mBxB3XJ;EwB4XI,mBAAA;EACA,eAAA;A3B+mFpB;;A4Bh/FA;EAEI,eAAA;EACA,oBAAA;EACA,czBEa;EyBDb,0BAAA;A5Bk/FJ;AIt/FI;EwBDJ;IASQ,SAAA;IACA,SAAA;E5Bk/FN;AACF;A4Bh/FI;EAEI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBzBnBS;EyBoBT,WAAA;A5Bi/FR;A4B/+FQ;EAEI,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;A5Bg/FZ;AI7gGI;EwBuBI;IAUQ,eAAA;E5Bg/Fd;AACF;A4B5+FQ;EAEI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;A5B6+FZ;AI1hGI;EwBsCI;IAUQ,eAAA;IACA,eAAA;IACA,eAAA;E5B8+Fd;AACF;A4B3+FQ;EAEI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;A5B4+FZ;A4B1+FY;EACI,aAAA;EACA,uBAAA;EACA,eAAA;A5B4+FhB;AI5iGI;EwB6DQ;IAOQ,eAAA;E5B4+FlB;AACF;A4Bx+FQ;EAEI,gBAAA;EACA,iBAAA;A5By+FZ;A4Bv+FY;EAEI,mBAAA;A5Bw+FhB;A4Bt+FgB;EAEI,kBAAA;EACA,czBhFH;EyBiFG,eAAA;A5Bu+FpB;AI7jGI;EwBkFY;IAQQ,eAAA;E5Bu+FtB;AACF;A4Bp+FoB;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,yBzBlGP;EyBmGO,2BAAA;EACA,mCAAA;A5Bq+FxB;A4Bl+FoB;EAEI,oBAAA;A5Bm+FxB;A4Bh+FoB;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;EACA,yBzBrHP;EyBsHO,6BAAA;EACA,mCAAA;A5Bi+FxB;A4B99FoB;EAEI,oBAAA;A5B+9FxB;A4Bx9FoB;EAEI,6BAAA;A5By9FxB;A4Bt9FoB;EAEI,2BAAA;A5Bu9FxB;A4Bj9FQ;EAEI,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;A5Bk9FZ;A4B/8FY;EAEI,eAAA;EACA,eAAA;EACA,czB5JC;AH4mGjB;AIjnGI;EwB6JQ;IAQQ,eAAA;E5Bg9FlB;AACF;A4B78FY;EAEI,czBvKE;EyBwKF,yBAAA;A5B88FhB;A4Bz8FI;EAEI,iBAAA;EACA,kBAAA;A5B08FR;A4Bx8FQ;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;A5By8FZ;A4Br8FI;EAEI,czBlMQ;EyBmMR,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;A5Bs8FR;AIlpGI;EwBmMA;IAaQ,YAAA;IACA,eAAA;E5Bs8FV;AACF;A4Bp8FQ;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;A5Bq8FZ;A4Bn8FY;EAEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBzBjOA;AHqqGhB;A4Bj8FY;EAEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,mBzB5OA;AH8qGhB;A4B97FQ;EAEI,kBAAA;A5B+7FZ;A4B77FY;EAEI,uBAAA;EACA,gBAAA;A5B87FhB;A4B57FgB;EAEI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBzB9PJ;EyB+PI,kBAAA;EACA,QAAA;EACA,WAAA;A5B67FpB;AIjsGI;EwB4PY;IAYQ,YAAA;E5B67FtB;AACF;A4Bz7FY;EAEI,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;A5B07FhB;AI/sGI;EwB6QQ;IAWQ,YAAA;IACA,SAAA;E5B27FlB;AACF;;A6BttGA;EAEI,c1BEY;E0BDZ,aAAA;EACA,eAAA;A7BwtGJ;A6BttGI;EAEI,c1BHU;E0BIV,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;A7ButGR;AI7tGI;EyBDA;IAWQ,eAAA;E7ButGV;AACF;AIxuGI;EyBKA;IAgBQ,eAAA;IACA,aAAA;E7ButGV;AACF;A6BntGI;EAEI,mBAAA;A7BotGR;A6BjtGI;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;A7BktGR;A6BhtGQ;EACI,c1BlCK;E0BmCL,eAAA;A7BktGZ;AI1vGI;EyBsCI;IAUQ,eAAA;E7B8sGd;AACF;A6B5sGY;EAEI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;A7B6sGhB;AIzwGI;EyBmDQ;IAiBQ,QAAA;E7BysGlB;AACF;A6BpsGI;EAEI,YAAA;EACA,eAAA;A7BqsGR;AIlxGI;EyB0EA;IAWQ,YAAA;IACA,eAAA;E7BisGV;AACF;A6B9rGI;EAEI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;A7B+rGR;AI/xGI;EyB0FA;IAcQ,eAAA;IACA,gBAAA;E7B2rGV;AACF;A6BzrGQ;EAEI,gBAAA;EACA,WAAA;A7B0rGZ;AIzyGI;EyB4GI;IAWQ,WAAA;E7BsrGd;AACF;A6BlrGI;EAEI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;A7BmrGR;A6BjrGQ;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;A7BmrGZ;A6BhrGQ;EAEI,c1BvIK;E0BwIL,eAAA;A7BirGZ;;A8B/zGA;EAEI,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,c3BHa;E2BIb,yBAAA;EACA,mBAAA;EACA,kBAAA;A9Bi0GJ;A8B/zGI;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,c3Bba;E2Bcb,eAAA;EACA,iBAAA;A9Bi0GJ;A8B/zGQ;EACI,aAAA;A9Bi0GZ;A8B7zGI;EACI,YAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,c3B5BS;E2B6BT,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;A9B+zGR;A8B7zGQ;EACI,aAAA;A9B+zGZ;A8B3zGI;EACI,aAAA;A9B6zGR;A8B1zGI;EACI,aAAA;A9B4zGR;A8BzzGI;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;A9B0zGR;A8BtzGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,yB3BpES;E2BqET,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;A9BwzGR;A8BtzGQ;EACI,mBAAA;A9BwzGZ;A8BrzGQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;A9BuzGZ;A8BrzGY;EAEI,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;A9BszGhB;A8BpzGgB;EACI,mBAAA;A9BszGpB;A8B/yGI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;A9BizGR;A8B/yGQ;EACI,aAAA;EACA,kBAAA;A9BizGZ;A8B7yGI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;A9B+yGR;A8B5yGI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;A9B8yGR;A8B3yGI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;A9B6yGR;A8B1yGI;EACI,UAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,c3BzJS;E2B0JT,yBAAA;EACA,eAAA;A9B4yGR;A8B1yGQ;EACI,aAAA;EACA,mBAAA;A9B4yGZ;A8BzyGQ;EACI,yB3BnKK;E2BoKL,c3BxKK;AHm9GjB;A8BxyGQ;EACI,6BAAA;EACA,c3B7KK;AHu9GjB;A8BtyGI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;A9BwyGR;A8BryGI;EACI,UAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,c3B7LS;E2B8LT,yBAAA;EACA,aAAA;EACA,eAAA;A9BuyGR;A8BryGQ;EACI,aAAA;EACA,mBAAA;A9BuyGZ;A8BpyGQ;EACI,yB3BxMK;E2ByML,c3B7MK;AHm/GjB;A8BnyGQ;EACI,6BAAA;EACA,c3BlNK;AHu/GjB;A8BjyGI;EACI,aAAA;EACA,mBAAA;A9BmyGR;A8BhyGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;A9BkyGR;A8B/xGI;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;A9BiyGR;A8B/xGQ;EACI,UAAA;EACA,aAAA;EACA,8BAAA;A9BiyGZ;A8B/xGY;EACI,iBAAA;A9BiyGhB;A8B7xGQ;EAEI,YAAA;A9B8xGZ;A8B1xGI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;A9B4xGR;A8BxxGI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;A9B0xGR;A8BxxGQ;EACI,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,c3BxRK;E2ByRL,yBAAA;EACA,eAAA;A9B0xGZ;A8BxxGY;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA;A9B0xGhB;A8BvxGY;EACI,iBAAA;EACA,mBAAA;A9ByxGhB;A8BtxGY;EACI,yB3BxSC;E2BySD,c3B7SC;AHqkHjB;A8BrxGY;EACI,6BAAA;EACA,c3BlTC;AHykHjB;A8BlxGI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;A9BoxGR;A8BjxGI;EACI,UAAA;EACA,eAAA;EACA,aAAA;EAEA,sBAAA;A9BkxGR;A8B/wGI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;A9BixGR;A8B9wGI;EACI,aAAA;EACA,sBAAA;A9BgxGR;A8B9wGQ;EACI,eAAA;EACA,kBAAA;A9BgxGZ;A8B7wGQ;EACI,YAAA;EACA,kBAAA;A9B+wGZ;A8B1wGQ;EACI,eAAA;EACA,kBAAA;EACA,cAAA;A9B4wGZ;A8B1wGY;EACI,cAAA;EACA,iBAAA;EACA,YAAA;A9B4wGhB;A8BvwGI;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;A9BywGR;A8BtwGI;EACI,cAAA;A9BwwGR;A8BrwGI;EACI,aAAA;A9BuwGR;A8BpwGI;EACI,WAAA;EACA,YAAA;A9BswGR;A8BpwGQ;EACI,iBAAA;A9BswGZ;A8BlwGI;EACI,YAAA;EACA,kBAAA;A9BowGR;A8BlwGQ;EACI,kBAAA;EACA,QAAA;EACA,WAAA;A9BowGZ;A8BjwGQ;EACI,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,c3B9YK;E2B+YL,iBAAA;EACA,iBAAA;EACA,kBAAA;A9BmwGZ;A8BjwGY;EACI,aAAA;A9BmwGhB;A8B9vGQ;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,c3BhaK;E2BiaL,iBAAA;EACA,mBAAA;A9BgwGZ;A8B9vGY;EACI,aAAA;A9BgwGhB;A8B3vGQ;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,c3BhbK;E2BibL,iBAAA;EACA,mBAAA;A9B6vGZ;A8BvvGI;EACI,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,c3B5bS;E2B6bT,iBAAA;EACA,mBAAA;EACA,eAAA;A9ByvGR;A8BvvGQ;EACI,yB3BlcK;E2BmcL,c3BvcK;AHgsHjB;A8BrvGI;EACI,aAAA;EACA,mBAAA;A9BuvGR;A8BrvGQ;EACI,eAAA;A9BuvGZ;;A8BlvGA;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,c3Bxda;E2Bydb,0BAAA;EACA,iBAAA;A9BqvGJ;A8BnvGI;EACI,yB3B7dS;E2B8dT,c3BleS;AHutHjB;A8BjvGI;EACI,kCAAA;EACA,c3BxeS;AH2tHjB;A8BjvGQ;EACA,oCAAA;EACA,W3B3eY;AH8tHpB;;A8B9uGA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A9BivGJ;A8B/uGI;EACI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,c3BxfS;AHyuHjB;A8B/uGQ;EACI,0BAAA;A9BivGZ;;A8B5uGA;EACI,eAAA;A9B+uGJ;;A8B5uGA;EACI,yB3BzgBa;AHwvHjB;;A8B5uGA;EACI,aAAA;A9B+uGJ;;A8B5uGA;EACI,cAAA;A9B+uGJ;;A8B5uGA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;A9B+uGJ;A8B7uGI;EACI,qBAAA;A9B+uGR;;A+B5wHA;EACI,aAAA;A/B+wHJ;;A+B5wHA;EAEQ,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;A/B8wHR;A+B5wHI;EAEI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;A/B6wHR;A+B1wHI;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;A/B4wHR;A+BzwHI;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;A/B2wHR;A+BxwHI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A/B0wHR;A+BvwHI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yB5BtDS;E4BuDT,c5BnDS;E4BoDT,yBAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;A/BywHR;A+BtwHI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;A/BwwHR;;AgCp1HA;EACI,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhCu1HJ;AgCr1HI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yB7BpBS;E6BqBT,c7BjBS;AHw2HjB;AgCr1HQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AhCu1HZ;AgCr1HY;EACI,gBAAA;EACA,eAAA;AhCu1HhB;AgCl1HI;EACI,iBAAA;EACA,gBAAA;AhCo1HR;AgCj1HI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AhCm1HR;;AgC90HA;EACI,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,c7B3Dc;E6B4Dd,yB7B/Da;E6BgEb,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AhCi1HJ;AgC/0HI;EACI,eAAA;EACA,c7B3ES;E6B4ET,yB7BxES;E6ByET,yBAAA;AhCi1HR","sourcesContent":["@font-face {\n    font-family: \"Roboto\";\n    src: url('../../assets/fonts/roboto.ttf');\n}\n\n@font-face {\n    font-family: \"Anton\";\n    src: url('../../assets/fonts/anton.ttf');\n}\n\n@font-face {\n    font-family: \"Bahnschrift\";\n    src: url('../../assets/fonts/bahnschrift.ttf');\n}\n\n@font-face {\n    font-family: \"BrunoAce\";\n    src: url('../../assets/fonts/brunoace.ttf');\n}\n\n@font-face {\n    font-family: \"Metamorphous\";\n    src: url('../../assets/fonts/metamorphous.ttf');\n}\n\n@font-face {\n    font-family: \"Overpass\";\n    src: url('../../assets/fonts/overpass.ttf');\n}","@font-face {\n  font-family: \"Roboto\";\n  src: url(\"../../assets/fonts/roboto.ttf\");\n}\n@font-face {\n  font-family: \"Anton\";\n  src: url(\"../../assets/fonts/anton.ttf\");\n}\n@font-face {\n  font-family: \"Bahnschrift\";\n  src: url(\"../../assets/fonts/bahnschrift.ttf\");\n}\n@font-face {\n  font-family: \"BrunoAce\";\n  src: url(\"../../assets/fonts/brunoace.ttf\");\n}\n@font-face {\n  font-family: \"Metamorphous\";\n  src: url(\"../../assets/fonts/metamorphous.ttf\");\n}\n@font-face {\n  font-family: \"Overpass\";\n  src: url(\"../../assets/fonts/overpass.ttf\");\n}\n@keyframes slideshow {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-874px);\n  }\n}\n@keyframes openingWindow {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes closingWindow {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0);\n  }\n}\n@keyframes topBarMoving {\n  0% {\n    top: 100%;\n    transform: scaleY(1);\n    opacity: 0;\n  }\n  13% {\n    transform: scaleY(50);\n  }\n  25% {\n    top: 0%;\n    transform: scaleY(1);\n  }\n  38% {\n    transform: scaleY(50);\n  }\n  50% {\n    top: 100%;\n    transform: scaleY(1);\n  }\n  60% {\n    transform: scaleY(50);\n  }\n  70% {\n    top: 0%;\n    transform: scaleY(1);\n  }\n  80% {\n    transform: scaleY(50);\n  }\n  90% {\n    top: 100%;\n    transform: scaleY(1);\n  }\n  95% {\n    transform: scaleY(50);\n    opacity: 0.5;\n  }\n  99% {\n    top: 0%;\n    transform: scaleY(1);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes bottomBarMoving {\n  0% {\n    bottom: 100%;\n    transform: scaleY(1);\n    opacity: 0;\n  }\n  13% {\n    transform: scaleY(50);\n  }\n  25% {\n    bottom: 0%;\n    transform: scaleY(1);\n  }\n  38% {\n    transform: scaleY(50);\n  }\n  50% {\n    bottom: 100%;\n    transform: scaleY(1);\n  }\n  60% {\n    transform: scaleY(50);\n  }\n  70% {\n    bottom: 0%;\n    transform: scaleY(1);\n  }\n  80% {\n    transform: scaleY(50);\n  }\n  90% {\n    bottom: 100%;\n    transform: scaleY(1);\n  }\n  95% {\n    transform: scaleY(50);\n    opacity: 0.5;\n  }\n  99% {\n    bottom: 0%;\n    transform: scaleY(1);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes menuButtonTop {\n  0% {\n    transform-origin: right center;\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg);\n  }\n}\n@keyframes menuCloseButtonTop {\n  0% {\n    transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg);\n  }\n  100% {\n    transform-origin: right center;\n    transform: rotate(0deg);\n  }\n}\n@keyframes menuButtonBottom {\n  0% {\n    transform-origin: left center;\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: translate(-5px, -3px) rotate(-50deg);\n  }\n}\n@keyframes menuCloseButtonBottom {\n  0% {\n    transform: translate(-5px, -3px) rotate(-50deg);\n  }\n  100% {\n    transform-origin: left center;\n    transform: rotate(0deg);\n  }\n}\n@keyframes introductionArrow {\n  0% {\n    transform: translateY(50px);\n  }\n  50% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(50px);\n  }\n}\n@keyframes introductionArrow2 {\n  0% {\n    transform: translateY(52px);\n  }\n  50% {\n    transform: translateY(32px);\n  }\n  100% {\n    transform: translateY(52px);\n  }\n}\n*, ::before, ::after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n}\n\na {\n  text-decoration: none;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  height: 100%;\n  align-items: center;\n  white-space: pre-line;\n}\n#root .app-body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  height: 100%;\n  position: relative;\n  background: #191825;\n  font-family: \"Bahnschrift\";\n}\n#root .app-body main {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 90%;\n  margin-bottom: 50px;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n}\n@media screen and (min-width: 768px) {\n  #root .app-body main {\n    width: 100%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  #root .app-body main {\n    width: 90%;\n  }\n}\n#root .app-body main .portfolio {\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: baseline;\n}\n@media screen and (min-width: 768px) {\n  #root .app-body main .portfolio {\n    width: 100%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  #root .app-body main .portfolio {\n    width: 95%;\n  }\n}\n\nbody {\n  position: relative;\n}\n\nheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  z-index: 3;\n}\nheader::after {\n  content: \"\";\n  width: 97%;\n  height: 2px;\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  background: #9471fd;\n  z-index: -1;\n}\n\nfooter {\n  display: flex;\n  align-items: center;\n  background: #191825;\n  padding-top: 25px;\n  flex-direction: column;\n  color: #9471fd;\n  font-weight: bold;\n  border-radius: 20px 20px 0 0;\n  position: relative;\n}\nfooter img {\n  width: 50px;\n}\nfooter .copyright {\n  padding: 15px 0 15px 0;\n}\nfooter::before {\n  content: \"\";\n  width: 97%;\n  height: 2px;\n  position: absolute;\n  top: 0px;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  background: #9471fd;\n}\n\n.secret-link {\n  color: #F0CAA3;\n  margin-left: 5px;\n  cursor: default;\n}\n\nheader {\n  font-family: \"Bahnschrift\";\n}\nheader .logo {\n  color: #9471fd;\n  font-size: 25px;\n  margin-top: 15px;\n  height: 160px;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media screen and (min-width: 1280px) {\n  header .logo {\n    font-size: 37px;\n  }\n}\nheader .logo .image {\n  width: 70px;\n  height: 70px;\n  position: relative;\n  left: 40%;\n  margin-bottom: 5px;\n}\nheader .logo .image::before {\n  content: \"\";\n  position: absolute;\n  top: 62px;\n  left: -52px;\n  width: 55px;\n  height: 3px;\n  background: #9471fd;\n}\nheader .logo .image::after {\n  content: \"\";\n  position: absolute;\n  top: 62px;\n  left: 60px;\n  width: 55px;\n  height: 3px;\n  background: #9471fd;\n}\nheader .logo .text {\n  position: relative;\n}\nheader .logo .text .name {\n  font-family: \"BrunoAce\";\n  flex-basis: 100%;\n}\nheader .logo .text .name::before {\n  content: \"\";\n  width: 250px;\n  height: 3px;\n  background: #9471fd;\n  position: absolute;\n  top: 0px;\n  left: -12px;\n}\n@media screen and (min-width: 1280px) {\n  header .logo .text .name::before {\n    width: 350px;\n  }\n}\nheader .logo .text .function {\n  font-stretch: condensed;\n  font-weight: 100;\n  position: absolute;\n  top: 27px;\n  min-width: 233px;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 1280px) {\n  header .logo .text .function {\n    width: 325px;\n    top: 37px;\n  }\n}\n\nnav {\n  position: absolute;\n  display: block;\n  font-size: 25px;\n  font-weight: lighter;\n  color: #F0CAA3;\n  right: 5%;\n  top: 35px;\n  font-family: \"Bahnschrift\";\n}\n@media screen and (min-width: 1280px) {\n  nav {\n    right: 2%;\n    top: 15px;\n  }\n}\nnav .openButton {\n  position: relative;\n  cursor: pointer;\n  width: 40px;\n  height: 18px;\n  z-index: 21;\n}\nnav .openButton.opened::before {\n  -webkit-animation: menuButtonTop 700ms ease-out normal both;\n  animation: menuButtonTop 700ms ease-out normal both;\n}\nnav .openButton.opened::after {\n  -webkit-animation: menuButtonBottom 700ms ease-out normal both;\n  animation: menuButtonBottom 700ms ease-out normal both;\n}\nnav .openButton.closed::before {\n  -webkit-animation: menuCloseButtonTop 700ms ease-out normal both;\n  animation: menuCloseButtonTop 700ms ease-out normal both;\n}\nnav .openButton.closed::after {\n  -webkit-animation: menuCloseButtonBottom 700ms ease-out normal both;\n  animation: menuCloseButtonBottom 700ms ease-out normal both;\n}\nnav .openButton::before {\n  content: \"\";\n  width: 40px;\n  height: 3px;\n  background: #FFA3FD;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\nnav .openButton::after {\n  content: \"\";\n  width: 30px;\n  height: 3px;\n  background: #FFA3FD;\n  position: absolute;\n  top: 15px;\n  left: 10px;\n}\nnav .menu {\n  position: absolute;\n  top: -10px;\n  right: 0px;\n}\nnav .menu__ref {\n  padding: 25px;\n  position: relative;\n  width: 300px;\n  height: 550px;\n  border: 2px solid #9471fd;\n  background: #191825;\n  z-index: 20;\n}\nnav .menu__ref span {\n  display: block;\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: bold;\n}\nnav .menu ul {\n  list-style: none;\n  margin-left: 15px;\n}\nnav .menu ul li {\n  margin-bottom: 20px;\n}\nnav .menu ul li a {\n  position: relative;\n  color: #F0CAA3;\n  font-size: 18px;\n}\nnav .menu ul li a::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0);\n  height: 2px;\n  bottom: -10px;\n  left: 0;\n  background-color: #F0CAA3;\n  transform-origin: top right;\n  transition: transform 0.6s ease-out;\n}\nnav .menu ul li a:hover::after {\n  transform: scaleX(1);\n}\nnav .menu ul li a::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0);\n  height: 2px;\n  top: -11px;\n  left: 0;\n  background-color: #F0CAA3;\n  transform-origin: bottom left;\n  transition: transform 0.6s ease-out;\n}\nnav .menu ul li a:hover::before {\n  transform: scaleX(1);\n}\nnav .menu ul .reversed a::after {\n  transform-origin: bottom left;\n}\nnav .menu ul .reversed a::before {\n  transform-origin: top right;\n}\nnav .menu ul.lang {\n  display: flex;\n  font-weight: bold;\n  justify-content: space-between;\n}\nnav .menu ul.lang li {\n  cursor: pointer;\n  font-size: 15px;\n  color: #F0CAA3;\n}\nnav .menu ul.lang li.activated {\n  color: #FFA3FD;\n  text-decoration: overline;\n}\nnav .sousMenu {\n  margin-left: 25px;\n  position: relative;\n}\nnav .sousMenu::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-left: 2px solid #F0CAA3;\n  border-bottom: 2px solid #F0CAA3;\n  position: absolute;\n  left: -15px;\n  top: 10px;\n}\n\n.prePortfolioNav .openButton::before {\n  background: #9471fd;\n}\n.prePortfolioNav .openButton::after {\n  background: #9471fd;\n}\n\n.contactform .openButton::before {\n  background: #F0CAA3;\n}\n.contactform .openButton::after {\n  background: #F0CAA3;\n}\n\n.jrpg .openButton::before {\n  background: #F0CAA3;\n}\n.jrpg .openButton::after {\n  background: #F0CAA3;\n}\n\n.scroller {\n  overflow-y: scroll;\n  -ms-scroll-snap-type: x mandatory;\n  scroll-snap-type: x mandatory;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n}\n@media screen and (min-width: 1280px) {\n  .scroller {\n    -ms-scroll-snap-type: y mandatory;\n    scroll-snap-type: y mandatory;\n    flex-wrap: wrap;\n  }\n}\n.scroller section {\n  min-height: 100vh;\n  min-width: 100%;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  scroll-snap-align: start;\n}\n.scroller .one {\n  background: #191825;\n  position: relative;\n  max-height: 100vh;\n}\n.scroller .two {\n  background: none;\n}\n.scroller .three {\n  background: #F0CAA3;\n}\n.scroller .four {\n  background: #9471fd;\n}\n.scroller .five {\n  background: #191825;\n}\n\n.introduction {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  flex-basis: 100%;\n  height: auto;\n  font-family: \"Bahnschrift\";\n  position: relative;\n}\n@media screen and (min-width: 1280px) {\n  .introduction::before {\n    content: \"\";\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    right: 0;\n    left: 0;\n    bottom: -2vw;\n    z-index: 0;\n    width: 0;\n    height: 0;\n    border-left: 70px solid transparent;\n    border-right: 70px solid transparent;\n    border-top: 70px solid #9471fd;\n    -webkit-animation: introductionArrow2 2.5s ease-in-out infinite normal;\n    animation: introductionArrow2 2.5s ease-in-out infinite normal;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introduction::after {\n    content: \"\";\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    right: 0;\n    left: 0;\n    bottom: -2vw;\n    z-index: 0;\n    width: 0;\n    height: 0;\n    border-left: 66px solid transparent;\n    border-right: 66px solid transparent;\n    border-top: 66px solid #191825;\n    -webkit-animation: introductionArrow 2.5s ease-in-out infinite normal;\n    animation: introductionArrow 2.5s ease-in-out infinite normal;\n  }\n}\n.introductionText {\n  position: relative;\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 100px;\n}\n@media screen and (min-width: 768px) {\n  .introductionText {\n    flex-basis: 90%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .introductionText {\n    flex-basis: 50%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText {\n    flex-basis: 50%;\n  }\n}\n.introductionText h1 {\n  position: relative;\n  z-index: 1;\n  flex-basis: 100%;\n  font-size: 6vw;\n  color: #FFA3FD;\n  margin-bottom: 0;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 768px) {\n  .introductionText h1 {\n    font-size: 4.5vw;\n    margin-left: 20px;\n    justify-content: start;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .introductionText h1 {\n    font-size: 2.7vw;\n    margin-left: 0px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText h1 {\n    margin-left: 0;\n    font-size: 3vw;\n  }\n}\n.introductionText h2 {\n  font-size: 4.8vw;\n  color: #F0CAA3;\n  margin: 0 0 15px 0;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 768px) {\n  .introductionText h2 {\n    font-size: 3vw;\n    justify-content: start;\n    margin: 50px 0 20px 20px;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .introductionText h2 {\n    font-size: 1.9vw;\n    margin: 50px 0 20px 0;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText h2 {\n    font-size: 1.8vw;\n    margin: 50px 0 20px 0;\n  }\n}\n.introductionText p {\n  font-size: 4vw;\n  color: #9471fd;\n  padding: 20px;\n}\n@media screen and (min-width: 768px) {\n  .introductionText p {\n    font-size: 2.8vw;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .introductionText p {\n    padding: 10px;\n    font-size: 1.5vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText p {\n    padding: 10px;\n    font-size: 1.5vw;\n  }\n}\n.introductionText .secondText, .introductionText .thirdText {\n  flex-basis: 100%;\n}\n@media screen and (min-width: 768px) {\n  .introductionText .secondText, .introductionText .thirdText {\n    flex-basis: 50%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText::before {\n    content: \"\";\n    position: absolute;\n    top: -55px;\n    right: 0;\n    z-index: 0;\n    width: 0;\n    height: 0;\n    border-left: 60px solid transparent;\n    border-right: 60px solid transparent;\n    border-top: 130px solid #9471fd;\n    transform: rotate(50deg);\n  }\n}\n@media screen and (min-width: 1280px) {\n  .introductionText::after {\n    content: \"\";\n    position: absolute;\n    top: -52px;\n    right: 3px;\n    z-index: 0;\n    width: 0;\n    height: 0;\n    border-left: 56px solid transparent;\n    border-right: 56px solid transparent;\n    border-top: 122px solid #191825;\n    transform: rotate(50deg);\n  }\n}\n.introduction .presentationText {\n  margin-top: 25px;\n  width: 500px;\n  background: #9471fd;\n  border-radius: 25px;\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n.introduction .presentationText .thirdText h2 {\n  display: flex;\n  flex-direction: column;\n}\n.introduction .presentationText .thirdText h2 span {\n  flex-basis: 50%;\n}\n.introduction .presentationText p {\n  position: relative;\n  flex-basis: 80%;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.introduction .presentationText::before {\n  content: \"\";\n  position: absolute;\n  height: 3px;\n  width: 100%;\n  background: #191825;\n  top: 98%;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  -webkit-animation: topBarMoving 1s ease 2 normal both;\n  animation: topBarMoving 1s ease 2 normal both;\n}\n.introduction .presentationText::after {\n  content: \"\";\n  position: absolute;\n  height: 3px;\n  width: 100%;\n  background: #191825;\n  bottom: 98%;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  -webkit-animation: bottomBarMoving 1s ease 2 normal both;\n  animation: bottomBarMoving 1s ease 2 normal both;\n}\n\n.two {\n  cursor: default;\n  color: #fff;\n  font-family: \"metamorphous\";\n  position: relative;\n  max-height: 100vh;\n  min-width: 100vw;\n}\n.two h2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.two h2 img {\n  height: 90px;\n  margin-right: 15px;\n}\n.two h3 {\n  padding-left: 3%;\n  margin-bottom: 15px;\n  position: relative;\n  font-size: 15px;\n}\n@media screen and (min-width: 1280px) {\n  .two h3 {\n    font-size: 1.17em;\n    padding-left: 5%;\n  }\n}\n.two h3::after {\n  content: \"\";\n  display: inline-block;\n  height: 1px;\n  width: 35%;\n  background: #fff;\n  position: absolute;\n  bottom: -10px;\n  left: 2%;\n}\n@media screen and (min-width: 1280px) {\n  .two h3::after {\n    left: 4%;\n  }\n}\n.two #backgroundVideo {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: -2;\n  min-width: 100vw;\n  min-height: 100vh;\n  max-height: 100vh;\n}\n@media screen and (min-width: 1280px) {\n  .two #backgroundVideo {\n    min-width: 100%;\n    min-height: 100%;\n    max-height: none;\n  }\n}\n.two::before {\n  content: \"\";\n  position: fixed;\n  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 15%, rgb(124, 124, 124) 40%, rgb(124, 124, 124) 60%, rgb(0, 0, 0) 85%, rgb(0, 0, 0) 100%);\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  opacity: 0.7;\n  width: 100%;\n  height: 100%;\n}\n.two .jrpgstat {\n  display: flex;\n  flex-wrap: wrap;\n}\n.two .jrpgstat .header {\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  min-height: 20vh;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header {\n    height: 20vh;\n  }\n}\n.two .jrpgstat .header .title h2 {\n  position: relative;\n}\n.two .jrpgstat .body {\n  flex-basis: 100%;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body {\n    height: 60vh;\n  }\n}\n.two .jrpgstat .body .stats {\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats {\n    flex-basis: 40%;\n  }\n}\n.two .jrpgstat .body .stats .skills {\n  flex-basis: 100%;\n  height: 100%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .skills {\n    height: 60%;\n  }\n}\n.two .jrpgstat .footer {\n  flex-basis: 100%;\n  min-height: 20vh;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer {\n    height: 20vh;\n  }\n}\n\n.prePortfolio {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-around;\n  position: relative;\n  flex-wrap: wrap;\n}\n.prePortfolio .projectCard {\n  position: relative;\n  z-index: 2;\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  order: 1;\n  margin-top: 0;\n  margin-top: -250px;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .projectCard {\n    flex-basis: 48%;\n    margin-top: -450px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .projectCard {\n    margin-top: 0;\n    flex-basis: 30%;\n    margin-top: 30px;\n    order: none;\n  }\n}\n.prePortfolio .textBlock {\n  background: #191825;\n}\n.prePortfolio .preProtfolioText {\n  flex-basis: 100%;\n  height: 100%;\n  font-family: \"Bahnschrift\";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  margin-top: 0;\n  margin-bottom: 10%;\n  order: 0;\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText {\n    margin-top: 0;\n    margin-bottom: 0;\n    flex-basis: 40%;\n    order: 1;\n  }\n}\n.prePortfolio .preProtfolioText h2 {\n  color: #9471fd;\n  font-size: 40px;\n  position: relative;\n  z-index: 0;\n  margin-top: -60px;\n  margin-bottom: -250px;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .preProtfolioText h2 {\n    font-size: 70px;\n    margin-top: -250px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText h2 {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 70px;\n  }\n  .prePortfolio .preProtfolioText h2::before {\n    content: \"\";\n    width: 400px;\n    height: 400px;\n    border-radius: 200px;\n    border: 4px solid #9471fd;\n    position: absolute;\n    left: -45%;\n    top: 0px;\n    z-index: -1;\n  }\n  .prePortfolio .preProtfolioText h2::after {\n    content: \"\";\n    width: 400px;\n    height: 400px;\n    border-radius: 200px;\n    border: 4px solid #9471fd;\n    position: absolute;\n    left: 100%;\n    top: 500%;\n    z-index: -1;\n  }\n}\n.prePortfolio .preProtfolioText p {\n  color: #191825;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  font-size: 20px;\n  padding: 3%;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .preProtfolioText p {\n    font-size: 30px;\n    margin-top: -250px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText p {\n    font-size: 40px;\n    margin-top: 0;\n  }\n  .prePortfolio .preProtfolioText p::before {\n    content: \"\";\n    width: 200px;\n    height: 200px;\n    border-radius: 100px;\n    border: 4px solid #9471fd;\n    position: absolute;\n    left: -10%;\n    top: 125%;\n    z-index: -1;\n  }\n  .prePortfolio .preProtfolioText p::after {\n    content: \"\";\n    width: 300px;\n    height: 300px;\n    border-radius: 150px;\n    border: 4px solid #9471fd;\n    position: absolute;\n    right: -30%;\n    top: -150%;\n    z-index: -1;\n  }\n}\n.prePortfolio .preProtfolioText .links {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-top: -100px;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .preProtfolioText .links {\n    margin-top: -300px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText .links {\n    margin-top: 0;\n  }\n}\n.prePortfolio .preProtfolioText .links a {\n  flex-basis: 45%;\n  margin-top: -150px;\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText .links a {\n    margin-top: 0px;\n    margin-bottom: 60px;\n  }\n}\n.prePortfolio .preProtfolioText .links a .button {\n  height: 50px;\n  border-radius: 45px;\n  color: #FFA3FD;\n  background: #191825;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  box-shadow: 5px 5px 10px #191825;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .preProtfolioText .links a .button {\n    height: 70px;\n    font-size: 30px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .preProtfolioText .links a .button {\n    height: 90px;\n    border-radius: 45px;\n    font-size: 35px;\n  }\n}\n.prePortfolio .preProtfolioText .links a .button:hover {\n  background: black;\n  box-shadow: 5px 5px 10px black;\n  color: rgb(100%, 79.9215686275%, 99.5635123615%);\n}\n.prePortfolio .projectCard.second {\n  margin-top: 0px;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .projectCard.second {\n    margin-top: -450px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .projectCard.second {\n    margin-top: 30px;\n  }\n}\n\nmain.notFound {\n  color: #9471fd;\n}\nmain.notFound h1 {\n  margin-top: 25px;\n  position: relative;\n  flex-basis: 100%;\n  font-size: 150px;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 768px) {\n  main.notFound h1 {\n    font-size: 300px;\n    margin-top: 50px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  main.notFound h1 {\n    margin-top: 50px;\n    font-size: 300px;\n  }\n}\nmain.notFound p {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 50px;\n  font-size: 12px;\n  font-weight: bold;\n}\n@media screen and (min-width: 768px) {\n  main.notFound p {\n    font-size: 25px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  main.notFound p {\n    font-size: 25px;\n  }\n}\nmain.notFound a {\n  color: #F0CAA3;\n  font-size: 20px;\n}\n\n.legal-mentions {\n  margin-top: 100px;\n  color: #F0CAA3;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  color: #FFA3FD;\n  font-size: 1.2rem;\n  margin-top: 50px;\n}\n.login-form.change {\n  margin-top: 0;\n}\n.login-form input {\n  width: 300px !important;\n  height: 40px !important;\n  margin: 10px !important;\n  padding: 0 10px !important;\n  border: none !important;\n  border-radius: 5px !important;\n  font-size: 1rem !important;\n  outline: none !important;\n  background-color: white !important;\n  color: black !important;\n}\n.login-form input:focus {\n  border: 2px solid #FFA3FD !important;\n}\n.login-form button {\n  width: 150px;\n  height: 40px;\n  margin: 10px;\n  border: 2px solid #F0CAA3;\n  border-radius: 5px;\n  background-color: transparent;\n  color: #F0CAA3;\n  font-size: 1rem;\n}\n.login-form button:hover {\n  background-color: #F0CAA3;\n  color: #000;\n  cursor: pointer;\n}\n\n.presentation-text input, .presentation-text textarea {\n  width: 100% !important;\n  border: none !important;\n  background-color: transparent !important;\n  color: #F0CAA3 !important;\n  font-size: 1rem !important;\n  margin-bottom: 10px !important;\n}\n.presentation-text .presentation-title {\n  font-size: 1.2rem !important;\n  font-weight: bold !important;\n  height: 30px !important;\n}\n.presentation-text .presentation-title:focus {\n  outline: 2px solid #FFA3FD !important;\n  border-radius: 0 !important;\n}\n.presentation-text .presentation-textarea {\n  height: 150px !important;\n  resize: none;\n  font-family: \"Bahnschrift\";\n}\n.presentation-text .presentation-textarea:focus {\n  outline: 2px solid #FFA3FD !important;\n}\n\n.login-sub-panel {\n  display: flex;\n  flex-direction: column;\n  margin: 20px;\n  padding: 20px 30px 20px 30px;\n  border-radius: 15px;\n  border: 2px solid #F0CAA3;\n}\n\n.sub-form {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n\n.admin-generator {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.freeSpace {\n  flex: 1;\n  position: relative;\n  bottom: 5px;\n}\n.freeSpace .slidingText {\n  position: absolute;\n  bottom: 0;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-basis: 100%;\n  padding-top: 20px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.buttonContainer .singleButton {\n  flex-basis: 95%;\n  padding-bottom: 20px;\n}\n@media screen and (min-width: 1280px) {\n  .buttonContainer .singleButton {\n    flex-basis: 48%;\n  }\n}\n.buttonContainer .button {\n  flex-basis: 100%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.5em 0 0.5em 0;\n  border-radius: 8px;\n  background: #9471fd;\n  font-family: \"Roboto\";\n  font-size: 15px;\n  font-weight: bold;\n  color: #000;\n  box-shadow: 1px 1px 5px #9471fd;\n  margin: 0 15px 0 15px;\n  position: relative;\n}\n.buttonContainer .button:hover {\n  box-shadow: 1px 1px 5px rgb(35.7475490196%, 14.7303921569%, 98.7990196078%);\n}\n@media screen and (min-width: 1280px) {\n  .buttonContainer .button {\n    font-size: 13px;\n    padding-left: 10px;\n  }\n}\n.buttonContainer .button img {\n  position: absolute;\n  left: 4%;\n  width: 20px;\n  top: 11px;\n}\n.buttonContainer .button.github {\n  background: #F0CAA3;\n  font-size: 12px;\n}\n.buttonContainer .button.github:hover {\n  background: rgb(92.7157778999%, 74.2624152465%, 55.3234377863%);\n}\n.buttonContainer .button.live {\n  color: #191825;\n  background: #FFA3FD;\n}\n.buttonContainer .button.live:hover {\n  background: rgb(100%, 53.9215686275%, 98.9982949702%);\n}\n.buttonContainer .button.unavailable {\n  background: #191825;\n  color: #9471fd;\n  cursor: not-allowed;\n}\n\n.slidingText {\n  overflow: hidden;\n  position: relative;\n  width: 97%;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slidingText .slidingBox {\n  -webkit-animation: slideshow 120s infinite linear;\n  animation: slideshow 120s infinite linear;\n}\n.slidingText .slidingBox span {\n  font-size: 15px;\n  opacity: 0.7;\n  color: #9471fd;\n  font-family: \"Anton\";\n}\n.slidingText .slidingBox :nth-child(2n+1) {\n  font-size: 16px;\n  position: relative;\n  top: 1px;\n}\n.slidingText .slidingBox :nth-child(2n+0) {\n  color: transparent;\n  -webkit-text-stroke: 1px #9471fd;\n}\n.slidingText.reversed .slidingBox {\n  animation: slideshow 120s infinite linear reverse;\n}\n.slidingText.reversed .slidingBox span {\n  color: #F0CAA3;\n}\n.slidingText.reversed .slidingBox :nth-child(2n+0) {\n  color: transparent;\n  -webkit-text-stroke: 1px #F0CAA3;\n}\n\n.textBlock {\n  position: relative;\n  font-family: \"Roboto\";\n  display: flex;\n  flex-wrap: wrap;\n  margin: 20px 0 20px 0;\n  padding-bottom: 10px;\n  justify-content: center;\n  -webkit-animation: openingWindow 700ms ease-out normal both;\n  animation: openingWindow 700ms ease-out normal both;\n  flex-basis: 95%;\n  border: 2px solid #9471fd;\n}\n@media screen and (min-width: 768px) {\n  .textBlock {\n    flex-basis: 90%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .textBlock {\n    flex-basis: 85%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .textBlock {\n    flex-basis: 95%;\n  }\n}\n.textBlock .codeTitle {\n  height: 50px;\n  background: #9471fd;\n  color: #191825;\n  padding: 10px 10px 10px 0;\n  text-align: center;\n  flex-basis: 100%;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n@media screen and (min-width: 1280px) {\n  .textBlock .codeTitle {\n    font-size: 17px;\n    padding: 10px 30px 10px 10px;\n    height: 50px;\n  }\n}\n.textBlock .textCode {\n  padding: 30px 30px 0 30px;\n  flex-basis: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.textBlock .textCode h3 {\n  text-decoration: underline;\n  flex-basis: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.textBlock::before {\n  content: \"\";\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  border-radius: 3px;\n  background: #191825;\n  border: 2px solid #F0CAA3;\n  position: absolute;\n  right: 4px;\n  top: 5px;\n}\n.textBlock .closeButton {\n  cursor: pointer;\n  font-size: 23px;\n  font-weight: bold;\n  color: #F0CAA3;\n  position: absolute;\n  top: -1px;\n  right: 10px;\n}\n.textBlock.fade {\n  -webkit-animation: closingWindow 700ms ease-out both;\n  animation: closingWindow 700ms ease-out both;\n}\n\n.portfolio .textBlock {\n  flex-basis: 100%;\n  border: 2px solid #9471fd;\n}\n@media screen and (min-width: 768px) {\n  .portfolio .textBlock {\n    flex-basis: 48%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .portfolio .textBlock {\n    flex-basis: 45%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .portfolio .textBlock {\n    flex-basis: 30%;\n  }\n}\n.portfolio .textCode {\n  color: #9471fd;\n  font-size: 4vw;\n}\n@media screen and (min-width: 768px) {\n  .portfolio .textCode {\n    font-size: 2.3vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .portfolio .textCode {\n    font-size: 1.26vw;\n  }\n}\n.portfolio .textCode h3 {\n  color: #FFA3FD;\n}\n.portfolio .textCode p {\n  margin-left: 7px;\n}\n@media screen and (min-width: 1280px) {\n  .portfolio .textCode p {\n    margin-left: 10px;\n  }\n}\n\n.prePortfolio .textCode {\n  color: #9471fd;\n  font-size: 4.6vw;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .textCode {\n    font-size: 2vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .textCode {\n    font-size: 1.2vw;\n  }\n}\n.prePortfolio .textCode h3 {\n  color: #FFA3FD;\n}\n.prePortfolio .textCode p {\n  margin-left: 7px;\n}\n@media screen and (min-width: 768px) {\n  .prePortfolio .textCode p {\n    margin-left: 20px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .textCode p {\n    margin-left: 50px;\n  }\n}\n\n.imageSample {\n  height: 200px;\n  width: 80%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: center;\n  background: #191825;\n  border: 3px solid #F0CAA3;\n  box-shadow: 1px 1px 5px #000;\n}\n@media screen and (min-width: 1280px) {\n  .imageSample {\n    height: 250px;\n    width: 80%;\n  }\n}\n.imageSample .imgContainer {\n  flex-basis: 100%;\n  margin: 51px 5px 5px 5px;\n  height: 100%;\n  overflow: hidden;\n}\n.imageSample .imgContainer img {\n  -o-object-fit: cover;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n.imageSample .imageText {\n  position: absolute;\n  top: 0;\n  padding-top: 8px;\n  padding-bottom: 17px;\n  width: 100%;\n  color: #191825;\n  font-weight: bold;\n  text-align: center;\n  background: #F0CAA3;\n}\n.imageSample.first {\n  z-index: 3;\n  -webkit-animation: openingWindow 700ms ease-out 2100ms normal both;\n  animation: openingWindow 700ms ease-out 2100ms normal both;\n}\n.imageSample.first.fade {\n  -webkit-animation: closingWindow 700ms ease-out both;\n  animation: closingWindow 700ms ease-out both;\n}\n.imageSample.second {\n  z-index: 2;\n  -webkit-animation: openingWindow 700ms ease-out 1400ms normal both;\n  animation: openingWindow 700ms ease-out 1400ms normal both;\n}\n.imageSample.second.fade {\n  -webkit-animation: closingWindow 700ms ease-out both;\n  animation: closingWindow 700ms ease-out both;\n}\n.imageSample.third {\n  z-index: 1;\n  -webkit-animation: openingWindow 700ms ease-out 700ms normal both;\n  animation: openingWindow 700ms ease-out 700ms normal both;\n}\n.imageSample.third.fade {\n  -webkit-animation: closingWindow 700ms ease-out both;\n  animation: closingWindow 700ms ease-out both;\n}\n.imageSample.left {\n  position: absolute;\n  left: -3%;\n  top: 10%;\n}\n.imageSample.center {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.imageSample.right {\n  position: absolute;\n  right: -3%;\n  top: 20%;\n}\n.imageSample::before {\n  content: \"\";\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  border-radius: 3px;\n  background: #191825;\n  border: 2px solid #FFA3FD;\n  position: absolute;\n  z-index: 2;\n  right: 4px;\n  top: 5px;\n}\n.imageSample .closeButton {\n  cursor: pointer;\n  font-size: 23px;\n  font-weight: bold;\n  color: #FFA3FD;\n  position: absolute;\n  z-index: 3;\n  top: -1px;\n  right: 10px;\n}\n\n.imageHolder {\n  position: relative;\n  max-height: 400px;\n  transition: max-height 700ms ease-out;\n  width: 100%;\n}\n.imageHolder .holder {\n  height: 200px;\n}\n@media screen and (min-width: 1280px) {\n  .imageHolder .holder {\n    height: 270px;\n  }\n}\n.imageHolder.fade {\n  max-height: 0px;\n}\n\n.presentationText .imageSample {\n  height: 200px;\n  width: 90%;\n}\n@media screen and (min-width: 1280px) {\n  .presentationText .imageSample {\n    height: 600px;\n    width: 90%;\n  }\n}\n.presentationText .imageSample .closeButton {\n  top: 3px;\n  right: 11px;\n}\n.presentationText .imageHolder {\n  position: relative;\n  max-height: 650px;\n  transition: max-height 700ms ease-out;\n  width: 100%;\n}\n.presentationText .imageHolder .holder {\n  height: 700px;\n}\n@media screen and (min-width: 1280px) {\n  .presentationText .imageHolder .holder {\n    height: 700px;\n  }\n}\n.presentationText .imageHolder.fade {\n  max-height: 0px;\n}\n\n@media screen and (min-width: 1280px) {\n  .prePortfolio .imageSample {\n    height: 200px;\n    width: 60%;\n  }\n}\n.prePortfolio .imageHolder {\n  position: relative;\n  max-height: 400px;\n  transition: max-height 700ms ease-out;\n  width: 100%;\n}\n@media screen and (min-width: 1280px) {\n  .prePortfolio .imageHolder .holder {\n    height: 200px;\n  }\n}\n\n.tripleContainer {\n  display: flex;\n  align-items: center;\n}\n.tripleContainer .triplePhoto {\n  max-height: 430px;\n  max-width: 610px;\n  position: relative;\n  margin-right: 50vw;\n  margin-bottom: 22vw;\n  margin-top: 10vw;\n  scale: 1;\n}\n@media screen and (min-width: 768px) {\n  .tripleContainer .triplePhoto {\n    margin-top: 10vw;\n    margin-right: 43vw;\n    margin-bottom: 30vw;\n    scale: 0.8;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .tripleContainer .triplePhoto {\n    scale: 0.5;\n    margin-right: 15vw;\n    margin-top: 3vw;\n    margin-bottom: 12vw;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .tripleContainer .triplePhoto {\n    margin-top: 0;\n    margin-right: 15vw;\n    margin-bottom: 17vw;\n    margin-left: 0;\n    scale: 0.5;\n  }\n}\n.tripleContainer .triplePhoto::before {\n  content: \"\";\n  width: 40vw;\n  height: 40vw;\n  border-radius: 2vw;\n  border: 2px solid #9471fd;\n  position: absolute;\n  left: -5vw;\n  top: -5vw;\n  z-index: 0;\n  overflow: auto;\n}\n.tripleContainer .triplePhoto::after {\n  content: \"\";\n  width: 10vw;\n  height: 10vw;\n  border-radius: 2vw;\n  border: 2px solid #9471fd;\n  position: absolute;\n  left: 36vw;\n  top: 36vw;\n  z-index: 0;\n}\n.tripleContainer .triplePhoto .squareOne {\n  width: 40vw;\n  height: 40vw;\n  border-radius: 2vw;\n  position: absolute;\n  overflow: hidden;\n  z-index: 1;\n}\n.tripleContainer .triplePhoto .squareOne img {\n  position: absolute;\n  top: -1vw;\n  left: 0;\n  min-width: 61vw;\n  height: 50vw;\n}\n.tripleContainer .triplePhoto .squareTwo {\n  width: 20vw;\n  height: 20vw;\n  border-radius: 2vw;\n  position: absolute;\n  left: 41vw;\n  top: 6vw;\n  overflow: hidden;\n  z-index: 1;\n}\n.tripleContainer .triplePhoto .squareTwo img {\n  position: absolute;\n  left: -41vw;\n  top: -7vw;\n  min-width: 61vw;\n  height: 50vw;\n}\n.tripleContainer .triplePhoto .squareThree {\n  width: 15vw;\n  height: 15vw;\n  border-radius: 2vw;\n  position: absolute;\n  left: 41vw;\n  top: 27vw;\n  overflow: hidden;\n  z-index: 1;\n}\n.tripleContainer .triplePhoto .squareThree img {\n  position: absolute;\n  left: -41vw;\n  top: -28vw;\n  min-width: 61vw;\n  height: 50vw;\n}\n\n.two .jrpgstat .header .title {\n  flex-basis: 100%;\n  display: flex;\n  margin-left: 2%;\n  align-items: center;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .header .title {\n    flex-basis: 30%;\n  }\n}\n.two .jrpgstat .header .title h2 {\n  font-size: 15px;\n  text-shadow: 3px 3px 2px #191825;\n  left: 7%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .title h2 {\n    font-size: 1.5em;\n  }\n}\n.two .jrpgstat .header .title h2 .text {\n  position: relative;\n  z-index: 1;\n  width: 130px;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .title h2 .text {\n    width: 220px;\n  }\n}\n.two .jrpgstat .header .title h2::before {\n  content: \"\";\n  width: 130px;\n  height: 50px;\n  position: absolute;\n  background: #191825;\n  border-radius: 25px;\n  opacity: 0.5;\n  z-index: 0;\n  left: 105px;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .title h2::before {\n    width: 220px;\n  }\n}\n.two .jrpgstat .header .faces {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-right: 5%;\n  align-items: center;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .header .faces {\n    flex-basis: 40%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .header .faces {\n    margin-top: 20px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .faces {\n    margin-top: 0;\n    flex-basis: 30%;\n    margin-right: 0;\n    justify-content: space-around;\n  }\n}\n.two .jrpgstat .header .faces h3 {\n  font-size: 15px;\n  display: flex;\n  justify-content: center;\n}\n.two .jrpgstat .header .faces h3::after {\n  width: 100%;\n  left: 15%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .faces h3 {\n    font-size: 1.17em;\n  }\n}\n.two .jrpgstat .header .faces h3::before {\n  content: \"\";\n  width: 100px;\n  height: 30px;\n  position: absolute;\n  background: #191825;\n  border-radius: 25px;\n  opacity: 0.5;\n  z-index: -1;\n  left: 2%;\n  top: -6px;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .faces h3::before {\n    width: 120px;\n    top: -4px;\n    left: 17%;\n  }\n}\n.two .jrpgstat .header .faces img {\n  height: 25px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .header .faces img {\n    height: 40px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .header .faces img {\n    height: 50px;\n  }\n}\n\n.two .jrpgstat .body .stats .head {\n  padding-left: 5%;\n  padding-right: 1%;\n  flex-basis: 100%;\n  height: 120px;\n  -o-object-fit: cover;\n  object-fit: cover;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  margin-bottom: 10px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head {\n    height: 170px;\n    margin-bottom: 20px;\n    margin-top: -60px;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .head {\n    margin-bottom: -20px;\n    margin-top: -30px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head {\n    height: 170px;\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n}\n.two .jrpgstat .body .stats .head::before {\n  content: \"\";\n  width: 75%;\n  height: 100%;\n  background: #000;\n  opacity: 0.5;\n  position: absolute;\n  border-radius: 0 0 25px 0;\n  z-index: -1;\n  top: 0;\n  right: 5%;\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .head::before {\n    width: 80%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head::before {\n    width: 80%;\n  }\n}\n.two .jrpgstat .body .stats .head img {\n  height: 100%;\n}\n.two .jrpgstat .body .stats .head .nameHPandMana {\n  flex-basis: 70%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  position: relative;\n  padding-left: 0;\n  padding-top: 15px;\n  padding-right: 5%;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana {\n    padding-right: 0;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana {\n    padding-left: 30px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana {\n    padding-left: 15px;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .namePC {\n  flex-basis: 100%;\n  font-size: 12px;\n  display: flex;\n  justify-content: space-between;\n  padding-right: 5%;\n  padding-left: 5%;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .namePC {\n    font-size: 22px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .namePC {\n    font-size: 22px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .HP {\n  flex-basis: 40%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: 0;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .HP {\n    font-size: 22px;\n    margin-right: 10px;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .HP .points {\n  flex-basis: 100%;\n  font-size: 10px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .HP .points {\n    font-size: 20px;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .HP .bar {\n  flex-basis: 100%;\n  height: 15px;\n  border-radius: 15px;\n  background: linear-gradient(90deg, rgb(246, 115, 0) 0%, rgb(255, 198, 155) 100%);\n  border: 2px solid black;\n  position: relative;\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {\n  content: \"\";\n  width: 109%;\n  height: 17px;\n  border-radius: 15px;\n  border: 4px solid white;\n  position: absolute;\n  left: -4px;\n  top: -3px;\n  z-index: -1;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {\n    width: 104%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {\n    width: 103%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .HP .bar::after {\n    width: 104%;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .mana {\n  flex-basis: 40%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .mana .points {\n  flex-basis: 100%;\n  font-size: 10px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .mana .points {\n    font-size: 20px;\n  }\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .mana .bar {\n  flex-basis: 100%;\n  height: 15px;\n  border-radius: 15px;\n  background: linear-gradient(90deg, rgb(9, 9, 121) 0%, rgb(0, 212, 255) 100%);\n  border: 2px solid black;\n  position: relative;\n}\n.two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {\n  content: \"\";\n  width: 109%;\n  height: 17px;\n  border-radius: 15px;\n  border: 4px solid white;\n  position: absolute;\n  left: -4px;\n  top: -3px;\n  z-index: -1;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {\n    width: 104%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {\n    width: 103%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .head .nameHPandMana .mana .bar::after {\n    width: 104%;\n  }\n}\n\n.two .jrpgstat .body .stats .skills h3 {\n  width: 210px;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .skills h3 {\n    width: 230px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .skills h3 {\n    width: 285px;\n  }\n}\n.two .jrpgstat .body .stats .skills h3::before {\n  content: \"\";\n  width: 210px;\n  height: 30px;\n  position: absolute;\n  background: #191825;\n  border-radius: 25px;\n  opacity: 0.7;\n  z-index: -1;\n  left: 3%;\n  top: -6px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills h3::before {\n    left: 6%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .skills h3::before {\n    left: 12%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .skills h3::before {\n    width: 285px;\n    top: -4px;\n    left: 7%;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities {\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: center;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities {\n    height: 90%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .skills .capacities {\n    height: 90%;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity {\n  position: relative;\n  flex-basis: 45%;\n  border-radius: 5px;\n  padding: 2px 0px 2px 15px;\n  display: flex;\n  color: #FFF;\n  font-weight: bold;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity {\n    margin-bottom: 9px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity {\n    margin-bottom: 0;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity.active {\n  color: #000;\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(94, 94, 94) 100%);\n  border: 1px solid black;\n  border-radius: 5px;\n  padding: 2px 0px 2px 15px;\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity.active::before {\n  border: 2px solid #fff;\n  background: linear-gradient(0deg, rgb(74, 74, 74) 0%, rgb(185, 185, 185) 100%);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity img {\n  height: 20px;\n  margin-left: -7%;\n  position: relative;\n  z-index: 1;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity img {\n    height: 30px;\n    margin-left: -3%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity img {\n    margin-left: -1%;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .valueName {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n  top: 0;\n  bottom: 0;\n  margin-left: 2px;\n  font-size: 11px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity .valueName {\n    font-size: 15px;\n    margin-left: 15px;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: auto;\n  top: 0;\n  bottom: 0;\n  right: 19%;\n  z-index: 2;\n  flex-basis: 30%;\n  height: 12px;\n  border-radius: 15px;\n  background: rgb(74, 74, 74);\n  border: 2px solid #fff;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity .bar {\n    right: 22%;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  border-radius: 15px;\n  border: 1px solid #000;\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  border-radius: 15px;\n  background: linear-gradient(90deg, rgb(9, 9, 121) 0%, rgb(0, 212, 255) 100%);\n  transform-origin: left center;\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.zero::after {\n  transform: scaleX(0);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.five::after {\n  transform: scaleX(0.2);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.ten::after {\n  transform: scaleX(0.4);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.fiveteen::after {\n  transform: scaleX(0.6);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.twenty::after {\n  transform: scaleX(0.8);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .bar.twentyfive::after {\n  transform: scaleX(1);\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity .value {\n  position: absolute;\n  margin-right: 2%;\n  top: 25%;\n  right: 0;\n  font-size: 8px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .stats .skills .capacities .capacity .value {\n    font-size: 15px;\n  }\n}\n.two .jrpgstat .body .stats .skills .capacities .capacity.empty::before {\n  background: none;\n  border: none;\n}\n\n.two .jrpgstat .body .equipment {\n  flex-basis: 100%;\n  font-size: 10px;\n  margin-top: 10%;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .equipment {\n    margin-top: 5%;\n    font-size: 14px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment {\n    flex-basis: 40%;\n    margin-top: 0;\n    font-size: 13px;\n  }\n}\n.two .jrpgstat .body .equipment h3 {\n  width: 330px;\n  display: flex;\n  justify-content: center;\n  flex-basis: 100%;\n  margin: 0 0 15px 0;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment h3 {\n    margin: 20px 0 20px 7%;\n  }\n}\n.two .jrpgstat .body .equipment h3::before {\n  content: \"\";\n  width: 293px;\n  height: 30px;\n  position: absolute;\n  background: #191825;\n  border-radius: 25px;\n  opacity: 0.7;\n  z-index: -1;\n  left: 8%;\n  top: -6px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .equipment h3::before {\n    left: 9%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .equipment h3::before {\n    left: 11%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment h3::before {\n    left: 8%;\n    width: 320px;\n    top: -4px;\n  }\n}\n.two .jrpgstat .body .equipment h3.smallBack {\n  width: 92px;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment h3.smallBack {\n    width: 102px;\n  }\n}\n.two .jrpgstat .body .equipment h3.smallBack::before {\n  width: 90px;\n  left: 8%;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .equipment h3.smallBack::before {\n    left: 14%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .body .equipment h3.smallBack::before {\n    left: 20%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment h3.smallBack::before {\n    width: 92px;\n    left: 22%;\n  }\n}\n.two .jrpgstat .body .equipment .weapons {\n  width: 100%;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  font-family: \"Overpass\";\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .equipment .weapons {\n    width: 90%;\n  }\n}\n.two .jrpgstat .body .equipment .weapons .weapon {\n  margin: 10px 0 10px 0;\n  flex-basis: 90%;\n  height: 50px;\n  border-radius: 5px;\n  padding: 2px 0px 2px 2px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.two .jrpgstat .body .equipment .weapons .weapon::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(94, 94, 94) 100%);\n  border: 1px solid black;\n  border-radius: 5px;\n  padding: 2px 0px 2px 15px;\n}\n.two .jrpgstat .body .equipment .weapons .weapon.active::before {\n  border: 2px solid #fff;\n  background: linear-gradient(0deg, rgb(74, 74, 74) 0%, rgb(185, 185, 185) 100%);\n}\n.two .jrpgstat .body .equipment .weapons .weapon .value {\n  position: relative;\n  z-index: 2;\n  font-weight: bold;\n  color: #fff;\n  padding-left: 7px;\n  display: inline-block;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .body .equipment .weapons .weapon .value {\n    padding-left: 15px;\n  }\n}\n.two .jrpgstat .body .equipment .weapons .weapon.active .value {\n  color: #000;\n}\n.two .jrpgstat .body .equipment .weapons .weapon img {\n  height: 40px;\n  position: relative;\n  z-index: 1;\n}\n\n.two .jrpgstat .body .stats .skills {\n  flex-basis: 100%;\n  height: 60%;\n}\n.two .jrpgstat .body .caracter {\n  display: none;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .body .caracter {\n    display: block;\n    flex-basis: 20%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    height: 100%;\n  }\n}\n.two .jrpgstat .body .caracter img {\n  width: 100%;\n}\n\n.two .jrpgstat .footer .others {\n  flex-basis: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-right: 5%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer .others {\n    flex-basis: 35%;\n    justify-content: space-around;\n    margin-right: 0;\n  }\n}\n.two .jrpgstat .footer .others h3 {\n  position: relative;\n  width: 200px;\n  display: flex;\n  justify-content: center;\n}\n.two .jrpgstat .footer .others h3::after {\n  width: 100%;\n  left: 5%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer .others h3 {\n    width: 230px;\n    left: 10%;\n  }\n}\n.two .jrpgstat .footer .others h3::before {\n  content: \"\";\n  width: 180px;\n  height: 30px;\n  position: absolute;\n  background: #191825;\n  border-radius: 25px;\n  opacity: 0.7;\n  z-index: -1;\n  left: 7%;\n  top: -6px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .footer .others h3::before {\n    left: 11%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .two .jrpgstat .footer .others h3::before {\n    left: 14%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer .others h3::before {\n    width: 220px;\n    top: -4px;\n    left: 10%;\n  }\n}\n.two .jrpgstat .footer .others .other {\n  flex-basis: 33%;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 0%;\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer .others .other {\n    margin-left: 10%;\n    flex-basis: 27%;\n  }\n}\n.two .jrpgstat .footer .others .other img {\n  margin-left: 10px;\n  height: 25px;\n}\n@media screen and (min-width: 768px) {\n  .two .jrpgstat .footer .others .other img {\n    margin-left: 25px;\n    height: 50px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .two .jrpgstat .footer .others .other img {\n    height: 50px;\n  }\n}\n\n.four .form {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  font-family: \"Roboto\";\n  color: #F0CAA3;\n  font-weight: bolder;\n  position: relative;\n}\n.four .form label {\n  font-size: 15px;\n}\n@media screen and (min-width: 768px) {\n  .four .form label {\n    font-size: 20px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form label {\n    font-size: 20px;\n  }\n}\n.four .form .name, .four .form .email, .four .form .request {\n  display: flex;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 1280px) {\n  .four .form .name, .four .form .email, .four .form .request {\n    display: block;\n    flex-wrap: nowrap;\n  }\n}\n.four .form input {\n  background: none;\n  border: none;\n  border-bottom: 4px solid #F0CAA3;\n  font-size: 15px;\n}\n@media screen and (min-width: 768px) {\n  .four .form input {\n    font-size: 25px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form input {\n    font-size: 25px;\n  }\n}\n.four .form input:focus {\n  outline: none;\n  border-bottom: 4px solid #FFA3FD;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.four .form {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n.four .form h2 {\n  height: 20%;\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  margin-top: 45px;\n}\n@media screen and (min-width: 768px) {\n  .four .form h2 {\n    font-size: 70px;\n    margin-top: -30px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form h2 {\n    margin-top: 0;\n    font-size: 70px;\n  }\n}\n.four .form p {\n  flex-basis: 80%;\n  display: flex;\n  justify-content: center;\n  font-size: 15px;\n  margin-bottom: 40px;\n}\n@media screen and (min-width: 768px) {\n  .four .form p {\n    font-size: 22px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form p {\n    font-size: 33px;\n    margin-bottom: 0;\n  }\n}\n.four .form .formInputs {\n  flex-basis: 90%;\n  height: 50%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n.four .form .formInputs .error {\n  font-size: 13px;\n  position: absolute;\n  bottom: -20px;\n  left: 0;\n}\n@media screen and (min-width: 768px) {\n  .four .form .formInputs .error {\n    font-size: 17px;\n    bottom: -4%;\n  }\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .four .form .formInputs .error {\n    bottom: -22%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .error {\n    bottom: 10%;\n    left: 50%;\n    font-size: 18px;\n  }\n}\n.four .form .formInputs .error.requestArea {\n  bottom: -6%;\n  left: 0;\n}\n@media screen and (min-width: 768px) {\n  .four .form .formInputs .error.requestArea {\n    bottom: -7%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .error.requestArea {\n    bottom: -15%;\n  }\n}\n.four .form .formInputs .name, .four .form .formInputs .email {\n  position: relative;\n  height: 20%;\n  display: flex;\n  flex-basis: 100%;\n  margin-bottom: 35px;\n}\n@media screen and (min-width: 1024px) and (min-height: 600px) {\n  .four .form .formInputs .name, .four .form .formInputs .email {\n    flex-basis: 48%;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .name, .four .form .formInputs .email {\n    margin-bottom: 0;\n    flex-basis: 45%;\n  }\n}\n.four .form .formInputs .name input, .four .form .formInputs .email input {\n  height: 50px;\n  flex-basis: 100%;\n  cursor: pointer;\n  padding-left: 15px;\n}\n.four .form .formInputs .name inputfocus, .four .form .formInputs .email inputfocus {\n  cursor: pointer;\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .name input, .four .form .formInputs .email input {\n    flex-basis: 80%;\n  }\n}\n.four .form .formInputs .request {\n  position: relative;\n  flex-basis: 100%;\n  display: flex;\n}\n.four .form .formInputs .request label {\n  flex-basis: 100%;\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .request label {\n    flex-basis: 10%;\n  }\n}\n.four .form .formInputs .request textarea {\n  font-size: 15px;\n  background: none;\n  height: 300px;\n  flex-basis: 100%;\n  border: 4px solid #F0CAA3;\n  vertical-align: sub;\n  padding: 15px;\n  resize: none;\n  cursor: pointer;\n  margin-top: 5px;\n}\n@media screen and (min-width: 768px) {\n  .four .form .formInputs .request textarea {\n    font-size: 25px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .request textarea {\n    flex-basis: 90%;\n    margin-top: 0;\n    font-size: 25px;\n  }\n}\n.four .form .formInputs .request textarea:focus {\n  outline: none;\n  border: 4px solid #FFA3FD;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.four .form .formInputs .button-form {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n.four .form .formInputs .button-form button {\n  flex-basis: 40%;\n  background: none;\n  border: 4px solid #F0CAA3;\n  font-family: \"Roboto\";\n  font-weight: bolder;\n  font-size: 15px;\n  height: 50px;\n  color: #F0CAA3;\n  margin-top: 25px;\n  margin-bottom: 40px;\n  padding: 10px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  z-index: 1;\n}\n@media screen and (min-width: 1280px) {\n  .four .form .formInputs .button-form button {\n    flex-basis: 20%;\n    font-size: 20px;\n    margin-bottom: 0;\n  }\n}\n.four .form .formInputs .button-form button:hover {\n  color: #191825;\n}\n.four .form .formInputs .button-form button:hover::after {\n  opacity: 1;\n  transform: scale(2, 6);\n}\n.four .form .formInputs .button-form button::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(to right, rgb(91.3139087411%, 69.3091442184%, 46.7253069452%), rgb(100%, 43.9215686275%, 98.7809036658%));\n  opacity: 0;\n  z-index: -1;\n  transform: scale(0, 0) rotate(90deg);\n  transition: all 1000ms;\n}\n.four .form .response {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.four .form .response::before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 50;\n  opacity: 0.5;\n  background: #000;\n  width: 100%;\n  height: 100%;\n}\n.four .form .response .window {\n  position: fixed;\n  width: 350px;\n  height: 180px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: auto;\n  margin-bottom: auto;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 51;\n  background: #9471fd;\n  border: 4px solid #F0CAA3;\n  display: flex;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 768px) {\n  .four .form .response .window {\n    height: 200px;\n    width: 400px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .four .form .response .window {\n    height: 200px;\n    width: 400px;\n  }\n}\n.four .form .response .window .text {\n  color: #F0CAA3;\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  padding-top: 70px;\n}\n.four .form .response .window button {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  width: 100px;\n  height: 40px;\n  border: none;\n  border: 2px solid #F0CAA3;\n  color: #F0CAA3;\n  background: #9471fd;\n  font-weight: bolder;\n  cursor: pointer;\n}\n\n.five {\n  font-size: 35px;\n  font-weight: lighter;\n  color: #F0CAA3;\n  font-family: \"Bahnschrift\";\n}\n@media screen and (min-width: 1280px) {\n  .five {\n    right: 2%;\n    top: 15px;\n  }\n}\n.five .menu {\n  padding-top: 5%;\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  background: #191825;\n  z-index: 20;\n}\n.five .menu .menuSection {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  margin-top: 2%;\n}\n@media screen and (min-width: 1280px) {\n  .five .menu .menuSection {\n    flex-basis: 50%;\n  }\n}\n.five .menu span {\n  display: block;\n  margin-bottom: 20px;\n  font-size: 20px;\n  padding-left: 20px;\n  font-weight: bold;\n  flex-basis: 100%;\n}\n@media screen and (min-width: 1280px) {\n  .five .menu span {\n    font-size: 35px;\n    flex-basis: 50%;\n    padding-left: 0;\n  }\n}\n.five .menu .copyright {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 4%;\n}\n.five .menu .copyright span {\n  display: flex;\n  justify-content: center;\n  font-size: 15px;\n}\n@media screen and (min-width: 1280px) {\n  .five .menu .copyright span {\n    font-size: 25px;\n  }\n}\n.five .menu ul {\n  list-style: none;\n  margin-left: 15px;\n}\n.five .menu ul li {\n  margin-bottom: 20px;\n}\n.five .menu ul li a {\n  position: relative;\n  color: #F0CAA3;\n  font-size: 20px;\n}\n@media screen and (min-width: 1280px) {\n  .five .menu ul li a {\n    font-size: 25px;\n  }\n}\n.five .menu ul li a::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0);\n  height: 2px;\n  bottom: -10px;\n  left: 0;\n  background-color: #F0CAA3;\n  transform-origin: top right;\n  transition: transform 0.6s ease-out;\n}\n.five .menu ul li a:hover::after {\n  transform: scaleX(1);\n}\n.five .menu ul li a::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0);\n  height: 2px;\n  top: -11px;\n  left: 0;\n  background-color: #F0CAA3;\n  transform-origin: bottom left;\n  transition: transform 0.6s ease-out;\n}\n.five .menu ul li a:hover::before {\n  transform: scaleX(1);\n}\n.five .menu ul .reversed a::after {\n  transform-origin: bottom left;\n}\n.five .menu ul .reversed a::before {\n  transform-origin: top right;\n}\n.five .menu ul.lang {\n  display: flex;\n  font-weight: bold;\n  justify-content: space-around;\n  flex-basis: 100%;\n}\n.five .menu ul.lang li {\n  cursor: pointer;\n  font-size: 15px;\n  color: #F0CAA3;\n}\n@media screen and (min-width: 1280px) {\n  .five .menu ul.lang li {\n    font-size: 20px;\n  }\n}\n.five .menu ul.lang li.activated {\n  color: #FFA3FD;\n  text-decoration: overline;\n}\n.five .sousMenu {\n  margin-left: 25px;\n  position: relative;\n}\n.five .sousMenu::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-left: 2px solid #F0CAA3;\n  border-bottom: 2px solid #F0CAA3;\n  position: absolute;\n  left: -15px;\n  top: 10px;\n}\n.five .logo {\n  color: #9471fd;\n  font-size: 25px;\n  margin-top: 15px;\n  height: 160px;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  width: 228px;\n}\n@media screen and (min-width: 1280px) {\n  .five .logo {\n    width: 325px;\n    font-size: 37px;\n  }\n}\n.five .logo .image {\n  width: 70px;\n  height: 70px;\n  position: relative;\n  left: 40%;\n  margin-bottom: 5px;\n}\n.five .logo .image::before {\n  content: \"\";\n  position: absolute;\n  top: 62px;\n  left: -52px;\n  width: 55px;\n  height: 3px;\n  background: #9471fd;\n}\n.five .logo .image::after {\n  content: \"\";\n  position: absolute;\n  top: 62px;\n  left: 60px;\n  width: 55px;\n  height: 3px;\n  background: #9471fd;\n}\n.five .logo .text {\n  position: relative;\n}\n.five .logo .text .name {\n  font-family: \"BrunoAce\";\n  flex-basis: 100%;\n}\n.five .logo .text .name::before {\n  content: \"\";\n  width: 250px;\n  height: 3px;\n  background: #9471fd;\n  position: absolute;\n  top: 0px;\n  left: -12px;\n}\n@media screen and (min-width: 1280px) {\n  .five .logo .text .name::before {\n    width: 350px;\n  }\n}\n.five .logo .text .function {\n  font-stretch: condensed;\n  font-weight: 100;\n  position: absolute;\n  top: 27px;\n  width: 228px;\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 1280px) {\n  .five .logo .text .function {\n    width: 325px;\n    top: 37px;\n  }\n}\n\n.lapantherePresentation {\n  color: #9471fd;\n  display: flex;\n  flex-wrap: wrap;\n}\n.lapantherePresentation h1 {\n  color: #FFA3FD;\n  font-size: 40px;\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n@media screen and (min-width: 768px) {\n  .lapantherePresentation h1 {\n    font-size: 50px;\n  }\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation h1 {\n    font-size: 70px;\n    margin-top: 0;\n  }\n}\n.lapantherePresentation h2 {\n  margin-bottom: 15px;\n}\n.lapantherePresentation .back {\n  position: relative;\n  flex-basis: 80%;\n  margin-top: 20px;\n}\n.lapantherePresentation .back a {\n  color: #F0CAA3;\n  font-size: 15px;\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation .back a {\n    font-size: 20px;\n  }\n}\n.lapantherePresentation .back a .arrow {\n  width: 15px;\n  height: 15px;\n  border-top: 3px solid #F0CAA3;\n  border-left: 3px solid #F0CAA3;\n  transform: rotate(-45deg);\n  position: absolute;\n  top: 1px;\n  left: -15px;\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation .back a .arrow {\n    top: 3px;\n  }\n}\n.lapantherePresentation p {\n  margin: 25px;\n  font-size: 18px;\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation p {\n    margin: 70px;\n    font-size: 25px;\n  }\n}\n.lapantherePresentation .avant, .lapantherePresentation .apres {\n  flex-basis: 100%;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation .avant, .lapantherePresentation .apres {\n    flex-basis: 30%;\n    margin-bottom: 0;\n  }\n}\n.lapantherePresentation .avant img, .lapantherePresentation .apres img {\n  max-width: 500px;\n  width: 100%;\n}\n@media screen and (min-width: 1280px) {\n  .lapantherePresentation .avant img, .lapantherePresentation .apres img {\n    width: 100%;\n  }\n}\n.lapantherePresentation .rapport {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 40px;\n}\n.lapantherePresentation .rapport h2 {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n}\n.lapantherePresentation .rapport a {\n  color: #F0CAA3;\n  font-size: 20px;\n}\n\n.administration {\n  margin-top: 50px;\n  padding: 15px 0 50px 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #F0CAA3;\n  border: 2px solid #F0CAA3;\n  border-radius: 15px;\n  position: relative;\n}\n.administration input[type=text] {\n  height: 35px;\n  background-color: transparent;\n  border: 2px solid #F0CAA3;\n  border-radius: 10px;\n  color: #F0CAA3;\n  font-size: 1rem;\n  padding-left: 5px;\n}\n.administration input[type=text]:focus {\n  outline: none;\n}\n.administration .textarea {\n  resize: none;\n  font-family: \"Bahnschrift\";\n  background-color: transparent;\n  border: 2px solid #F0CAA3;\n  border-radius: 10px;\n  color: #F0CAA3;\n  padding-left: 5px;\n  padding-top: 5px;\n  font-size: 1.2rem;\n  font-weight: 100;\n}\n.administration .textarea:focus {\n  outline: none;\n}\n.administration .text-description {\n  height: 250px;\n}\n.administration .text-technologies {\n  height: 150px;\n}\n.administration .admin-categories {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  width: 100%;\n}\n.administration .admin-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 90%;\n  background-color: #191825;\n  min-height: 50px;\n  border-radius: 15px;\n  margin: 10px 0;\n  border: 2px solid #F0CAA3;\n  padding-top: 10px;\n  position: relative;\n}\n.administration .admin-panel h2 {\n  margin-bottom: 10px;\n}\n.administration .admin-panel .presentation {\n  display: flex;\n  flex-direction: row;\n  margin: 20px;\n}\n.administration .admin-panel .presentation .presentation-text {\n  background-color: transparent;\n  border-radius: 15px;\n  padding: 15px;\n  margin: 10px;\n  width: 33%;\n  border: 2px solid #F0CAA3;\n}\n.administration .admin-panel .presentation .presentation-text h4 {\n  margin-bottom: 10px;\n}\n.administration .contact-message {\n  min-width: 670px;\n  height: 450px;\n  border-radius: 15px;\n  padding: 15px;\n  border: 2px solid #F0CAA3;\n  font-size: 1.2rem;\n  margin-left: 15px;\n  margin-bottom: 10px;\n}\n.administration .contact-message .message-field {\n  height: 230px;\n  overflow-y: scroll;\n}\n.administration .no-new-message {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  height: 150px;\n  font-size: 2rem;\n}\n.administration .contact-sub-panel {\n  display: flex;\n  flex-direction: row;\n  width: 90%;\n  border: 2px solid #F0CAA3;\n  border-radius: 15px;\n  padding: 10px 0 10px 0;\n  margin: 10px;\n  overflow-x: scroll;\n}\n.administration .devStat-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.administration .devStat {\n  width: 20%;\n  background-color: transparent;\n  border-radius: 10px;\n  min-width: 300px;\n  margin: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #F0CAA3;\n  border: 2px solid #F0CAA3;\n  cursor: pointer;\n}\n.administration .devStat .index-image {\n  display: flex;\n  align-items: center;\n}\n.administration .devStat.selected {\n  background-color: #F0CAA3;\n  color: #191825;\n}\n.administration .devStat.newSelected {\n  background-color: greenyellow;\n  color: #191825;\n}\n.administration .weapon-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.administration .weapon {\n  width: 90%;\n  background-color: transparent;\n  border-radius: 10px;\n  min-width: 300px;\n  margin: 10px 0 10px 0;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #F0CAA3;\n  border: 2px solid #F0CAA3;\n  padding: 10px;\n  cursor: pointer;\n}\n.administration .weapon .index-image {\n  display: flex;\n  align-items: center;\n}\n.administration .weapon.selected {\n  background-color: #F0CAA3;\n  color: #191825;\n}\n.administration .weapon.newSelected {\n  background-color: greenyellow;\n  color: #191825;\n}\n.administration .weapon-box {\n  display: flex;\n  flex-direction: row;\n}\n.administration .weapon-list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 70%;\n  border: 2px solid #F0CAA3;\n  border-radius: 10px;\n  overflow-y: scroll;\n  height: 525px;\n}\n.administration .weapon-options {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 30%;\n  align-items: center;\n  justify-content: flex-start;\n  height: 300px;\n}\n.administration .weapon-options div {\n  width: 90%;\n  display: flex;\n  justify-content: space-between;\n}\n.administration .weapon-options div label {\n  padding-top: 10px;\n}\n.administration .weapon-options input[type=text] {\n  width: 270px;\n}\n.administration .admin-sub-panel {\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  border: 2px solid #F0CAA3;\n  border-radius: 15px;\n  padding: 10px;\n  margin: 10px;\n}\n.administration .project-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  overflow-x: scroll;\n}\n.administration .project-list .project {\n  background-color: transparent;\n  border-radius: 10px;\n  min-width: 400px;\n  margin: 15px;\n  height: 350px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #F0CAA3;\n  border: 2px solid #F0CAA3;\n  cursor: pointer;\n}\n.administration .project-list .project .project-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.administration .project-list .project .project-description {\n  font-size: 1.1rem;\n  margin-bottom: 15px;\n}\n.administration .project-list .project.selected {\n  background-color: #F0CAA3;\n  color: #191825;\n}\n.administration .project-list .project.newSelected {\n  background-color: greenyellow;\n  color: #191825;\n}\n.administration .project-option {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.administration .project-sub-option {\n  width: 48%;\n  margin-left: 1%;\n  display: flex;\n  flex-direction: column;\n}\n.administration .photo-field {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.administration .photo-option-presentation {\n  display: flex;\n  flex-direction: column;\n}\n.administration .photo-option-presentation label {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.administration .photo-option-presentation img {\n  width: 200px;\n  margin-bottom: 5px;\n}\n.administration .photo-option .button-field {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  margin-left: 0;\n}\n.administration .photo-option .button-field button {\n  margin-left: 0;\n  margin-right: 5px;\n  width: 110px;\n}\n.administration .openClose, .administration .openCloseClose {\n  font-size: 2rem;\n  cursor: pointer;\n  position: absolute;\n  right: 25px;\n  top: 5px;\n}\n.administration .openClose {\n  rotate: -90deg;\n}\n.administration .openCloseClose {\n  rotate: 90deg;\n}\n.administration .button-field {\n  width: 100%;\n  margin: 20px;\n}\n.administration .button-field button {\n  margin-left: 15px;\n}\n.administration .option-field {\n  margin: 20px;\n  position: relative;\n}\n.administration .option-field img {\n  position: absolute;\n  top: 2px;\n  left: -20px;\n}\n.administration .option-field .textfield {\n  margin-left: 15px;\n  border: 2px solid #F0CAA3;\n  background-color: transparent;\n  height: 35px;\n  width: 250px;\n  border-radius: 10px;\n  color: #F0CAA3;\n  font-size: 1.2rem;\n  font-weight: bold;\n  padding-left: 10px;\n}\n.administration .option-field .textfield:focus {\n  outline: none;\n}\n.administration .option-field .numberfield {\n  margin-left: 15px;\n  height: 35px;\n  padding-left: 10px;\n  padding-right: 5px;\n  background-color: transparent;\n  border: 2px solid #F0CAA3;\n  color: #F0CAA3;\n  font-size: 1.2rem;\n  border-radius: 10px;\n}\n.administration .option-field .numberfield:focus {\n  outline: none;\n}\n.administration .option-field .filefield {\n  margin-left: 15px;\n  height: 35px;\n  padding-left: 10px;\n  padding-right: 5px;\n  background-color: transparent;\n  color: #F0CAA3;\n  font-size: 1.2rem;\n  border-radius: 10px;\n}\n.administration input::file-selector-button {\n  height: 35px;\n  background-color: transparent;\n  border: 2px solid #F0CAA3;\n  color: #F0CAA3;\n  font-size: 1.2rem;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.administration input::file-selector-button:hover {\n  background-color: #F0CAA3;\n  color: #191825;\n}\n.administration .language-selector {\n  display: flex;\n  flex-direction: row;\n}\n.administration .language-selector .language {\n  cursor: pointer;\n}\n\n.button-alert {\n  cursor: pointer;\n  width: 150px;\n  height: 50px;\n  border: 2px solid #F0CAA3;\n  border-radius: 10px;\n  background-color: transparent;\n  color: #F0CAA3;\n  font-family: \"Bahnschrift\";\n  font-size: 1.2rem;\n}\n.button-alert:hover {\n  background-color: #F0CAA3;\n  color: #191825;\n}\n.button-alert.delete {\n  background-color: rgb(185, 49, 49);\n  color: #191825;\n}\n.button-alert.delete:hover {\n  background-color: rgb(255, 104, 104);\n  color: #000;\n}\n\n.admin-navigation {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 15px;\n  left: 15px;\n}\n.admin-navigation-button {\n  margin-right: 10px;\n  margin-left: 10px;\n  cursor: pointer;\n  color: #F0CAA3;\n}\n.admin-navigation-button:hover {\n  text-decoration: underline;\n}\n\nselect {\n  cursor: pointer;\n}\n\noption {\n  background-color: #191825;\n}\n\n.top {\n  rotate: 90deg;\n}\n\n.bottom {\n  rotate: -90deg;\n}\n\n.devstat-selector {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  width: 100%;\n}\n.devstat-selector .devstat-input {\n  width: 30% !important;\n}\n\n.empty-alert-box {\n  display: none;\n}\n\n.alert-box {\n  position: absolute;\n  display: inline-block;\n  top: 0;\n  left: 0;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  font-family: \"Bahnschrift\";\n}\n.alert-box::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 100%;\n  font-size: 1.2rem;\n  text-align: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  background-color: black;\n  opacity: 0.8;\n}\n.alert-box .alert-box-title {\n  padding-left: 15px;\n  padding-top: 15px;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n.alert-box .alert-box-message {\n  display: flex;\n  justify-content: center;\n  margin: 20px;\n  font-size: 1.2rem;\n}\n.alert-box .alert-box-buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.alert-box-success {\n  padding: 15px;\n  border-radius: 10px;\n  margin: 20px 0;\n  background-color: #191825;\n  color: #F0CAA3;\n  border: 2px solid #F0CAA3;\n  position: sticky;\n  top: 40%;\n  left: 50%;\n  translate: -50%;\n  z-index: 11;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 600px;\n}\n.alert-box-error {\n  padding: 15px;\n  border-radius: 10px;\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 2px solid #f5c6cb;\n}\n\n.cookies {\n  font-family: \"Bahnschrift\";\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.cookies__panel {\n  width: 700px;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 30px;\n  border: 2px solid #F0CAA3;\n  border-radius: 15px;\n  background-color: #191825;\n  color: #F0CAA3;\n}\n.cookies__panel .lang-choice {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.cookies__panel .lang-choice .lang {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.cookies button {\n  margin-left: 15px;\n  margin-top: 15px;\n}\n.cookies::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: black;\n  opacity: 50%;\n  z-index: 10;\n}\n\n.cookie-button-open {\n  position: absolute;\n  font-family: \"Bahnschrift\";\n  bottom: -2px;\n  left: 10px;\n  width: 160px;\n  height: 50px;\n  color: #FFA3FD;\n  background-color: #191825;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px 15px 0 0;\n  margin-left: 20px;\n  font-weight: bold;\n  border: 2px solid #F0CAA3;\n  z-index: 10;\n}\n.cookie-button-open:hover {\n  cursor: pointer;\n  color: #191825;\n  background-color: #F0CAA3;\n  border: 2px solid #FFA3FD;\n}","@keyframes slideshow {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(-874px);\n    }\n}\n\n@keyframes openingWindow {\n    0%{\n        opacity:0;\n        transform: scale(0);\n    }\n\n    100%{\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes closingWindow {\n    0%{\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    100%{\n        opacity:0;\n        transform: scale(0);\n    }\n}\n\n@keyframes topBarMoving {\n    0%{\n        top:100%;\n        transform: scaleY(1);\n        opacity: 0;\n    }\n\n    13%{\n        transform: scaleY(50);\n    }\n\n    25%{\n        top: 0%;\n        transform: scaleY(1);\n    }\n\n    38%{\n        transform: scaleY(50);\n    }\n\n    50%{\n        top: 100%;\n        transform: scaleY(1);\n    }\n\n    60%{\n        transform: scaleY(50);\n    }\n\n    70%{\n        top: 0%;\n        transform: scaleY(1);\n    }\n\n    80%{\n        transform: scaleY(50);\n    }\n\n    90%{\n        top: 100%;\n        transform: scaleY(1);\n    }\n\n    95%{\n        transform: scaleY(50);\n        opacity: 0.5;\n    }\n\n    99%{\n        top: 0%;\n        transform: scaleY(1);\n        opacity: 1;\n    }\n\n    100%{\n        opacity: 0;\n    }\n}\n\n@keyframes bottomBarMoving {\n    0%{\n        bottom:100%;\n        transform: scaleY(1);\n        opacity: 0;\n    }\n\n    13%{\n        transform: scaleY(50);\n    }\n\n    25%{\n        bottom: 0%;\n        transform: scaleY(1);\n    }\n\n    38%{\n        transform: scaleY(50);\n    }\n\n    50%{\n        bottom: 100%;\n        transform: scaleY(1);\n    }\n\n    60%{\n        transform: scaleY(50);\n    }\n\n    70%{\n        bottom: 0%;\n        transform: scaleY(1);\n    }\n\n    80%{\n        transform: scaleY(50);\n    }\n\n    90%{\n        bottom: 100%;\n        transform: scaleY(1);\n    }\n\n    95%{\n        transform: scaleY(50);\n        opacity: 0.5;\n    }\n\n    99%{\n        bottom: 0%;\n        transform: scaleY(1);\n        opacity: 1;\n    }\n\n    100%{\n        opacity: 0;\n    }\n}\n\n@keyframes menuButtonTop {\n\n    0% {\n        transform-origin: right center;\n        transform: rotate(0deg);\n\n    }\n    100% {\n        transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg) ;\n    }\n\n}\n\n@keyframes menuCloseButtonTop {\n\n    0% {\n        transform: scaleX(0.6) scaleY(1.2) translateY(10px) rotate(30deg) ;\n    }\n\n    100% {\n        transform-origin: right center;\n        transform: rotate(0deg);\n\n    }\n}\n\n@keyframes menuButtonBottom {\n\n    0% {\n        transform-origin: left center;\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: translate(-5px, -3px) rotate(-50deg) ;\n    }\n\n}\n\n@keyframes menuCloseButtonBottom {\n\n    0% {\n        transform: translate(-5px, -3px) rotate(-50deg) ;\n    }\n\n    100% {\n        transform-origin: left center;\n        transform: rotate(0deg);\n        \n\n    }\n}\n\n@keyframes introductionArrow {\n    0% {\n        transform: translateY(50px);\n    }\n\n    50% {\n        transform: translateY(30px);\n    }\n    100% { \n        transform: translateY(50px);\n    }\n}\n\n@keyframes introductionArrow2 {\n    0% {\n        transform: translateY(52px);\n    }\n\n    50% {\n        transform: translateY(32px);\n    }\n    100% { \n        transform: translateY(52px);\n    }\n}","*, ::before, ::after {\n\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    scroll-behavior: smooth;\n}\n\na {\n\n    text-decoration: none;\n}\n\n#root {\n\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 100vh;\n    height: 100%;\n    align-items: center;\n    white-space: pre-line;\n\n    .app-body {\n\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        height: 100%;\n        position: relative;\n        background: $neutral_color;\n        font-family: \"Bahnschrift\";\n\n        main {\n            \n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            width: 90%;\n            margin-bottom: 50px;\n            position: relative;\n            margin-left: auto;\n            margin-right: auto;\n            left: 0;\n            right: 0;\n\n            @include tablet-only {\n\n                width: 100%;\n            }\n\n            @include desktop-only {\n\n                width: 90%;    \n            }\n\n            .portfolio {\n\n                flex-basis: 100%;\n                display: flex;\n                flex-wrap: wrap;\n                justify-content: space-around;\n                align-items: baseline;\n\n                @include tablet-only {\n\n                    width: 100%;    \n                }\n        \n                @include desktop-only {\n\n                    width: 95%;    \n                }\n            }\n        }\n    }\n}\n\nbody {\n    position: relative;\n}","// NIGHT PALETTE\n\n$neutral_color : #191825;\n$neutral_alt_color: #000;\n$primary_color: #9471fd;\n$secondary_color: #FFA3FD;\n$tertiary_color: #F0CAA3;\n\n// CANDYSHOP PALETTE\n\n// $neutral_color : #FDF4F5;\n// $neutral_alt_color: #000;\n// $primary_color: #3580a8;\n// $secondary_color: #a84f76;\n// $tertiary_color: #BA90C6 ;\n\n// RED BLUE PALETTE\n\n// $neutral_color : #FDF4F5;\n// $neutral_alt_color: #000;\n// $primary_color: #08D9D6;\n// $secondary_color: #797777;\n// $tertiary_color: #FF2E63 ;\n\n// OCEAN PALETTE\n\n// $neutral_color : #FFF;\n// $neutral_alt_color: #0A2647;\n// $primary_color: #5170FD;\n// $secondary_color: #4636FC;\n// $tertiary_color:  #60ABFB;\n\n// RUBY PALETTE\n\n// $neutral_color : #FAF8F1;\n// $neutral_alt_color: #4C0033;\n// $primary_color: #790252;\n// $secondary_color: #AF0171;\n// $tertiary_color:  #E80F88;\n\n// // PEACH PALETTE\n\n// $neutral_color : #FFF;\n// $neutral_alt_color: #000;\n// $primary_color: #FF9494;\n// $secondary_color: #b35858;\n// $tertiary_color:  #f36666;\n\n// GOLD PALETTE\n\n// $neutral_color : #000;\n// $neutral_alt_color: #000;\n// $primary_color: #ee9b00;\n// $secondary_color: #916f00;\n// $tertiary_color:  #fdd17f;\n\n$slidingTextWidth: 97%;\n\n$breakpoints: (\n    tablet: 768px,\n    desktop: 1280px,\n);","@mixin desktop-only {\n    @media screen and (min-width: map-get($breakpoints, desktop)){\n        @content;\n    }\n}\n\n@mixin tablet-only {\n    @media screen and (min-width: map-get($breakpoints, tablet)){\n         @content;\n    }\n}\n\n@mixin small-desktop-only {\n    @media screen and (min-width: 1024px) and (min-height: 600px){\n         @content;\n    }\n}","header {\n\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    z-index: 3;\n\n    &::after {\n\n        content: \"\";\n        width: $slidingTextWidth;\n        height: 2px;\n        position: absolute;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        background: $primary_color;\n        z-index: -1;\n    }\n}","footer {\n    \n    display: flex;\n    align-items: center;\n    background: $neutral_color;\n    padding-top: 25px;\n    flex-direction: column;\n    color: $primary_color;\n    font-weight: bold;\n    border-radius: 20px 20px 0 0;\n    position: relative;\n\n    img {\n\n        width: 50px;\n    }\n\n    .copyright {\n        \n        padding: 15px 0 15px 0;\n    }\n\n    &::before {\n\n        content: \"\";\n        width: $slidingTextWidth;\n        height: 2px;\n        position: absolute;\n        top: 0px;\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        background: $primary_color;\n    }\n}\n\n.secret-link{\n    color: $tertiary_color;\n    margin-left: 5px;\n    cursor: default;\n}","header {\n\n    font-family: \"Bahnschrift\";\n\n    .logo {\n\n        color: $primary-color;\n        font-size: 25px;\n        margin-top: 15px;\n        height: 160px;\n        position: relative;\n        margin-left: auto;\n        margin-right: auto;\n\n\n        @include desktop-only {\n\n            font-size: 37px;\n        }\n\n        .image {\n\n            width: 70px;\n            height: 70px;\n            position: relative;\n            left: 40%;\n            margin-bottom: 5px;\n\n            &::before {\n\n                content: \"\";\n                position: absolute;\n                top: 62px;\n                left: -52px;\n                width: 55px;\n                height: 3px;\n                background: $primary-color;\n            }\n\n            &::after {\n\n                content: \"\";\n                position: absolute;\n                top: 62px;\n                left: 60px;\n                width: 55px;\n                height: 3px;\n                background: $primary-color;\n            }\n        }\n\n        .text {\n\n            position: relative;\n\n            .name {\n\n                font-family: \"BrunoAce\";\n                flex-basis: 100%;\n    \n                &::before {\n\n                    content: \"\";\n                    width: 250px;\n                    height: 3px;\n                    background: $primary-color;\n                    position: absolute;\n                    top: 0px;\n                    left: -12px;\n            \n                    @include desktop-only {\n\n                        width: 350px;\n                    }\n                }\n            }\n    \n            .function {\n\n                font-stretch: condensed;\n                font-weight: 100;\n                position: absolute;\n                top: 27px;\n                min-width: 233px;\n                display: flex;\n                justify-content: center;\n        \n                @include desktop-only {\n\n                    width: 325px;\n                    top: 37px;\n                }\n            }\n        }\n    }\n}","nav {\n\n    position: absolute;\n    display: block;\n    font-size: 25px;\n    font-weight: lighter;\n    color: $tertiary_color;\n    right: 5%;\n    top: 35px;\n    font-family: \"Bahnschrift\";\n\n    @include desktop-only {\n\n        right: 2%;\n        top: 15px;\n    }\n\n    .openButton {\n\n        position: relative;\n        cursor: pointer;\n        width: 40px;\n        height: 18px;\n        z-index: 21;\n\n        &.opened {\n\n            &::before {\n\n                -webkit-animation: menuButtonTop 700ms ease-out normal both;\n                        animation: menuButtonTop 700ms ease-out normal both;\n            }\n        \n            &::after {\n\n                -webkit-animation: menuButtonBottom 700ms ease-out normal both;\n                        animation: menuButtonBottom 700ms ease-out normal both;\n            }\n        }\n\n        &.closed {\n\n            &::before {\n\n                -webkit-animation: menuCloseButtonTop 700ms ease-out normal both;\n                animation: menuCloseButtonTop 700ms ease-out normal both;\n            }\n        \n            &::after {\n\n                -webkit-animation: menuCloseButtonBottom 700ms ease-out normal both;\n                animation: menuCloseButtonBottom 700ms ease-out normal both;\n            }\n        }\n\n        &::before {\n\n            content: \"\";\n            width: 40px;\n            height: 3px;\n            background: $secondary-color;\n            position: absolute;\n            top: 0;\n            left: 0;\n        }\n    \n        &::after {\n\n            content: \"\";\n            width: 30px;\n            height: 3px;\n            background: $secondary-color;\n            position: absolute;\n            top: 15px;\n            left: 10px;\n        }\n    }\n\n    .menu {\n\n        position: absolute;\n        top: -10px;\n        right: 0px;\n    \n        &__ref {\n\n            padding: 25px;\n            position: relative;\n            width: 300px;\n            height: 550px;\n            border: 2px solid $primary-color;\n            background: $neutral_color;\n            z-index: 20;\n    \n            span {\n\n                display: block;\n                margin-bottom: 20px;\n                font-size: 20px;\n                font-weight: bold;\n            }\n        }\n    \n    \n    \n        ul {\n\n            list-style: none;\n            margin-left: 15px;\n    \n            li {\n    \n                margin-bottom: 20px;\n    \n                a {\n\n                    position: relative;\n                    color: $tertiary_color;\n                    font-size: 18px;\n    \n                    &::after {\n\n                        content: '';\n                        position: absolute;\n                        width: 100%;\n                        transform: scaleX(0);\n                        height: 2px;\n                        bottom: -10px;\n                        left: 0;\n                        background-color: $tertiary_color;\n                        transform-origin: top right;\n                        transition: transform 0.6s ease-out;\n                    }\n    \n                    &:hover::after {\n\n                        transform: scaleX(1);\n                    }\n    \n                    &::before {\n\n                        content: '';\n                        position: absolute;\n                        width: 100%;\n                        transform: scaleX(0);\n                        height: 2px;\n                        top: -11px;\n                        left: 0;\n                        background-color: $tertiary_color;\n                        transform-origin: bottom left;\n                        transition: transform 0.6s ease-out;\n                    }\n    \n                    &:hover::before {\n\n                        transform: scaleX(1);\n                    } \n                }\n            }\n    \n            .reversed {\n                \n                a {\n                    &::after {\n\n                        transform-origin: bottom left;\n                    }\n    \n                    &::before {\n\n                        transform-origin: top right;\n                    }\n                }\n            }\n        }\n    \n        ul.lang {\n\n            display: flex;\n            font-weight: bold;\n            justify-content: space-between;\n\n    \n            li {\n\n                cursor: pointer;\n                font-size: 15px;\n                color: $tertiary_color;\n            }\n    \n            li.activated {\n\n                color: $secondary_color;\n                text-decoration: overline;\n            }\n        }\n    }\n\n    .sousMenu {\n\n        margin-left: 25px;\n        position: relative;\n\n        &::before {\n            \n            content: \"\";\n            width: 10px;\n            height: 10px;\n            border-left: 2px solid $tertiary_color;\n            border-bottom: 2px solid $tertiary_color;\n            position: absolute;\n            left: -15px;\n            top: 10px;\n        }\n    }\n}\n\n\n.prePortfolioNav {\n\n    .openButton {\n\n        &::before {\n\n            background: $primary-color;\n\n        }\n\n        &::after {\n\n            background: $primary-color;\n\n        }\n    }\n}\n\n.contactform {\n\n    .openButton {\n\n        &::before {\n\n            background: $tertiary-color;\n\n        }\n\n        &::after {\n\n            background: $tertiary-color;\n\n        }\n    }\n}\n\n.jrpg{\n\n    .openButton {\n\n        &::before {\n\n            background: $tertiary-color;\n\n        }\n\n        &::after {\n\n            background: $tertiary-color;\n\n        }\n    }\n}",".scroller {\n\n    overflow-y: scroll;\n    -ms-scroll-snap-type: x mandatory;\n    scroll-snap-type: x mandatory;\n    height: 100vh;\n    width: 100%;\n    display: flex;\n    flex-wrap: nowrap;\n\n    @include tablet-only {\n    \n    }\n\n    @include desktop-only {\n\n        -ms-scroll-snap-type: y mandatory;\n        scroll-snap-type: y mandatory;\n        flex-wrap: wrap;\n        }\n\n    section {\n\n        min-height: 100vh;\n        min-width: 100%;\n        height: 100%;\n        width: 100%;\n        overflow: auto;\n        scroll-snap-align: start;\n\n        @include tablet-only {\n    \n        }\n    \n        @include desktop-only {\n\n        }\n    \n    }\n\n    .one {\n\n        background: $neutral_color;\n        position: relative;\n        max-height: 100vh;\n    }\n    \n    .two {\n\n        background: none;\n    }\n\n    .three {\n\n    background: $tertiary-color;\n    }\n\n    .four {\n\n    background:  $primary-color;\n    }\n\n    .five {\n\n        background: $neutral_color;\n    }\n}",".introduction {\n\n    display: flex;\n    flex-wrap: wrap;\n    justify-content:space-around;\n    flex-basis: 100%;\n    height: auto;\n    font-family: \"Bahnschrift\";\n    position: relative;\n\n    &::before {\n    \n        @include desktop-only {\n\n            content: \"\";\n            position: absolute;\n            margin-left: auto;\n            margin-right: auto;\n            right: 0;\n            left: 0;\n            bottom: -2vw;\n            z-index: 0;\n            width  : 0;\n            height : 0;\n            border-left  : 70px solid transparent;\n            border-right : 70px solid transparent;\n            border-top   : 70px solid $primary_color;\n            -webkit-animation: introductionArrow2 2.5s ease-in-out infinite normal;\n                    animation: introductionArrow2 2.5s ease-in-out infinite normal;\n        }\n        \n    }\n\n    &::after {\n    \n        @include desktop-only {\n\n            content: \"\";\n            position: absolute;\n            margin-left: auto;\n            margin-right: auto;\n            right: 0;\n            left: 0;\n            bottom: -2vw;\n            z-index: 0;\n            width  : 0;\n            height : 0;\n            border-left  : 66px solid transparent;\n            border-right : 66px solid transparent;\n            border-top   : 66px solid $neutral_color;\n            -webkit-animation: introductionArrow 2.5s ease-in-out infinite normal;\n                    animation: introductionArrow 2.5s ease-in-out infinite normal;\n        }\n    }\n\n\n    &Text {\n\n        position: relative;\n        flex-basis: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 100px;\n\n        @include tablet-only {\n\n            flex-basis: 90%;\n        }\n\n        @include small-desktop-only {\n\n            flex-basis: 50%;\n        }\n    \n        @include desktop-only {\n\n            flex-basis: 50%;\n        }\n\n        h1 {\n\n            position: relative;\n            z-index: 1;\n            flex-basis: 100%;\n            font-size: 6vw;\n            color: $secondary_color;\n            margin-bottom: 0;\n            display: flex;\n            justify-content: center;\n\n            @include tablet-only {\n\n                font-size: 4.5vw;\n                margin-left: 20px;\n                justify-content: start;   \n            }\n\n            @include small-desktop-only {\n\n                font-size: 2.7vw;\n                margin-left: 0px;\n            }\n        \n            @include desktop-only {\n\n                margin-left: 0;\n                font-size: 3vw;\n            }\n        }\n\n        h2 {\n\n            font-size: 4.8vw;\n            color: $tertiary_color;\n            margin: 0 0 15px 0;\n            display: flex;\n            justify-content: center;\n\n            @include tablet-only {\n\n                font-size: 3vw;\n                justify-content: start;\n                margin: 50px 0 20px 20px;\n            }\n\n            @include small-desktop-only {\n\n                font-size: 1.9vw;\n                margin: 50px 0 20px 0;\n            }\n        \n            @include desktop-only {\n\n                font-size: 1.8vw;\n                margin: 50px 0 20px 0;\n            }\n        }\n\n        p {\n\n            font-size: 4vw;\n            color: $primary_color;\n            padding: 20px;\n\n            @include tablet-only {\n\n                font-size: 2.8vw;\n            }\n\n            @include small-desktop-only {\n\n                padding: 10px;\n                font-size: 1.5vw;\n            }\n        \n            @include desktop-only {\n\n                padding: 10px;\n                font-size: 1.5vw;\n            }\n        }\n\n        .secondText, .thirdText {\n\n            flex-basis: 100%;\n\n            @include tablet-only {\n                flex-basis: 50%;\n            }\n        }\n\n        &::before {\n     \n            @include desktop-only {\n\n                content: \"\";\n                position: absolute;\n                top: -55px;\n                right: 0;\n                z-index: 0;\n                width  : 0;\n                height : 0;\n                border-left  : 60px solid transparent;\n                border-right : 60px solid transparent;\n                border-top   : 130px solid $primary_color;\n                transform: rotate(50deg);\n            }\n        }\n\n        &::after {\n\n            @include desktop-only {\n\n                content: \"\";\n                position: absolute;\n                top: -52px;\n                right: 3px;\n                z-index: 0;\n                width  : 0;\n                height : 0;\n                border-left  : 56px solid transparent;\n                border-right : 56px solid transparent;\n                border-top   : 122px solid $neutral_color;\n                transform: rotate(50deg);\n            }\n        }\n    }\n\n    .presentationText {\n\n        margin-top: 25px;\n        width: 500px;\n        background: $primary_color;\n        border-radius: 25px;\n        display: flex;\n        flex-wrap: wrap;\n        position: relative;\n    \n        .thirdText {\n    \n            h2{\n    \n                display: flex;\n                flex-direction: column;\n        \n                span {\n    \n                    flex-basis: 50%;\n                }\n            }\n        }\n    \n        p {\n    \n            position: relative;\n            flex-basis: 80%;\n            left: 0;\n            right: 0;\n            margin-left: auto;\n            margin-right: auto;\n        }\n    \n        &::before {\n    \n            content: \"\";\n            position: absolute;\n            height: 3px;\n            width: 100%;\n            background: $neutral_color;\n            top: 98%;\n            z-index: 4;\n            left: 0;\n            right: 0;\n            margin-left: auto;\n            margin-right: auto;\n            -webkit-animation: topBarMoving 1s ease 2 normal both;\n            animation: topBarMoving 1s ease 2 normal both;\n        }\n    \n        &::after {\n    \n            content: \"\";\n            position: absolute;\n            height: 3px;\n            width: 100%;\n            background: $neutral_color;\n            bottom: 98%;\n            z-index: 4;\n            left: 0;\n            right: 0;\n            margin-left: auto;\n            margin-right: auto;\n            -webkit-animation: bottomBarMoving 1s ease 2 normal both;\n                    animation: bottomBarMoving 1s ease 2 normal both;\n        }\n    }\n}",".two {\n\n    cursor: default;\n    color: #fff;\n    font-family: \"metamorphous\";\n    position: relative;\n    max-height: 100vh;\n    min-width: 100vw;\n\n    h2 {\n\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n\n            height: 90px;\n            margin-right: 15px;\n        }\n    }\n\n    h3 {\n\n        padding-left: 3% ;\n        margin-bottom: 15px;\n        position: relative;\n        font-size: 15px;\n    \n        @include desktop-only {\n\n            font-size: 1.17em;\n            padding-left: 5% ;\n        }\n\n        &::after {\n\n            content: \"\";\n            display: inline-block;\n            height: 1px;\n            width: 35%;\n            background: #fff;\n            position: absolute;\n            bottom: -10px;\n            left: 2%;\n        \n            @include desktop-only {\n                left: 4%;\n            }\n        }\n    }\n    \n    #backgroundVideo {\n\n        position: fixed;\n        right: 0;\n        top: 0;\n        z-index: -2;\n        min-width: 100vw;\n        min-height: 100vh;\n        max-height: 100vh;\n    \n        @include desktop-only {\n\n            min-width: 100%;\n            min-height: 100%;\n            max-height: none;\n        }\n    }\n    \n    &::before {\n\n        content: \"\";\n        position: fixed;\n        background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 15%, rgba(124,124,124,1) 40%, rgba(124,124,124,1) 60%, rgba(0,0,0,1) 85%, rgba(0,0,0,1) 100%);\n        right: 0;\n        bottom: 0;\n        z-index: -1;\n        opacity: 0.7;\n        width: 100%;\n        height: 100%;\n    }\n\n    .jrpgstat {\n\n        display: flex;\n        flex-wrap: wrap;\n\n        .header {\n\n            flex-basis: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            min-height: 20vh;\n        \n            @include desktop-only {\n\n                height: 20vh;\n            }\n\n            .title {\n\n                h2 {\n                    \n                    position: relative; \n                }\n            }\n        }\n\n        .body {\n\n            flex-basis: 100%;\n            height: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n\n            @include desktop-only {\n\n                height: 60vh;\n            }\n\n            .stats{\n\n                flex-basis: 100%;\n                display: flex;\n                flex-wrap: wrap;\n                \n                @include desktop-only {\n\n                    flex-basis: 40%;\n                }\n\n                .skills {\n\n                    flex-basis: 100%;\n                    height: 100%;\n\n                    @include desktop-only {\n\n                        height: 60%;\n                    }\n                }\n            }\n        }\n\n        .footer {\n            \n            flex-basis: 100%;\n            min-height: 20vh;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n        \n            @include desktop-only {\n\n                height: 20vh;\n            }\n        }\n    }\n}",".prePortfolio {\n\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-around;\n    position: relative;\n    flex-wrap: wrap;\n\n    .projectCard {\n\n        position: relative;\n        z-index: 2;\n        flex-basis: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: baseline;\n        order: 1;\n        margin-top: 0;\n        margin-top: -250px;\n\n        @include tablet-only {\n\n            flex-basis: 48%;\n            margin-top: -450px;\n        }\n    \n        @include desktop-only {\n            margin-top: 0;\n            flex-basis: 30%;\n            margin-top: 30px;\n            order: none;\n        }\n    }\n\n    .textBlock {\n\n        background: $neutral_color;\n    }\n\n    .preProtfolioText {\n\n        flex-basis: 100%;\n        height: 100%;\n        font-family: \"Bahnschrift\";\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin-top: 0;\n        margin-bottom: 10%;\n        order: 0;\n\n        @include desktop-only {\n\n            margin-top: 0;\n            margin-bottom: 0;\n            flex-basis: 40%;\n            order: 1;\n        }\n\n        h2 {\n\n            color: $primary-color;\n            font-size: 40px;\n            position: relative;\n            z-index: 0;\n            margin-top: -60px;\n            margin-bottom: -250px;\n\n            @include tablet-only {\n                \n                font-size: 70px;\n                margin-top: -250px;\n            }\n        \n            @include desktop-only {\n\n                margin-top: 0;\n                margin-bottom: 0;\n                font-size: 70px;\n\n                &::before {\n\n                    content: \"\";\n                    width: 400px;\n                    height: 400px;\n                    border-radius: 200px;\n                    border: 4px solid $primary_color;\n                    position: absolute;\n                    left: -45%;\n                    top: 0px;\n                    z-index: -1;\n                }\n    \n                &::after {\n\n                    content: \"\";\n                    width: 400px;\n                    height: 400px;\n                    border-radius: 200px;\n                    border: 4px solid $primary_color;\n                    position: absolute;\n                    left: 100%;\n                    top: 500%;\n                    z-index: -1;\n                }\n            }\n        }\n\n        p {\n\n            color: $neutral_color;\n            position: relative;\n            z-index: 1;\n            width: 100%;\n            font-size: 20px;\n            padding: 3%;\n\n            @include tablet-only {\n        \n                font-size: 30px;\n                margin-top: -250px;\n            }\n        \n            @include desktop-only {\n\n                font-size: 40px;\n                margin-top: 0;\n                \n                &::before {\n\n                    content: \"\";\n                    width: 200px;\n                    height: 200px;\n                    border-radius: 100px;\n                    border: 4px solid $primary_color;\n                    position: absolute;\n                    left: -10%;\n                    top: 125%;\n                    z-index: -1;\n                }\n\n                &::after {\n\n                    content: \"\";\n                    width: 300px;\n                    height: 300px;\n                    border-radius: 150px;\n                    border: 4px solid $primary_color;\n                    position: absolute;\n                    right: -30%;\n                    top: -150%;\n                    z-index: -1;\n                }\n            }\n        }\n\n        .links {\n\n            position: relative;\n            z-index: 2;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-around;\n            margin-top: -100px;\n\n            @include tablet-only {\n\n                margin-top: -300px;\n            }\n\n            @include desktop-only {\n\n                margin-top: 0;\n            }\n\n            a {\n\n                flex-basis: 45%;\n                margin-top: -150px;\n            \n                @include desktop-only {\n\n                    margin-top: 0px;\n                    margin-bottom: 60px;\n                }\n\n                .button {\n\n                    height: 50px;\n                    border-radius: 45px;\n                    color: $secondary_color;\n                    background: $neutral_color;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: 20px;\n                    box-shadow: 5px 5px 10px $neutral_color;\n\n                    @include tablet-only {\n                        \n                        height: 70px;\n                        font-size: 30px;\n                    }\n                \n                    @include desktop-only {\n    \n                        height: 90px;\n                        border-radius: 45px;\n                        font-size: 35px;\n                    }\n\n                    &:hover {\n\n                        background: darken($neutral_color, 15%);\n                        box-shadow: 5px 5px 10px darken($neutral_color, 15%);\n                        color: lighten($secondary_color, 8%)\n                    }\n                } \n            }\n        }\n    }\n\n    .projectCard.second {\n\n        margin-top: 0px;\n\n        @include tablet-only {\n\n            margin-top: -450px;\n        }\n\n        @include desktop-only {\n\n            margin-top: 30px;\n        }\n    }\n}\n\n","main {\n    &.notFound {\n\n        color: $primary-color;\n\n        h1 {\n            margin-top: 25px;\n            position: relative;\n            flex-basis: 100%;\n            font-size: 150px;\n            display: flex;\n            justify-content: center;\n\n            @include tablet-only {\n                font-size: 300px;\n                margin-top: 50px;\n            }\n        \n            @include desktop-only {\n                margin-top: 50px;\n                font-size: 300px;\n            }\n        }\n\n        p {\n            flex-basis: 100%;\n            display: flex;\n            justify-content: center;\n            margin-bottom: 50px;\n            font-size: 12px;\n            font-weight: bold;\n\n            @include tablet-only {\n        \n                font-size: 25px;\n            }\n        \n            @include desktop-only {\n\n                font-size: 25px;\n            }\n        }\n\n        a {\n            color: $tertiary-color;\n            font-size: 20px;\n        }\n    }\n}\n\n.legal-mentions{\n    margin-top: 100px;\n    color: $tertiary-color;\n}",".login-form{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n\n    color: $secondary_color;\n    font-size: 1.2rem;\n    margin-top: 50px;\n\n    &.change{\n        margin-top: 0;\n    }\n\n    input {\n        width: 300px !important;\n        height: 40px !important;\n        margin: 10px !important;\n        padding: 0 10px !important;\n        border: none !important;\n        border-radius: 5px !important;\n        font-size: 1rem !important;\n        outline: none !important;\n        background-color: white !important;\n        color: black !important;\n\n        &:focus {\n            border: 2px solid $secondary_color !important;\n        }\n    }\n\n    button {\n        width: 150px;\n        height: 40px;\n        margin: 10px;\n        border: 2px solid $tertiary_color;\n        border-radius: 5px;\n        background-color: transparent;\n        color: $tertiary_color;\n        font-size: 1rem;\n\n        &:hover {\n            background-color: $tertiary_color;\n            color: $neutral_alt_color;\n            cursor: pointer;\n        }\n    }\n}\n\n.presentation-text {\n\n    input, textarea {\n        width: 100% !important;\n        border: none !important;\n        background-color: transparent !important;\n        color: $tertiary_color !important;\n        font-size: 1rem !important;\n        margin-bottom: 10px !important;\n    }\n\n    .presentation-title {\n        font-size: 1.2rem !important;\n        font-weight: bold !important;\n        height: 30px !important;\n\n        &:focus {\n            outline: 2px solid $secondary_color !important;\n            border-radius: 0 !important;\n        }\n    }\n\n    .presentation-textarea {\n        height: 150px !important;\n        resize: none;\n        font-family: \"Bahnschrift\";\n\n        &:focus {\n            outline: 2px solid $secondary_color !important;\n        }\n    }\n}\n\n.login-sub-panel{\n    display: flex;\n    flex-direction: column;\n    margin: 20px;\n    padding: 20px 30px 20px 30px;\n    border-radius: 15px;\n    border: 2px solid $tertiary_color;\n}\n\n.sub-form{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n}\n\n.admin-generator{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}",".freeSpace {\n\n    flex: 1;\n    position: relative;\n    bottom: 5px;\n\n    .slidingText {\n\n        position: absolute;\n        bottom: 0;\n    }\n}",".buttonContainer {\n\n    display: flex;\n    flex-basis: 100%;\n    padding-top: 20px;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    .singleButton {\n\n        flex-basis: 95%;\n        padding-bottom: 20px;\n\n        @include tablet-only {\n   \n        }\n    \n        @include desktop-only {\n\n            flex-basis: 48%;\n        }\n    }\n\n    .button {\n\n        flex-basis: 100% ;\n        height: 40px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 0.5em 0 0.5em 0;\n        border-radius: 8px;\n        background: $primary_color;\n        font-family: \"Roboto\";\n        font-size: 15px;\n        font-weight: bold;\n        color: $neutral_alt_color;\n        box-shadow: 1px 1px 5px $primary_color;\n        margin: 0 15px 0 15px;\n        position: relative;\n\n        &:hover {\n\n            box-shadow: 1px 1px 5px darken($primary_color, 15%);\n        }\n\n        @include tablet-only {\n   \n        }\n    \n        @include desktop-only {\n\n            font-size: 13px;\n            padding-left: 10px;\n        }\n        \n        img {\n\n            position: absolute;\n            left: 4% ;\n            width: 20px;\n            top: 11px;\n        }\n\n        &.github {\n\n            background: $tertiary_color;\n            font-size: 12px;\n\n            &:hover {\n                background: darken($tertiary_color, 5%);\n            }\n        }\n    \n        &.live{\n\n            color: $neutral_color;\n            background: $secondary_color;\n\n            &:hover {\n                background: darken($secondary_color, 5%);\n            }\n        }\n    \n        &.unavailable {\n\n            background: $neutral_color;\n            color: $primary_color;\n            cursor: not-allowed;\n        }\n    }\n}",".slidingText {\n\n    $slidingTextColor: $primary_color;\n    overflow: hidden;\n    position: relative;\n    width: $slidingTextWidth;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n\n    .slidingBox {\n\n        -webkit-animation: slideshow 120s infinite linear;\n\n                animation: slideshow 120s infinite linear; \n        \n        span {\n\n            font-size: 15px;\n            opacity: 0.7;\n            color: $slidingTextColor;\n            font-family: \"Anton\";\n    \n        }\n\n        :nth-child(2n+1) {\n\n            font-size: 16px;\n            position: relative;\n            top: 1px;\n        }\n\n        :nth-child(2n+0) {\n\n            color: transparent;\n            -webkit-text-stroke: 1px $slidingTextColor;\n        }\n        \n    }\n    \n    &.reversed {\n\n        $slidingTextColor: $tertiary_color;\n\n        .slidingBox {\n\n            animation: slideshow 120s infinite linear reverse; \n            \n            span {\n                color: $slidingTextColor;\n            }\n    \n            :nth-child(2n+0) {\n\n                color: transparent;\n                -webkit-text-stroke: 1px $slidingTextColor;\n            }\n        }\n    }\n}",".textBlock {\n\n    position: relative;\n    font-family: \"Roboto\";\n    display: flex;\n    flex-wrap: wrap;\n    margin: 20px 0 20px 0;\n    padding-bottom: 10px;\n    justify-content: center;\n    -webkit-animation: openingWindow 700ms ease-out normal both;\n            animation: openingWindow 700ms ease-out normal both;\n    flex-basis: 95%;\n    border: 2px solid $primary_color;\n\n    @include tablet-only {\n\n        flex-basis: 90%;    \n    }\n \n    @include small-desktop-only {\n        flex-basis: 85%;   \n    }\n    \n    @include desktop-only {\n\n        flex-basis: 95%;   \n    }\n\n    .codeTitle {\n\n        height: 50px;\n        background: $primary_color;\n        color: $neutral_color;\n        padding: 10px 10px 10px 0;\n        text-align: center;\n        flex-basis: 100%;\n        margin-bottom: 20px;\n        font-size: 14px;\n    \n        @include desktop-only {\n            font-size: 17px;   \n            padding: 10px 30px 10px 10px;\n            height: 50px;\n        }\n    }\n\n    .textCode {\n\n        padding: 30px 30px 0 30px;\n        flex-basis: 100%;\n        display: flex;\n        flex-wrap: wrap;\n\n        h3 {\n\n            text-decoration: underline;\n            flex-basis: 100%;\n            margin-top: 20px;\n            margin-bottom: 20px;\n        }\n    }\n\n    &::before {\n\n        content: \"\";\n        display: inline-block;\n        width: 25px;\n        height: 25px;\n        border-radius: 3px;\n        background: $neutral_color;\n        border: 2px solid $tertiary_color;\n        position: absolute;\n        right: 4px;\n        top: 5px;\n    }\n\n     .closeButton {\n\n        cursor: pointer;\n        font-size: 23px;\n        font-weight: bold;\n        color: $tertiary_color;\n        position: absolute;\n        top: -1px;\n        right: 10px;\n    }\n\n    &.fade{\n\n        -webkit-animation: closingWindow 700ms ease-out both;\n                animation: closingWindow 700ms ease-out both;\n    }\n}\n\n.portfolio {\n\n    .textBlock {\n\n        flex-basis: 100%;\n        border: 2px solid $primary_color;\n\n        @include tablet-only {\n\n            flex-basis: 48%;    \n        }\n\n        @include small-desktop-only {\n            flex-basis: 45%;\n        }\n    \n        @include desktop-only {\n\n            flex-basis: 30%;    \n        }\n    }\n    \n    .textCode {\n\n        color: $primary_color;\n        font-size: 4vw;\n\n        @include tablet-only {\n            font-size: 2.3vw;\n        }\n    \n        @include desktop-only {\n            \n            font-size: 1.26vw;\n        }\n    \n\n        h3 {\n\n            color: $secondary_color;\n        }\n\n        p {\n\n            margin-left: 7px;\n        \n            @include desktop-only {\n\n                margin-left: 10px;\n            }\n        }\n    }\n}\n\n.prePortfolio {\n\n    .textCode {\n\n        color: $primary_color;\n        font-size: 4.6vw;\n\n        @include tablet-only {\n            font-size: 2vw;\n        }\n    \n        @include desktop-only {\n\n            font-size: 1.2vw;\n        }\n\n        h3 {\n            \n            color: $secondary_color;\n        }\n\n        p {\n\n            margin-left: 7px;\n\n            @include tablet-only {\n                margin-left: 20px;\n            }\n        \n            @include desktop-only {\n\n                margin-left: 50px;\n            }\n        }\n    }\n}",".imageSample {\n\n    height: 200px;\n    width: 80%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    background: $neutral_color;\n    border: 3px solid $tertiary_color;\n    box-shadow: 1px 1px 5px #000;\n\n    @include tablet-only {\n   \n    }\n\n    @include desktop-only {\n\n        height: 250px;\n        width: 80%;\n    }\n\n    .imgContainer {\n\n        flex-basis: 100%;\n        margin: 51px 5px 5px 5px;\n        height: 100%;\n        overflow: hidden;\n        \n        img {\n\n            -o-object-fit: cover;\n            object-fit: cover;\n            width: 100%;\n            height: 100%; \n        }\n    }\n\n    .imageText {\n\n        position: absolute;\n        top: 0;\n        padding-top: 8px;\n        padding-bottom: 17px;\n        width: 100%;\n        color: $neutral_color;\n        font-weight: bold;\n        text-align: center;\n        background: $tertiary_color;\n    }\n    &.first{\n\n        z-index: 3;\n        -webkit-animation: openingWindow 700ms ease-out 2100ms normal both;\n                animation: openingWindow 700ms ease-out 2100ms normal both;\n\n        &.fade{\n\n            -webkit-animation: closingWindow 700ms ease-out both;\n                    animation: closingWindow 700ms ease-out both;\n        }\n    }\n\n    &.second{\n\n        z-index: 2;\n        -webkit-animation: openingWindow 700ms ease-out 1400ms normal both;\n                animation: openingWindow 700ms ease-out 1400ms normal both;\n\n        &.fade{\n\n            -webkit-animation: closingWindow 700ms ease-out both;\n                    animation: closingWindow 700ms ease-out both;\n        }\n    }\n\n    &.third{\n\n        z-index: 1;\n        -webkit-animation: openingWindow 700ms ease-out 700ms normal both;\n                animation: openingWindow 700ms ease-out 700ms normal both;\n\n        &.fade{\n\n            -webkit-animation: closingWindow 700ms ease-out both;\n                    animation: closingWindow 700ms ease-out both;\n        }\n    }\n\n    &.left{\n\n        position: absolute;\n        left: -3%;\n        top: 10%;\n    }\n\n    &.center{\n\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n\n    }\n\n    &.right{\n\n        position: absolute;\n        right: -3%;\n        top: 20%;\n    }\n\n    &::before {\n\n        content: \"\";\n        display: inline-block;\n        width: 25px;\n        height: 25px;\n        border-radius: 3px;\n        background: $neutral_color;\n        border: 2px solid $secondary_color;\n        position: absolute;\n        z-index: 2;\n        right: 4px;\n        top: 5px;\n    }\n\n    .closeButton {\n\n        cursor: pointer;\n        font-size: 23px;\n        font-weight: bold;\n        color: $secondary_color;\n        position: absolute;\n        z-index: 3;\n        top: -1px;\n        right: 10px;\n    }\n}\n\n.imageHolder {\n\n    position: relative;\n    max-height: 400px;\n    transition: max-height 700ms ease-out;\n    width: 100%;\n\n    .holder {\n\n        height: 200px;\n\n        @include desktop-only {\n\n            height: 270px;\n        }\n    }\n\n    &.fade{\n\n        max-height: 0px;\n    }\n}\n\n.presentationText {\n\n    .imageSample {\n\n        height: 200px;\n        width: 90%;\n    \n        @include tablet-only {\n       \n        }\n    \n        @include desktop-only {\n\n            height: 600px;\n            width: 90%;\n        }\n    \n        .closeButton {\n\n            top: 3px;\n            right: 11px;\n        }\n    }\n    \n    .imageHolder {\n\n        position: relative;\n        max-height: 650px;\n        transition: max-height 700ms ease-out;\n        width: 100%;\n    \n        .holder {\n\n            height: 700px;\n    \n            @include desktop-only {\n\n                height: 700px;\n            }\n        }\n    \n        &.fade{\n            \n            max-height: 0px;\n        }\n    }\n}\n\n.prePortfolio {\n\n    .imageSample {\n\n        @include desktop-only {\n\n            height: 200px;\n            width: 60%;\n        }\n    }\n\n    .imageHolder {\n\n        position: relative;\n        max-height: 400px;\n        transition: max-height 700ms ease-out;\n        width: 100%;\n    \n        .holder {\n    \n            @include desktop-only {\n    \n                height: 200px;\n            }\n        }\n    }\n}",".tripleContainer {\n    \n    display: flex;\n    align-items: center;\n\n    .triplePhoto {\n\n        max-height: 430px;\n        max-width: 610px;\n        position: relative;\n        margin-right: 50vw;\n        margin-bottom: 22vw;\n        margin-top: 10vw;\n        scale: (1);\n\n    \n        @include tablet-only {\n            margin-top: 10vw;\n            margin-right: 43vw;\n            margin-bottom: 30vw;\n            scale: (0.8);\n        }\n\n        @include small-desktop-only {\n            scale: (0.5);\n            margin-right: 15vw;\n            margin-top: 3vw;\n            margin-bottom: 12vw;\n        }\n    \n        @include desktop-only {\n            margin-top: 0;\n            margin-right: 15vw;\n            margin-bottom: 17vw;\n            margin-left: 0;\n            scale: (0.5);\n        }\n    \n        &::before {\n    \n            content: \"\";\n            width: 40vw;\n            height: 40vw;\n            border-radius: 2vw;\n            border: 2px solid $primary_color;\n            position: absolute;\n            left: -5vw;\n            top: -5vw;\n            z-index: 0;\n            overflow: auto;\n        }\n    \n        &::after {\n    \n            content: \"\";\n            width: 10vw;\n            height: 10vw;\n            border-radius: 2vw;\n            border: 2px solid $primary_color;\n            position: absolute;\n            left: 36vw;\n            top: 36vw;\n            z-index: 0;\n        }\n    \n        .squareOne {\n    \n            width: 40vw;\n            height: 40vw;\n            border-radius: 2vw;\n            position: absolute;\n            overflow: hidden;\n            z-index: 1;\n    \n            img {\n    \n                position: absolute;\n                top: -1vw;\n                left: 0;\n                min-width:  61vw;\n                height:  50vw;\n            }\n        }\n        \n        .squareTwo {\n    \n            width: 20vw;\n            height: 20vw;\n            border-radius: 2vw;\n            position: absolute;\n            left: 41vw;\n            top: 6vw;\n            overflow: hidden;\n            z-index: 1;\n    \n            img {\n    \n                position: absolute;\n                left: -41vw;\n                top: -7vw;\n                min-width:  61vw;\n                height:  50vw;\n            }\n        }\n        \n        .squareThree {\n    \n            width: 15vw;\n            height: 15vw;\n            border-radius: 2vw;\n            position: absolute;\n            left: 41vw;\n            top: 27vw;\n            overflow: hidden;\n            z-index: 1;\n    \n            img {\n                \n                position: absolute;\n                left: -41vw;\n                top: -28vw;\n                min-width: 61vw;\n                height:  50vw;\n            }\n        }\n    }\n}",".two {\n    \n    .jrpgstat {\n\n        .header {\n\n            .title {\n\n                flex-basis: 100%;\n                display: flex;\n                margin-left: 2%;\n                align-items: center;\n\n                @include tablet-only {\n                    flex-basis: 30%;\n                }\n\n                h2 {\n\n                    font-size: 15px;\n                    text-shadow: 3px 3px 2px $neutral_color;\n                    left: 7%;\n\n                    @include desktop-only {\n\n                        font-size: 1.5em;\n                    }\n\n                    .text {\n                        \n                        position: relative;\n                        z-index: 1;\n                        width: 130px;\n                        display: flex;\n                        justify-content: center;\n\n                        @include desktop-only {\n\n                            width: 220px;\n                        }\n                    }\n\n                    &::before {\n\n                        content: \"\";\n                        width: 130px;\n                        height: 50px;\n                        position: absolute;\n                        background: $neutral_color;\n                        border-radius: 25px;\n                        opacity: 0.5;\n                        z-index: 0;\n                        left: 105px;\n\n                        @include desktop-only {\n\n                            width: 220px;\n                        }\n                    }\n                }\n            }\n\n            .faces {\n\n                flex-basis: 100%;\n                display: flex;\n                justify-content: space-between;\n                margin-right: 5%;\n                align-items: center;\n\n                @include tablet-only {\n\n                    flex-basis: 40%;\n                }\n\n                @include small-desktop-only {\n\n                    margin-top: 20px;\n                }\n            \n                @include desktop-only {\n                    \n                    \n                    margin-top: 0;\n                    flex-basis: 30%;\n                    margin-right: 0;\n                    justify-content: space-around;\n                }\n\n                h3 {\n\n                    font-size: 15px;\n                    display: flex;\n                    justify-content: center;\n\n                    &::after {\n\n                        width: 100%;\n                        left: 15%;\n                    }\n                \n                    @include desktop-only {\n\n                        font-size: 1.17em;\n                    }\n\n                    &::before {\n\n                        content: \"\";\n                        width: 100px;\n                        height: 30px;\n                        position: absolute;\n                        background: $neutral_color;\n                        border-radius: 25px;\n                        opacity: 0.5;\n                        z-index: -1;\n                        left: 2%;\n                        top:-6px;\n\n                        @include desktop-only {\n\n                            width: 120px;\n                            top:-4px;\n                            left: 17%;\n                        }\n                    }\n                }\n\n                img {\n\n                    height: 25px;\n\n                    @include tablet-only {\n                        height: 40px;       \n                    }\n                \n                    @include desktop-only {\n                        \n                        height: 50px;\n                    }\n                }\n            }\n        }\n    }\n}",".two {\n    \n    .jrpgstat {\n\n        .body {\n\n            .stats{\n\n                .head {\n\n                    padding-left: 5%;\n                    padding-right: 1%;\n                    flex-basis: 100%;\n                    height: 120px;\n                    -o-object-fit: cover;\n                       object-fit: cover;\n                    overflow: hidden;\n                    position: relative;\n                    display: flex; \n                    margin-bottom: 10px;\n\n                    @include tablet-only {\n\n                        height: 170px;\n                        margin-bottom: 20px; \n                        margin-top: -60px;     \n                    }\n \n                    @include small-desktop-only {\n\n                        margin-bottom: -20px; \n                        margin-top: -30px;   \n                    }\n                \n                    @include desktop-only {\n\n                        height: 170px;\n                        margin-bottom: 0;\n                        margin-top: 0; \n                    }\n\n                    &::before {\n\n                        content: \"\";\n                        width: 75%;\n                        height: 100%;\n                        background: #000;\n                        opacity: 0.5;\n                        position: absolute;\n                        border-radius: 0 0 25px 0;\n                        z-index: -1;\n                        top: 0;\n                        right: 5%;\n\n                        @include small-desktop-only {\n\n                            width: 80%;\n                        }\n\n                        @include desktop-only {\n\n                            width: 80%;\n                        }\n                    }\n\n                    img{\n\n                        height: 100%;\n                    }\n\n                    .nameHPandMana {\n\n                        flex-basis: 70%;\n                        display: flex;\n                        flex-wrap: wrap;\n                        justify-content: space-around;\n                        position: relative;\n                        padding-left: 0;\n                        padding-top: 15px;\n                        padding-right: 5%;\n\n                        @include tablet-only {\n\n                            padding-right: 0;\n                        }\n\n                        @include small-desktop-only {\n\n                            padding-left: 30px;\n                        }\n                    \n                        @include desktop-only {\n\n                            padding-left: 15px;\n                        }\n    \n                        .namePC {\n    \n                            flex-basis: 100%;\n                            font-size: 12px;\n                            display: flex;\n                            justify-content: space-between;\n                            padding-right: 5%;\n                            padding-left: 5%;\n\n                            @include tablet-only {\n\n                                font-size: 22px;\n                            }\n                        \n                            @include desktop-only {\n\n                                font-size: 22px;\n                                padding-left: 0;\n                                padding-right: 0;\n                            }\n    \n                        }\n    \n                        .HP {\n    \n                            flex-basis: 40%;\n                            display: flex;\n                            flex-wrap: wrap;\n                            margin-right: 0;\n                        \n                            @include desktop-only {\n\n                                font-size: 22px;\n                                margin-right: 10px;\n                            }\n    \n                            .points {\n\n                                flex-basis: 100%;\n                                font-size: 10px;\n\n                                @include tablet-only {\n                                    font-size: 20px;    \n                                }\n                            }\n    \n                            .bar {\n\n                                flex-basis: 100%;\n                                height: 15px;\n                                border-radius: 15px;\n                                background: linear-gradient(90deg, rgba(246,115,0,1) 0%, rgba(255,198,155,1) 100%);\n                                border: 2px solid black;\n                                position: relative;\n\n                                &::after {\n\n                                    content: \"\";\n                                    width: 109%;\n                                    height: 17px;\n                                    border-radius: 15px;\n                                    border: 4px solid white;\n                                    position: absolute;\n                                    left: -4px;\n                                    top: -3px;\n                                    z-index: -1;\n\n                                    @include tablet-only {\n                                        width: 104%;\n                                    }\n\n                                    @include small-desktop-only {\n\n                                        width: 103%;\n                                    }\n                                \n                                    @include desktop-only {\n\n                                        width: 104%;\n                                    }\n                                }\n                            }\n                        }\n    \n                        .mana {\n    \n                            flex-basis: 40%;\n                            display: flex;\n                            flex-wrap: wrap;\n    \n                            .points {\n\n                                flex-basis: 100%;\n                                font-size: 10px;\n\n                                @include tablet-only {\n\n                                    font-size: 20px;   \n                                }\n                            }\n    \n                            .bar {\n\n                                flex-basis: 100%;\n                                height: 15px;\n                                border-radius: 15px;\n                                background: linear-gradient(90deg, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%);\n                                border: 2px solid black;\n                                position: relative;\n    \n                                &::after {\n\n                                    content: \"\";\n                                    width: 109%;\n                                    height: 17px;\n                                    border-radius: 15px;\n                                    border: 4px solid white;\n                                    position: absolute;\n                                    left: -4px;\n                                    top: -3px;\n                                    z-index: -1;\n  \n                                    @include tablet-only {\n\n                                        width: 104%;       \n                                    }\n\n                                    @include small-desktop-only {\n\n                                        width: 103%;\n                                    }\n                                \n                                    @include desktop-only {\n                                        \n                                        width: 104%;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".two {\n\n    .jrpgstat {\n\n        .body {\n\n            .stats{\n\n                .skills {\n\n                    h3 {\n\n                        width: 210px;\n                        display: flex;\n                        justify-content: center;\n\n                        @include small-desktop-only {\n\n                            width: 230px;\n                        }\n\n                        @include desktop-only {\n    \n                            width: 285px;\n                        }\n\n                        &::before {\n\n                            content: \"\";\n                            width: 210px;\n                            height: 30px;\n                            position: absolute;\n                            background: $neutral_color;\n                            border-radius: 25px;\n                            opacity: 0.7;\n                            z-index: -1;\n                            left: 3%;\n                            top:-6px;\n\n                            @include tablet-only {\n\n                                left: 6%;\n                            }\n\n                            @include small-desktop-only {\n\n                                left: 12%;\n                            }\n    \n                            @include desktop-only {\n    \n                                width: 285px;\n                                top:-4px;\n                                left: 7%;\n                            }\n                        }\n                    }\n\n                    .capacities {\n\n                        height: 100%;\n                        display: flex;\n                        flex-wrap: wrap;\n                        justify-content: space-evenly;\n                        align-items: center;\n\n                        @include tablet-only {\n\n                            height: 90%;   \n \n                        }\n                    \n                        @include desktop-only {\n\n                            height: 90%;\n                        }\n\n                        .capacity {\n\n                            position: relative;\n                            flex-basis: 45%;\n                            border-radius: 5px;\n                            padding: 2px 0px 2px 15px;\n                            display: flex;\n                            color: #FFF;\n                            font-weight: bold;\n\n                            @include tablet-only {\n\n                                margin-bottom: 9px;\n                            }\n\n                            @include desktop-only {\n\n                                margin-bottom: 0;\n                            }\n\n                            &.active {\n\n                                color: #000;\n                            }\n                            \n                            &::before {\n\n                                content: \"\";\n                                position: absolute;\n                                left: 0;\n                                top: 0;\n                                width: 100%;\n                                height: 100%;\n                                background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(94,94,94,1) 100%);\n                                border: 1px solid black;\n                                border-radius: 5px;\n                                padding: 2px 0px 2px 15px;\n                            }\n\n                            &.active::before{\n\n                                border: 2px solid #fff;\n                                background: linear-gradient(0deg, rgba(74,74,74,1) 0%, rgba(185,185,185,1) 100%);\n                            }\n\n                            img {\n\n                                height: 20px;\n                                margin-left: -7% ;\n                                position: relative;\n                                z-index: 1;\n\n                                @include tablet-only {\n        \n                                    height: 30px;\n                                    margin-left: -3% ;\n                                }\n                            \n                                @include small-desktop-only {\n\n                                    margin-left: -1%;\n                                }\n                            }\n\n                            .valueName {\n\n                                position: relative;\n                                margin-top: auto;\n                                margin-bottom: auto;\n                                top: 0;\n                                bottom: 0;\n                                margin-left: 2px;\n                                font-size: 11px;\n\n                                @include tablet-only {\n        \n                                    font-size: 15px;\n                                    margin-left: 15px;\n                                }\n                            }\n\n                            \n                            .bar {\n\n                                position: relative;\n                                margin-top: auto;\n                                margin-bottom: auto;\n                                margin-left: auto;\n                                top: 0;\n                                bottom: 0;\n                                right: 19%;\n                                z-index: 2;\n                                flex-basis: 30%;\n                                height: 12px;\n                                border-radius: 15px;\n                                background: rgba(74,74,74,1);\n                                border: 2px solid #fff;\n\n                                @include tablet-only {\n                                    right: 22%;       \n                                }\n\n                                &::before {\n\n                                    content: \"\";\n                                    position: absolute;\n                                    top: 0;\n                                    left: 0;\n                                    z-index: 2;\n                                    width: 100%;\n                                    height: 100%;\n                                    border-radius: 15px;\n                                    border: 1px solid #000;\n                                }\n\n                                &::after {\n\n                                    content: \"\";\n                                    position: absolute;\n                                    top: 0;\n                                    left: 0;\n                                    z-index: 1;\n                                    width: 100%;\n                                    height: 100%;\n                                    border-radius: 15px;\n                                    background: linear-gradient(90deg, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%);\n                                    transform-origin: left center;\n                                }\n\n                                &.zero {\n\n                                    &::after {\n                                    transform: scaleX(0);\n                                    }\n                                }\n\n                                &.five {\n                                    \n                                    &::after {\n                                    transform: scaleX(0.2);\n                                    }\n                                }\n\n                                &.ten {\n\n                                    &::after {\n                                    transform: scaleX(0.4);\n                                    }\n                                }\n\n                                &.fiveteen {\n\n                                    &::after {\n                                    transform: scaleX(0.6);\n                                    }\n                                }\n\n                                &.twenty {\n\n                                    &::after {\n                                    transform: scaleX(0.8);\n                                    }\n                                }\n\n                                &.twentyfive {\n\n                                    &::after {\n                                    transform: scaleX(1);\n                                    }\n                                }\n\n                            }\n\n                            .value {\n\n                                position: absolute;\n                                margin-right: 2%;\n                                top: 25%;\n                                right: 0;\n                                font-size: 8px;\n\n                                @include tablet-only {\n\n                                    font-size: 15px;       \n                                }\n                            }\n\n                            &.empty::before {\n                                \n                                background: none;\n                                border: none;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".two {\n    \n    .jrpgstat {\n\n        .body {\n\n            .equipment{\n\n                flex-basis: 100%;\n                font-size: 10px;\n                margin-top: 10%;\n\n                @include tablet-only {\n        \n                    margin-top: 5%;\n                    font-size: 14px;\n                }\n            \n                @include desktop-only {\n\n                    flex-basis: 40%;\n                    margin-top: 0;\n                    font-size: 13px;\n                }\n\n\n                h3 {\n\n                    width: 330px;\n                    display: flex;\n                    justify-content: center;\n                    flex-basis: 100%;\n                    margin: 0 0 15px 0;\n\n                    @include desktop-only {\n\n                        margin: 20px 0 20px 7%;\n                    }\n\n                    &::before {\n\n                        content: \"\";\n                        width: 293px;\n                        height: 30px;\n                        position: absolute;\n                        background: $neutral_color;\n                        border-radius: 25px;\n                        opacity: 0.7;\n                        z-index: -1;\n                        left: 8%;\n                        top:-6px;\n\n                        @include tablet-only {\n\n                            left: 9%;\n                        }\n\n                        @include small-desktop-only {\n\n                            left: 11%;\n                        }\n\n                        @include desktop-only {\n\n                            left: 8%;\n                            width: 320px;\n                            top:-4px;\n                        }\n                    }\n\n                    &.smallBack{\n\n                        width: 92px;\n                        \n                        @include desktop-only {\n\n                            width: 102px;\n                        }\n                    \n                        &::before {\n\n                            width: 90px;\n                            left: 8%;\n\n                            @include tablet-only {\n\n                                left: 14%;\n                            }\n\n                            @include small-desktop-only {\n\n                                left: 20%;\n                            }\n\n                            @include desktop-only {\n\n                                width: 92px;\n                                left: 22%;\n                            }\n                        }\n                    }\n                }\n\n                .weapons {\n\n                    width: 100%;\n                    position: relative;\n                    margin-left: auto;\n                    margin-right: auto;\n                    left: 0;\n                    right: 0;\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: space-around;\n                    font-family: \"Overpass\";\n\n                    @include desktop-only {\n\n                        width: 90%;\n                    }\n\n                    .weapon {\n\n                        margin: 10px 0 10px 0;\n                        flex-basis: 90%;\n                        height: 50px;\n                        border-radius: 5px;\n                        padding: 2px 0px 2px 2px;\n                        position: relative;\n                        display: flex;\n                        align-items: center;\n                        cursor: pointer;\n\n                        &::before {\n\n                            content: \"\";\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n                            width: 100%;\n                            height: 100%;\n                            background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(94,94,94,1) 100%);\n                            border: 1px solid black;\n                            border-radius: 5px;\n                            padding: 2px 0px 2px 15px;\n                        }\n\n                        &.active::before{\n\n                            border: 2px solid #fff;\n                            background: linear-gradient(0deg, rgba(74,74,74,1) 0%, rgba(185,185,185,1) 100%);\n                        }\n\n                        .value {\n\n                            position: relative;\n                            z-index: 2;\n                            font-weight: bold;\n                            color: #fff;\n                            padding-left: 7px;\n                            display: inline-block;\n\n                            @include tablet-only {\n\n                                padding-left: 15px;\n                            }\n                        }\n\n                        &.active .value {\n\n                            color: #000;\n                        }\n\n                        img {\n                            \n                            height: 40px;\n                            position: relative;\n                            z-index: 1;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".two {\n    \n    .jrpgstat {\n\n        .body {\n\n            .stats{\n\n                .skills {\n\n                    flex-basis: 100%;\n                    height: 60%;\n                }\n            }\n\n            .caracter{\n\n                display: none;\n            \n                @include desktop-only {\n                    \n                    display: block;\n                    flex-basis: 20%;\n                    -o-object-fit: cover;\n                       object-fit: cover;\n                       height: 100%;\n                }\n\n                img {\n                    \n                    width: 100%;\n                }\n            }\n        }\n    }\n}",".two {\n    \n    .jrpgstat {\n\n        .footer {\n\n            .others {\n\n                flex-basis: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                margin-right: 5%;\n\n                @include desktop-only {\n\n                    flex-basis: 35%;\n                    justify-content: space-around;\n                    margin-right: 0;\n                }\n\n                h3 {\n                    position: relative;\n                    width: 200px;\n                    display: flex;\n                    justify-content: center;\n            \n                    &::after {\n\n                        width: 100%;\n                        left: 5%;\n                    }\n                \n                    @include desktop-only {\n\n                        width: 230px;\n                        left: 10%;\n                    }\n\n                    &::before {\n\n                        content: \"\";\n                        width: 180px;\n                        height: 30px;\n                        position: absolute;\n                        background: $neutral_color;\n                        border-radius: 25px;\n                        opacity: 0.7;\n                        z-index: -1;\n                        left: 7%;\n\n                        top:-6px;\n\n                        @include tablet-only {\n\n                            left: 11%;\n                        }\n\n                        @include small-desktop-only {\n\n                            left: 14%;\n                        }\n\n                        @include desktop-only {\n\n                            width: 220px;\n                            top:-4px;\n                            left: 10%;\n                        }\n                    }\n                }\n\n                .other {\n\n                    flex-basis: 33%;\n                    display: flex;\n                    justify-content: space-between;\n                    margin-left: 0%;\n                \n                    @include desktop-only {\n\n                        margin-left: 10%;\n                        flex-basis: 27%;\n                    }\n\n                    img {\n                        \n                        margin-left: 10px;\n                        height: 25px;\n\n                        @include tablet-only {\n\n                            margin-left: 25px;\n                            height: 50px;\n                        }\n                    \n                        @include desktop-only {\n\n                            height: 50px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".four {\n    \n    .form {\n\n        display: flex;\n        width: 100%;\n        min-height: 100vh;\n        font-family: \"Roboto\";\n        color: $tertiary_color;\n        font-weight: bolder;\n        position: relative;\n\n        label {\n\n            font-size: 15px;\n\n            @include tablet-only {\n   \n                font-size: 20px;\n            }\n\n            @include desktop-only {\n\n                font-size: 20px;\n            }\n        }\n\n        .name, .email, .request {\n\n            display: flex;\n            flex-wrap: wrap;\n\n            @include desktop-only {\n\n                display: block;\n                flex-wrap: nowrap;\n            }\n        }\n\n        input {\n\n            background: none;\n            border: none;\n            border-bottom: 4px solid $tertiary_color;\n            font-size: 15px;\n\n            @include tablet-only {\n                \n                font-size: 25px;\n            }\n\n            @include desktop-only {\n\n                font-size: 25px;\n            }\n\n            &:focus {\n\n                outline: none;\n                border-bottom: 4px solid $secondary_color;\n                background-color: #ffffff33;\n            }\n        }\n\n        height: 100%;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n\n        h2 {\n\n            height: 20%;\n            flex-basis: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            font-size: 40px;\n            margin-top: 45px;\n\n            @include tablet-only {\n   \n                font-size: 70px;\n                margin-top: -30px;\n            }\n\n            @include desktop-only {\n                margin-top: 0;\n                font-size: 70px;\n            }\n        }\n\n        p {\n\n            flex-basis: 80%;\n            display: flex;\n            justify-content: center;\n            font-size: 15px;\n            margin-bottom: 40px;\n\n            @include tablet-only {\n   \n                font-size: 22px;\n            }\n\n            @include desktop-only {\n\n                font-size: 33px;\n                margin-bottom: 0;\n            }\n        }\n\n        .formInputs {\n\n            flex-basis: 90%;\n            height: 50%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            align-items: center;\n\n            .error {\n\n                font-size: 13px;\n                position: absolute;\n                bottom: -20px;\n                left: 0;\n\n                @include tablet-only {\n        \n                    font-size: 17px;\n                    bottom: -4%;\n                }\n\n                @include small-desktop-only {\n    \n                    bottom: -22%;\n                }\n    \n                @include desktop-only {\n\n                    bottom: 10%;\n                    left: 50%;\n                    font-size: 18px;\n                }\n\n                &.requestArea {\n                    bottom: -6%;\n                    left: 0;\n \n\n                    @include tablet-only {\n                        \n                        bottom: -7%;\n                    }\n        \n                    @include desktop-only {\n\n                        bottom: -15%;\n                    }\n                }\n            }\n\n            .name, .email {\n\n                position: relative;\n                height: 20%;\n                display: flex;\n                flex-basis: 100%;\n                margin-bottom: 35px;\n\n                @include small-desktop-only {\n    \n                    flex-basis: 48%;\n                }\n                \n    \n                @include desktop-only {\n\n                    margin-bottom: 0;\n                    flex-basis: 45%;\n                }\n\n                input {\n\n                    height: 50px;\n                    flex-basis: 100%;\n                    cursor:pointer;\n                    padding-left: 15px;\n\n                    &focus {\n\n                        cursor:pointer;\n                    }\n        \n                    @include desktop-only {\n\n                        flex-basis: 80%;\n                    }\n                }\n            }\n\n            .request {\n\n                position: relative;\n                flex-basis: 100%;\n                display: flex;\n\n                label {\n\n                    flex-basis: 100%;\n\n                    @include desktop-only {\n\n                        flex-basis: 10%;\n                    }\n                }\n\n                textarea {\n\n                    font-size: 15px;\n                    background: none;\n                    height: 300px;\n                    flex-basis: 100%;\n                    border: 4px solid $tertiary_color;\n                    vertical-align: sub;\n                    padding: 15px;\n                    resize: none;\n                    cursor: pointer;\n                    margin-top: 5px;\n\n                    @include tablet-only {\n       \n                        font-size: 25px;\n                    }\n        \n                    @include desktop-only {\n\n                        flex-basis: 90%;\n                        margin-top: 0;\n                        font-size: 25px;\n                    }\n                    \n                    &:focus {\n\n                        outline: none;\n                        border: 4px solid $secondary_color;\n                        background-color: #ffffff33;\n                    }\n\n\n                }\n            }\n            .button-form {\n\n                flex-basis: 100%;\n                display: flex;\n                justify-content: flex-end;\n\n                button {\n\n                    flex-basis: 40%;\n                    background: none;\n                    border: 4px solid $tertiary_color;\n                    font-family: \"Roboto\";\n                    font-weight: bolder;\n                    font-size: 15px;\n                    height: 50px;\n                    color: $tertiary_color;\n                    margin-top: 25px;\n                    margin-bottom: 40px;\n                    padding: 10px;\n                    position: relative;\n                    overflow: hidden;\n                    cursor: pointer;\n                    z-index: 1;\n        \n                    @include desktop-only {\n\n                        flex-basis: 20%;\n                        font-size: 20px;\n                        margin-bottom: 0;\n                    }\n\n                    &:hover {\n\n                        color: $neutral_color;\n                        &::after{\n                            opacity: 1;\n                            transform: scale(2, 6) ;\n                        }\n                    }\n                \n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        top: 0;\n                        right: 0;\n                        bottom: 0;\n                        left: 0;\n                        background: linear-gradient(to right, darken($tertiary-color, 10%), darken($secondary-color,10%));\n                        opacity: 0;\n                        z-index: -1; \n                        transform: scale(0, 0) rotate(90deg);\n                        transition: all 1000ms;\n                    }\n                }\n            }\n        }\n\n        .response {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            &::before{\n\n                content: \"\";\n                position: fixed;\n                top: 0;\n                left: 0;\n                z-index: 50;\n                opacity: 0.5;\n                background: #000;\n                width: 100%;\n                height: 100%;\n\n            }\n\n            .window {\n\n                position: fixed;\n                width: 350px;\n                height: 180px;\n                margin-left: auto;\n                margin-right: auto;\n                margin-top: auto;\n                margin-bottom: auto;\n                left: 0;\n                right: 0;\n                top: 0;\n                bottom: 0;\n                z-index: 51;\n                background: $primary-color;\n                border: 4px solid $tertiary-color;\n                display: flex;\n                flex-wrap: wrap;\n\n                @include tablet-only {\n   \n                    height: 200px;\n                    width: 400px;\n                }\n    \n                @include desktop-only {\n    \n                    height: 200px;\n                    width: 400px;\n                }\n                \n\n                .text {\n\n                    color: $tertiary-color;\n                    flex-basis: 100%;\n                    display: flex;\n                    justify-content: center;\n                    padding-top: 70px;\n                }\n\n                button {\n\n                    position: absolute;\n                    bottom: 10px;\n                    right: 10px;\n                    width: 100px;\n                    height: 40px;\n                    border: none;\n                    border: 2px solid $tertiary-color;\n                    color: $tertiary-color;\n                    background: $primary-color;\n                    font-weight: bolder;\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n}",".five {\n\n    font-size: 35px;\n    font-weight: lighter;\n    color: $tertiary_color;\n    font-family: \"Bahnschrift\";\n\n    @include desktop-only {\n\n        right: 2%;\n        top: 15px;\n    }\n\n    .menu {\n\n        padding-top: 5%;\n        position: relative;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-around;\n        background: $neutral_color;\n        z-index: 20;\n\n        .menuSection {\n\n            flex-basis: 100%;\n            display: flex;\n            justify-content: space-around;\n            flex-wrap: wrap;\n            margin-top: 2%;\n    \n            @include desktop-only {\n    \n                flex-basis: 50%;\n            }\n\n        }\n\n        span {\n\n            display: block;\n            margin-bottom: 20px;\n            font-size: 20px;\n            padding-left: 20px;\n            font-weight: bold;\n            flex-basis: 100%;\n    \n            @include desktop-only {\n                font-size: 35px;\n                flex-basis: 50%;\n                padding-left: 0;\n            }\n        }\n\n        .copyright {\n\n            flex-basis: 100%;\n            display: flex;\n            justify-content: center;\n            margin-top: 4%;\n            \n            span {\n                display: flex;\n                justify-content: center;\n                font-size: 15px;\n        \n                @include desktop-only {\n    \n                    font-size: 25px;\n                }\n            }\n        }\n    \n        ul {\n\n            list-style: none;\n            margin-left: 15px;\n    \n            li {\n    \n                margin-bottom: 20px;\n    \n                a {\n\n                    position: relative;\n                    color: $tertiary_color;\n                    font-size: 20px;\n            \n                    @include desktop-only {\n\n                        font-size: 25px;\n                    }\n        \n    \n                    &::after {\n\n                        content: '';\n                        position: absolute;\n                        width: 100%;\n                        transform: scaleX(0);\n                        height: 2px;\n                        bottom: -10px;\n                        left: 0;\n                        background-color: $tertiary_color;\n                        transform-origin: top right;\n                        transition: transform 0.6s ease-out;\n                    }\n    \n                    &:hover::after {\n\n                        transform: scaleX(1);\n                    }\n    \n                    &::before {\n\n                        content: '';\n                        position: absolute;\n                        width: 100%;\n                        transform: scaleX(0);\n                        height: 2px;\n                        top: -11px;\n                        left: 0;\n                        background-color: $tertiary_color;\n                        transform-origin: bottom left;\n                        transition: transform 0.6s ease-out;\n                    }\n    \n                    &:hover::before {\n\n                        transform: scaleX(1);\n                    } \n                }\n            }\n    \n            .reversed {\n                a {\n                    &::after {\n\n                        transform-origin: bottom left;\n                    }\n    \n                    &::before {\n\n                        transform-origin: top right;\n                    }\n                }\n            }\n        }\n    \n        ul.lang {\n\n            display: flex;\n            font-weight: bold;\n            justify-content: space-around;\n            flex-basis: 100%;\n\n    \n            li {\n\n                cursor: pointer;\n                font-size: 15px;\n                color: $tertiary_color;\n        \n                @include desktop-only {\n\n                    font-size: 20px;\n                }\n            }\n    \n            li.activated {\n\n                color: $secondary_color;\n                text-decoration: overline;\n            }\n        }\n    }\n\n    .sousMenu {\n\n        margin-left: 25px;\n        position: relative;\n\n        &::before {\n            \n            content: \"\";\n            width: 10px;\n            height: 10px;\n            border-left: 2px solid $tertiary_color;\n            border-bottom: 2px solid $tertiary_color;\n            position: absolute;\n            left: -15px;\n            top: 10px;\n        }\n    }\n\n    .logo {\n\n        color: $primary-color;\n        font-size: 25px;\n        margin-top: 15px;\n        height: 160px;\n        position: relative;\n        margin-left: auto;\n        margin-right: auto;\n        width: 228px;\n\n        @include desktop-only {\n\n            width: 325px;\n            font-size: 37px;\n        }\n\n        .image {\n\n            width: 70px;\n            height: 70px;\n            position: relative;\n            left: 40%;\n            margin-bottom: 5px;\n\n            &::before {\n\n                content: \"\";\n                position: absolute;\n                top: 62px;\n                left: -52px;\n                width: 55px;\n                height: 3px;\n                background: $primary-color;\n            }\n\n            &::after {\n\n                content: \"\";\n                position: absolute;\n                top: 62px;\n                left: 60px;\n                width: 55px;\n                height: 3px;\n                background: $primary-color;\n            }\n        }\n\n        .text {\n\n            position: relative;\n\n            .name {\n\n                font-family: \"BrunoAce\";\n                flex-basis: 100%;\n    \n                &::before {\n\n                    content: \"\";\n                    width: 250px;\n                    height: 3px;\n                    background: $primary-color;\n                    position: absolute;\n                    top: 0px;\n                    left: -12px;\n            \n                    @include desktop-only {\n\n                        width: 350px;\n                    }\n                }\n            }\n    \n            .function {\n\n                font-stretch: condensed;\n                font-weight: 100;\n                position: absolute;\n                top: 27px;\n                width: 228px;\n                display: flex;\n                justify-content: center;\n        \n                @include desktop-only {\n                    width: 325px;\n                    top: 37px;\n                }\n            }\n        }\n    }\n}",".lapantherePresentation {\n\n    color: $primary-color;\n    display: flex;\n    flex-wrap: wrap;\n\n    h1 {\n        \n        color: $secondary-color;\n        font-size: 40px;\n        flex-basis: 100%;\n        display: flex;\n        justify-content: center;\n        margin-top: 20px;\n\n        @include tablet-only {\n\n            font-size: 50px;\n        }\n        \n        @include desktop-only {\n        \n            font-size: 70px;\n            margin-top: 0;\n        }\n\n    }\n\n    h2 {\n\n        margin-bottom: 15px;\n    }\n\n    .back {\n\n        position: relative;\n        flex-basis: 80%;\n        margin-top: 20px;\n\n        a {\n            color: $tertiary-color;\n            font-size: 15px;\n\n            @include tablet-only {\n\n            }\n            \n            @include desktop-only {\n            \n                font-size: 20px;\n            }\n\n            .arrow {\n\n                width: 15px;\n                height: 15px;\n                border-top: 3px solid $tertiary-color;\n                border-left: 3px solid $tertiary-color;\n                transform: rotate(-45deg);\n                position: absolute;\n                top: 1px;\n                left: -15px;\n\n                @include tablet-only {\n\n                }\n                \n                @include desktop-only {\n                \n                    top:3px;\n                }\n            }\n        }\n    }\n\n    p {\n\n        margin: 25px;\n        font-size: 18px;\n\n        @include tablet-only {\n\n        }\n        \n        @include desktop-only {\n        \n            margin: 70px;\n            font-size: 25px;\n        }\n    }\n\n    .avant, .apres {\n\n        flex-basis: 100%;\n        margin-bottom: 20px;\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n\n        @include tablet-only {\n\n        }\n        \n        @include desktop-only {\n        \n            flex-basis: 30%;\n            margin-bottom: 0;\n        }\n\n        img {\n\n            max-width: 500px;\n            width: 100%;\n\n            @include tablet-only {\n\n            }\n            \n            @include desktop-only {\n            \n                width: 100%;\n            }\n        }\n    }\n\n    .rapport {\n\n        flex-basis: 100%;\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        margin-top: 40px;\n\n        h2 {\n            flex-basis: 100%;\n            display: flex;\n            justify-content: center;\n        }\n\n        a {\n\n            color: $tertiary-color;\n            font-size: 20px;\n        }\n    }\n}",".administration {\n\n    margin-top: 50px;\n    padding: 15px 0 50px 0;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: $tertiary_color;\n    border: 2px solid $tertiary_color;\n    border-radius: 15px;\n    position: relative;\n\n    input[type=\"text\"]{\n    height: 35px;\n    background-color: transparent;\n    border: 2px solid $tertiary_color;\n    border-radius: 10px;\n    color: $tertiary_color;\n    font-size: 1rem;\n    padding-left: 5px;\n\n        &:focus{\n            outline: none;\n        }\n    }\n\n    .textarea {\n        resize: none;\n        font-family: \"Bahnschrift\";\n        background-color: transparent;\n        border: 2px solid $tertiary_color;\n        border-radius: 10px;\n        color: $tertiary_color;\n        padding-left: 5px;\n        padding-top: 5px;\n        font-size: 1.2rem;\n        font-weight: 100;\n\n        &:focus{\n            outline: none;\n        }\n    }\n\n    .text-description {\n        height: 250px;\n    }\n\n    .text-technologies {\n        height: 150px;\n    }\n\n    .admin-categories {\n\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 30px;\n        width: 100%;\n\n    }\n        \n    .admin-panel{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 90%;\n        background-color: $neutral_color;\n        min-height: 50px;\n        border-radius: 15px;\n        margin: 10px 0;\n        border: 2px solid $tertiary_color;\n        padding-top: 10px;\n        position: relative;\n\n        h2 {\n            margin-bottom: 10px;;\n        }\n\n        .presentation{\n            display: flex;\n            flex-direction: row;\n            margin: 20px;\n\n            .presentation-text{\n\n                background-color: transparent;\n                border-radius: 15px;\n                padding: 15px;\n                margin: 10px;\n                width: 33%;\n                border: 2px solid $tertiary_color;\n\n                h4 {\n                    margin-bottom: 10px;\n\n                }\n            }\n        }\n    }\n\n    .contact-message{\n        min-width: 670px;\n        height: 450px;\n        border-radius: 15px;\n        padding: 15px;\n        border: 2px solid $tertiary_color;\n        font-size: 1.2rem;\n        margin-left: 15px;\n        margin-bottom: 10px;\n\n        .message-field{\n            height: 230px;\n            overflow-y: scroll;\n        }\n    }\n\n    .no-new-message{\n        display: flex;\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n        height: 150px;\n        font-size: 2rem;\n    }\n\n    .contact-sub-panel{\n        display: flex;\n        flex-direction: row;\n        width: 90%;\n        border: 2px solid $tertiary_color;\n        border-radius: 15px;\n        padding: 10px 0 10px 0;\n        margin: 10px;\n        overflow-x: scroll;\n    }\n\n    .devStat-list{\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        width: 100%;\n    }\n\n    .devStat{\n        width: 20%;\n        background-color: transparent;\n        border-radius: 10px;\n        min-width: 300px;\n        margin: 10px;\n        padding-left: 10px;\n        padding-right: 10px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        color: $tertiary_color;\n        border: 2px solid $tertiary_color;\n        cursor: pointer;\n\n        .index-image{\n            display: flex;\n            align-items: center;    \n        }\n\n        &.selected{\n            background-color: $tertiary_color;\n            color: $neutral_color;\n        }\n\n        &.newSelected{\n            background-color: greenyellow;\n            color: $neutral_color;\n        }\n    }\n\n    .weapon-container {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    }\n\n    .weapon{\n        width: 90%;\n        background-color: transparent;\n        border-radius: 10px;\n        min-width: 300px;\n        margin: 10px 0 10px 0;\n        height: 100px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        color: $tertiary_color;\n        border: 2px solid $tertiary_color;\n        padding: 10px;\n        cursor: pointer;\n\n        .index-image{\n            display: flex;\n            align-items: center;    \n        }\n\n        &.selected{\n            background-color: $tertiary_color;\n            color: $neutral_color;\n        }\n\n        &.newSelected{\n            background-color: greenyellow;\n            color: $neutral_color;\n        }\n    }\n\n    .weapon-box {\n        display: flex;\n        flex-direction: row;\n    }\n\n    .weapon-list{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 70%;\n        border: 2px solid $tertiary_color;\n        border-radius: 10px;\n        overflow-y: scroll;\n        height: 525px;\n    }\n\n    .weapon-options{\n        margin-left: 10px;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        width: 30%;\n        align-items: center;\n        justify-content: flex-start;\n        height: 300px;\n\n        div {\n            width: 90%;\n            display: flex;\n            justify-content: space-between;\n\n            label {\n                padding-top: 10px;\n            }\n        }\n\n        input[type=\"text\"]{\n\n            width: 270px;\n        }\n    }\n\n    .admin-sub-panel{\n        display: flex;\n        flex-direction: column;\n        width: 90%;\n        border: 2px solid $tertiary_color;\n        border-radius: 15px;\n        padding: 10px;\n        margin: 10px;\n    }\n\n\n    .project-list{\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        width: 100%;\n        overflow-x: scroll;\n\n        .project{\n            background-color: transparent;\n            border-radius: 10px;\n            min-width: 400px;\n            margin: 15px;\n            height: 350px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            color: $tertiary_color;\n            border: 2px solid $tertiary_color;\n            cursor: pointer;\n\n            .project-title{\n                font-size: 1.2rem;\n                font-weight: bold;\n                margin-bottom: 15px;\n            }\n\n            .project-description{\n                font-size: 1.1rem;\n                margin-bottom: 15px;\n            }\n\n            &.selected{\n                background-color: $tertiary_color;\n                color: $neutral_color;\n            }\n\n            &.newSelected{\n                background-color: greenyellow;\n                color: $neutral_color;\n            }\n        }\n    }\n\n    .project-option{\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n    }\n\n    .project-sub-option {\n        width: 48%;\n        margin-left: 1%;\n        display: flex;\n        \n        flex-direction: column;\n    }\n\n    .photo-field{\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    .photo-option-presentation{\n        display: flex;\n        flex-direction: column;\n\n        label{\n            margin-top: 5px;\n            margin-bottom: 5px;\n        }\n\n        img{\n            width: 200px;\n            margin-bottom: 5px;\n        }\n    }\n\n    .photo-option {\n        .button-field{\n            margin-top: 5px;\n            margin-bottom: 5px;\n            margin-left: 0;\n\n            button{\n                margin-left: 0;\n                margin-right: 5px;\n                width: 110px;\n            }\n        }\n    }\n\n    .openClose, .openCloseClose {\n        font-size: 2rem;\n        cursor: pointer;\n        position: absolute;\n        right: 25px;\n        top: 5px;\n    }\n\n    .openClose {\n        rotate: -90deg;\n    }\n\n    .openCloseClose {\n        rotate: 90deg;\n    }\n\n    .button-field {\n        width: 100%;\n        margin: 20px;\n\n        button {\n            margin-left: 15px;\n        }\n    }\n\n    .option-field {\n        margin: 20px;\n        position: relative;\n\n        img {\n            position: absolute;\n            top: 2px;\n            left: -20px;\n        }\n\n        .textfield {\n            margin-left: 15px;\n            border: 2px solid $tertiary_color;\n            background-color: transparent;\n            height: 35px;\n            width: 250px;\n            border-radius: 10px;\n            color: $tertiary_color;\n            font-size: 1.2rem;\n            font-weight: bold;\n            padding-left: 10px;\n\n            &:focus {\n                outline: none;\n\n            }\n        }\n\n        .numberfield {\n            margin-left: 15px;\n            height: 35px;\n            padding-left:10px ;\n            padding-right: 5px;\n            background-color: transparent;\n            border: 2px solid $tertiary_color;\n            color: $tertiary_color;\n            font-size: 1.2rem;\n            border-radius: 10px;\n\n            &:focus {\n                outline: none;\n\n            }\n        }\n\n        .filefield {\n            margin-left: 15px;\n            height: 35px;\n            padding-left:10px ;\n            padding-right: 5px;\n            background-color: transparent;\n            color: $tertiary_color;\n            font-size: 1.2rem;\n            border-radius: 10px;\n\n\n        }\n    }\n\n    input::file-selector-button {\n        height: 35px;\n        background-color: transparent;\n        border: 2px solid $tertiary_color;\n        color: $tertiary_color;\n        font-size: 1.2rem;\n        border-radius: 10px;\n        cursor: pointer;\n\n        &:hover{\n            background-color: $tertiary_color;\n            color: $neutral_color;\n        }\n    }\n\n    .language-selector{\n        display: flex;\n        flex-direction: row;\n\n        .language{\n            cursor: pointer;\n        }\n    }\n}\n\n.button-alert{\n    cursor: pointer;\n    width: 150px;\n    height: 50px;\n    border: 2px solid $tertiary_color;\n    border-radius: 10px;\n    background-color: transparent;\n    color: $tertiary_color;\n    font-family:\"Bahnschrift\";\n    font-size: 1.2rem;\n    \n    &:hover {\n        background-color: $tertiary_color;\n        color: $neutral_color;\n        \n    }\n\n    &.delete {\n        background-color: rgb(185, 49, 49);\n        color: $neutral_color;\n\n        &:hover {\n        background-color: rgb(255, 104, 104);\n        color: $neutral_alt_color;\n        }\n    }\n}\n\n.admin-navigation{\n    display: flex;\n    flex-direction: row;\n    position: absolute;\n    top: 15px;\n    left: 15px;\n    \n    &-button{\n        margin-right: 10px;\n        margin-left: 10px;\n        cursor: pointer;\n        color: $tertiary_color;\n\n        &:hover{\n            text-decoration: underline;\n        }\n    }\n}\n\nselect{\n    cursor: pointer;\n}\n\noption{\n    background-color: $neutral_color;\n}\n\n.top{\n    rotate: 90deg;\n}\n\n.bottom{\n    rotate: -90deg;\n}\n\n.devstat-selector{\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    width: 100%;\n\n    & .devstat-input{\n        width: 30% !important;\n    }\n}\n",".empty-alert-box {\n    display: none;\n}\n\n.alert-box{\n\n        position: absolute;\n        display: inline-block;\n        top: 0;\n        left: 0;\n        opacity: 1;\n        width: 100%;\n        height: 100%;\n        font-family: \"Bahnschrift\";\n\n    &::before{\n\n        content: \"\";\n        display: block;\n        width: 100%;\n        height: 100%;\n        font-size: 1.2rem;\n        text-align: center;\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: 10;\n        background-color: black;\n        opacity: 0.8;\n    }\n\n    .alert-box-title {\n        padding-left: 15px;\n        padding-top: 15px;\n        font-size: 1.5rem;\n        font-weight: bold;\n    }\n\n    .alert-box-message {\n        display: flex;\n        justify-content: center;\n        margin: 20px;\n        font-size: 1.2rem;\n    }\n\n    .alert-box-buttons {\n        display: flex;\n        justify-content: center;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    &-success {\n        padding: 15px;\n        border-radius: 10px;\n        margin: 20px 0;\n        background-color: $neutral_color;\n        color: $tertiary_color;\n        border: 2px solid $tertiary_color;\n        position: sticky;\n        top: 40%;\n        left: 50%;\n        translate: -50%;\n        z-index: 11;\n        opacity: 1;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        width: 600px;\n    }\n\n    &-error {\n        padding: 15px;\n        border-radius: 10px;\n        background-color: #f8d7da;\n        color: #721c24;\n        border: 2px solid #f5c6cb;\n    }\n}\n",".cookies {\n    font-family: \"Bahnschrift\";\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    &__panel{\n        width: 700px;\n        z-index: 11;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n        padding: 30px;\n        border: 2px solid $tertiary-color;\n        border-radius: 15px;\n        background-color: $neutral_color;\n        color: $tertiary-color;\n\n        .lang-choice{\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            justify-content: flex-end;\n\n            .lang{\n                margin-left: 5px;\n                cursor: pointer;\n            }\n        }\n    }\n\n    button {\n        margin-left: 15px;\n        margin-top: 15px;\n    }\n\n    &::before{\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        position: fixed;\n        top:0;\n        left:0;\n        background-color: black;\n        opacity: 50%;\n        z-index: 10;\n    }\n}\n\n\n.cookie-button-open {\n    position: absolute;\n    font-family: \"Bahnschrift\";\n    bottom: -2px;\n    left: 10px;\n    width: 160px;\n    height: 50px;\n    color: $secondary_color;\n    background-color: $neutral_color;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 15px 15px 0 0; \n    margin-left: 20px;\n    font-weight: bold;\n    border: 2px solid $tertiary-color;\n    z-index: 10;\n\n    &:hover{\n        cursor: pointer;\n        color: $neutral_color;\n        background-color: $tertiary-color;\n        border: 2px solid $secondary_color;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
